// THIS FILE IS AUTO GENERATED
import { GenIcon } from '../lib';
export function RiProgress3Line(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24', fill: 'currentColor' }, child: [{ tag: 'path', attr: { d: 'M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM18 12C18 13.6569 17.3284 15.1569 16.2426 16.2426L12 12V6C15.3137 6 18 8.68629 18 12Z' }, child: [] }] })(props);
}

export function RiProgress4Line(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24', fill: 'currentColor' }, child: [{ tag: 'path', attr: { d: 'M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM18 12C18 15.3137 15.3137 18 12 18V6C15.3137 6 18 8.68629 18 12Z' }, child: [] }] })(props);
}

export function RiProgress5Line(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24', fill: 'currentColor' }, child: [{ tag: 'path', attr: { d: 'M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM18 12C18 15.3137 15.3137 18 12 18C10.3431 18 8.84311 17.3284 7.75732 16.2426L12 12V6C15.3137 6 18 8.68629 18 12Z' }, child: [] }] })(props);
}

export function RiProgress6Line(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24', fill: 'currentColor' }, child: [{ tag: 'path', attr: { d: 'M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM17.9998 12C17.9998 15.3137 15.3135 18 11.9998 18C8.68606 18 5.99977 15.3137 5.99977 12H11.9998V6C15.3135 6 17.9998 8.68629 17.9998 12Z' }, child: [] }] })(props);
}

export function RiProgress8Line(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24', fill: 'currentColor' }, child: [{ tag: 'path', attr: { d: 'M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18Z' }, child: [] }] })(props);
}

export function TbCode(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M7 8l-4 4l4 4' }, child: [] },
      { tag: 'path', attr: { d: 'M17 8l4 4l-4 4' }, child: [] },
      { tag: 'path', attr: { d: 'M14 4l-4 16' }, child: [] }
    ]
  })(props);
}

export function TbFileTextSpark(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M14 3v4a1 1 0 0 0 1 1h4' }, child: [] },
      { tag: 'path', attr: { d: 'M12 21h-5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v3.5' }, child: [] },
      { tag: 'path', attr: { d: 'M9 9h1' }, child: [] },
      { tag: 'path', attr: { d: 'M9 13h6' }, child: [] },
      { tag: 'path', attr: { d: 'M9 17h3' }, child: [] },
      { tag: 'path', attr: { d: 'M19 22.5a4.75 4.75 0 0 1 3.5 -3.5a4.75 4.75 0 0 1 -3.5 -3.5a4.75 4.75 0 0 1 -3.5 3.5a4.75 4.75 0 0 1 3.5 3.5' }, child: [] }
    ]
  })(props);
}

export function TbAnalyze(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M20 11a8.1 8.1 0 0 0 -6.986 -6.918a8.095 8.095 0 0 0 -8.019 3.918' }, child: [] },
      { tag: 'path', attr: { d: 'M4 13a8.1 8.1 0 0 0 15 3' }, child: [] },
      { tag: 'path', attr: { d: 'M19 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0' }, child: [] },
      { tag: 'path', attr: { d: 'M5 8m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0' }, child: [] },
      { tag: 'path', attr: { d: 'M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0' }, child: [] }
    ]
  })(props);
}

export function TbFileText(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M14 3v4a1 1 0 0 0 1 1h4' }, child: [] },
      { tag: 'path', attr: { d: 'M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z' }, child: [] },
      { tag: 'path', attr: { d: 'M9 9l1 0' }, child: [] },
      { tag: 'path', attr: { d: 'M9 13l6 0' }, child: [] },
      { tag: 'path', attr: { d: 'M9 17l6 0' }, child: [] }
    ]
  })(props);
}

export function TbFileTypePdf(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M14 3v4a1 1 0 0 0 1 1h4' }, child: [] },
      { tag: 'path', attr: { d: 'M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4' }, child: [] },
      { tag: 'path', attr: { d: 'M5 18h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6' }, child: [] },
      { tag: 'path', attr: { d: 'M17 18h2' }, child: [] },
      { tag: 'path', attr: { d: 'M20 15h-3v6' }, child: [] },
      { tag: 'path', attr: { d: 'M11 15v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-1z' }, child: [] }
    ]
  })(props);
}

export function TbReload(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M19.933 13.041a8 8 0 1 1 -9.925 -8.788c3.899 -1 7.935 1.007 9.425 4.747' }, child: [] },
      { tag: 'path', attr: { d: 'M20 4v5h-5' }, child: [] }
    ]
  })(props);
}

export function TbListDetails(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M13 5h8' }, child: [] },
      { tag: 'path', attr: { d: 'M13 9h5' }, child: [] },
      { tag: 'path', attr: { d: 'M13 15h8' }, child: [] },
      { tag: 'path', attr: { d: 'M13 19h5' }, child: [] },
      { tag: 'path', attr: { d: 'M3 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z' }, child: [] },
      { tag: 'path', attr: { d: 'M3 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z' }, child: [] }
    ]
  })(props);
}

export function TbAlertOctagon(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M12.802 2.165l5.575 2.389c.48 .206 .863 .589 1.07 1.07l2.388 5.574c.22 .512 .22 1.092 0 1.604l-2.389 5.575c-.206 .48 -.589 .863 -1.07 1.07l-5.574 2.388c-.512 .22 -1.092 .22 -1.604 0l-5.575 -2.389a2.036 2.036 0 0 1 -1.07 -1.07l-2.388 -5.574a2.036 2.036 0 0 1 0 -1.604l2.389 -5.575c.206 -.48 .589 -.863 1.07 -1.07l5.574 -2.388a2.036 2.036 0 0 1 1.604 0z' }, child: [] },
      { tag: 'path', attr: { d: 'M12 8v4' }, child: [] },
      { tag: 'path', attr: { d: 'M12 16h.01' }, child: [] }
    ]
  })(props);
}

export function TbAlertTriangle(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M12 9v4' }, child: [] },
      { tag: 'path', attr: { d: 'M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0z' }, child: [] },
      { tag: 'path', attr: { d: 'M12 16h.01' }, child: [] }
    ]
  })(props);
}

export function TbInfoCircle(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0' }, child: [] },
      { tag: 'path', attr: { d: 'M12 9h.01' }, child: [] },
      { tag: 'path', attr: { d: 'M11 12h1v4h1' }, child: [] }
    ]
  })(props);
}

export function LuAsterisk(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M12 6v12' }, child: [] },
      { tag: 'path', attr: { d: 'M17.196 9 6.804 15' }, child: [] },
      { tag: 'path', attr: { d: 'm6.804 9 10.392 6' }, child: [] }
    ]
  })(props);
}

export function LuExternalLink(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M15 3h6v6' }, child: [] },
      { tag: 'path', attr: { d: 'M10 14 21 3' }, child: [] },
      { tag: 'path', attr: { d: 'M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6' }, child: [] }
    ]
  })(props);
}

export function LuHistory(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8' }, child: [] },
      { tag: 'path', attr: { d: 'M3 3v5h5' }, child: [] },
      { tag: 'path', attr: { d: 'M12 7v5l4 2' }, child: [] }
    ]
  })(props);
}

export function GrGraphQl(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24' }, child: [{ tag: 'path', attr: { d: 'M14.3335126,2.85206923 L19.0436746,5.57156232 C19.1861408,5.42269933 19.3517561,5.29107777 19.5390336,5.18229987 C20.6054985,4.56924218 21.9657203,4.93324518 22.585164,5.99971013 C23.1982217,7.06617507 22.8342187,8.42639682 21.7677537,9.04584053 C21.5354003,9.17940894 21.2887997,9.26659782 21.038849,9.31024708 L21.038849,14.6900096 C21.2856344,14.7341019 21.5290274,14.8207365 21.7585099,14.9526546 C22.8303433,15.5715108 23.1940011,16.9304425 22.5751449,17.9958959 C21.9626686,19.0613494 20.597357,19.4250072 19.5319036,18.8125309 C19.2675499,18.6605671 19.046399,18.4622584 18.8726413,18.2336837 L14.2472483,20.9042339 C14.359389,21.1704807 14.4213527,21.4632106 14.4213527,21.770637 C14.4213527,22.997106 13.4248466,24 12.1919896,24 C10.9591327,24 9.96262662,23.0034939 9.96262662,21.770637 C9.96262662,21.5276826 10.001326,21.293907 10.0729072,21.0751276 L5.39448212,18.3739583 C5.24136397,18.5447862 5.05910975,18.6948998 4.84979559,18.8164775 C3.77694463,19.4295352 2.41672287,19.0655322 1.80366518,17.9990673 C1.19060749,16.9326023 1.55461049,15.5723806 2.62107544,14.9529369 C2.78345801,14.8595912 2.95265101,14.7888975 3.12500248,14.7398866 L3.12500248,9.26050018 C2.95045269,9.21143227 2.77917162,9.14021295 2.61500295,9.04584053 C1.548538,8.43278284 1.184535,7.06617507 1.79759269,5.99971013 C2.41065038,4.93324518 3.77725815,4.56924218 4.8437231,5.18229987 C4.99574654,5.27060092 5.13349582,5.37395472 5.25617553,5.48936462 L10.0208088,2.73842163 C9.98274768,2.57496174 9.96262662,2.40454853 9.96262662,2.22936302 C9.96262662,0.996506107 10.9591327,4.6629367e-14 12.1919896,4.6629367e-14 C13.4248466,4.6629367e-14 14.4213527,0.996506107 14.4213527,2.22936302 C14.4213527,2.44556708 14.3907061,2.6545024 14.3335126,2.85206923 Z M13.8405544,3.73141097 C13.7908242,3.78597435 13.7384158,3.8380524 13.6835353,3.88743909 L19.9624322,14.7624885 C19.9851165,14.7552188 20.0079142,14.7483109 20.0308156,14.7417672 L20.0308156,9.25474103 C19.4969015,9.10015188 19.0200076,8.74749468 18.7216233,8.22843028 C18.396599,7.66302338 18.3462063,7.01504748 18.5295247,6.43866863 L13.8405544,3.73141097 Z M10.5612952,3.75078761 C10.5290822,3.71626947 10.4979547,3.6807246 10.4679668,3.64420691 L5.81568405,6.33028239 C6.04182311,6.93281226 6.00669953,7.62728911 5.66113335,8.22843028 C5.32249418,8.81752134 4.75393127,9.19227671 4.13303588,9.30641503 L4.13303588,14.6916383 C4.16637437,14.6977154 4.19956458,14.7045461 4.23257942,14.7121233 L10.5612952,3.75078761 Z M12.8009687,4.3748119 C12.60746,4.42948073 12.403193,4.45872604 12.1919896,4.45872604 C11.9129003,4.45872604 11.645923,4.40765895 11.3998763,4.31434325 L5.14116232,15.1544358 C5.34676617,15.3211714 5.52618301,15.5275552 5.66720584,15.7703471 C5.76055152,15.9327297 5.83124515,16.1019227 5.8802561,16.2742741 L18.5020915,16.2742741 C18.5510684,16.101457 18.6218024,15.9318817 18.7152686,15.7692896 C18.8216025,15.5843129 18.950628,15.4204894 19.0968364,15.2792547 L12.8009687,4.3748119 Z M13.7498392,20.1747099 L18.4885766,17.4387184 C18.4752977,17.3870257 18.4638585,17.3348529 18.454287,17.2823075 L5.92850441,17.2823075 C5.91572246,17.3524283 5.89960649,17.4218931 5.88022341,17.4904498 L10.5957921,20.2130645 C11.0004395,19.7984186 11.5657199,19.541274 12.1919896,19.541274 C12.7987163,19.541274 13.3482006,19.7826203 13.7498392,20.1747099 Z' }, child: [] }] })(props);
}

export function MdPlaylistAdd(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'path', attr: { d: 'M14 10H3v2h11v-2zm0-4H3v2h11V6zm4 8v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zM3 16h7v-2H3v2z' }, child: [] }
    ]
  })(props);
}

export function LuCable(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M17 21v-2a1 1 0 0 1-1-1v-1a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1' }, child: [] },
      { tag: 'path', attr: { d: 'M19 15V6.5a1 1 0 0 0-7 0v11a1 1 0 0 1-7 0V9' }, child: [] },
      { tag: 'path', attr: { d: 'M21 21v-2h-4' }, child: [] },
      { tag: 'path', attr: { d: 'M3 5h4V3' }, child: [] },
      { tag: 'path', attr: { d: 'M7 5a1 1 0 0 1 1 1v1a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a1 1 0 0 1 1-1V3' }, child: [] }
    ]
  })(props);
}

export function PiCaretUpBold(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 256 256', fill: 'currentColor' }, child: [{ tag: 'path', attr: { d: 'M216.49,168.49a12,12,0,0,1-17,0L128,97,56.49,168.49a12,12,0,0,1-17-17l80-80a12,12,0,0,1,17,0l80,80A12,12,0,0,1,216.49,168.49Z' }, child: [] }] })(props);
}

export function FiPercent(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'line', attr: { x1: '19', y1: '5', x2: '5', y2: '19' }, child: [] },
      { tag: 'circle', attr: { cx: '6.5', cy: '6.5', r: '2.5' }, child: [] },
      { tag: 'circle', attr: { cx: '17.5', cy: '17.5', r: '2.5' }, child: [] }
    ]
  })(props);
}

export function FiPhone(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }, child: [{ tag: 'path', attr: { d: 'M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z' }, child: [] }] })(props);
}

export function FaServer(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 512 512' }, child: [{ tag: 'path', attr: { d: 'M64 32C28.7 32 0 60.7 0 96l0 64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64L64 32zm280 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm48 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM64 288c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64L64 288zm280 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z' }, child: [] }] })(props);
}

export function FaMarkdown(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 640 512' }, child: [{ tag: 'path', attr: { d: 'M593.8 59.1H46.2C20.7 59.1 0 79.8 0 105.2v301.5c0 25.5 20.7 46.2 46.2 46.2h547.7c25.5 0 46.2-20.7 46.1-46.1V105.2c0-25.4-20.7-46.1-46.2-46.1zM338.5 360.6H277v-120l-61.5 76.9-61.5-76.9v120H92.3V151.4h61.5l61.5 76.9 61.5-76.9h61.5v209.2zm135.3 3.1L381.5 256H443V151.4h61.5V256H566z' }, child: [] }] })(props);
}

export function LuAlignLeft(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M15 12H3' }, child: [] },
      { tag: 'path', attr: { d: 'M17 18H3' }, child: [] },
      { tag: 'path', attr: { d: 'M21 6H3' }, child: [] }
    ]
  })(props);
}

export function LuCalendarDays(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M8 2v4' }, child: [] },
      { tag: 'path', attr: { d: 'M16 2v4' }, child: [] },
      { tag: 'rect', attr: { width: '18', height: '18', x: '3', y: '4', rx: '2' }, child: [] },
      { tag: 'path', attr: { d: 'M3 10h18' }, child: [] },
      { tag: 'path', attr: { d: 'M8 14h.01' }, child: [] },
      { tag: 'path', attr: { d: 'M12 14h.01' }, child: [] },
      { tag: 'path', attr: { d: 'M16 14h.01' }, child: [] },
      { tag: 'path', attr: { d: 'M8 18h.01' }, child: [] },
      { tag: 'path', attr: { d: 'M12 18h.01' }, child: [] },
      { tag: 'path', attr: { d: 'M16 18h.01' }, child: [] }
    ]
  })(props);
}

export function LuMousePointerClick(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M14 4.1 12 6' }, child: [] },
      { tag: 'path', attr: { d: 'm5.1 8-2.9-.8' }, child: [] },
      { tag: 'path', attr: { d: 'm6 12-1.9 2' }, child: [] },
      { tag: 'path', attr: { d: 'M7.2 2.2 8 5.1' }, child: [] },
      { tag: 'path', attr: { d: 'M9.037 9.69a.498.498 0 0 1 .653-.653l11 4.5a.5.5 0 0 1-.074.949l-4.349 1.041a1 1 0 0 0-.74.739l-1.04 4.35a.5.5 0 0 1-.95.074z' }, child: [] }
    ]
  })(props);
}

export function LuWorkflow(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'rect', attr: { width: '8', height: '8', x: '3', y: '3', rx: '2' }, child: [] },
      { tag: 'path', attr: { d: 'M7 11v4a2 2 0 0 0 2 2h4' }, child: [] },
      { tag: 'rect', attr: { width: '8', height: '8', x: '13', y: '13', rx: '2' }, child: [] }
    ]
  })(props);
}

export function AiOutlineStar(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 1024 1024' }, child: [{ tag: 'path', attr: { d: 'M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3zM664.8 561.6l36.1 210.3L512 672.7 323.1 772l36.1-210.3-152.8-149L417.6 382 512 190.7 606.4 382l211.2 30.7-152.8 148.9z' }, child: [] }] })(props);
}

export function AiFillStar(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 1024 1024' }, child: [{ tag: 'path', attr: { d: 'M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z' }, child: [] }] })(props);
}

export function GrAnalytics(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24' }, child: [{ tag: 'path', attr: { fill: 'none', strokeWidth: '2', d: 'M20,7 C21.25,8.67 22,10.75 22,13 C22,18.52 17.52,23 12,23 C6.48,23 2,18.52 2,13 C2,7.48 6.48,3 12,3 M12,1 L12,13 L21.6,5.8 C19.41,2.89 15.92,1 12,1 L12,1 Z' }, child: [] }] })(props);
}

export function FaCheck(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 512 512' }, child: [{ tag: 'path', attr: { d: 'M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z' }, child: [] }] })(props);
}

export function MdErrorOutline(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0V0z' }, child: [] },
      { tag: 'path', attr: { d: 'M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' }, child: [] }
    ]
  })(props);
}

export function LuBraces(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M8 3H7a2 2 0 0 0-2 2v5a2 2 0 0 1-2 2 2 2 0 0 1 2 2v5c0 1.1.9 2 2 2h1' }, child: [] },
      { tag: 'path', attr: { d: 'M16 21h1a2 2 0 0 0 2-2v-5c0-1.1.9-2 2-2a2 2 0 0 1-2-2V5a2 2 0 0 0-2-2h-1' }, child: [] }
    ]
  })(props);
}

export function HiOutlineExternalLink(props) {
  return GenIcon({ tag: 'svg', attr: { fill: 'none', viewBox: '0 0 24 24', strokeWidth: '2', stroke: 'currentColor', 'aria-hidden': 'true' }, child: [{ tag: 'path', attr: { strokeLinecap: 'round', strokeLinejoin: 'round', d: 'M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14' }, child: [] }] })(props);
}

export function FiStopCircle(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'circle', attr: { cx: '12', cy: '12', r: '10' }, child: [] },
      { tag: 'rect', attr: { x: '9', y: '9', width: '6', height: '6' }, child: [] }
    ]
  })(props);
}

export function FiCheckSquare(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'polyline', attr: { points: '9 11 12 14 22 4' }, child: [] },
      { tag: 'path', attr: { d: 'M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11' }, child: [] }
    ]
  })(props);
}

export function FiSquare(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }, child: [{ tag: 'rect', attr: { x: '3', y: '3', width: '18', height: '18', rx: '2', ry: '2' }, child: [] }] })(props);
}

export function LiaFlaskSolid(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 32 32' }, child: [{ tag: 'path', attr: { d: 'M 17 0 C 16.449219 0 16 0.449219 16 1 C 16 1.550781 16.449219 2 17 2 C 17.550781 2 18 1.550781 18 1 C 18 0.449219 17.550781 0 17 0 Z M 14 3 C 13.449219 3 13 3.449219 13 4 L 10 4 L 10 6 L 11 6 L 11 13.65625 L 4.84375 21.59375 C 4.300781 22.292969 4 23.148438 4 24.03125 C 4 26.214844 5.785156 28 7.96875 28 L 24.03125 28 C 26.214844 28 28 26.214844 28 24.03125 C 28 23.148438 27.699219 22.292969 27.15625 21.59375 L 21 13.65625 L 21 6 L 22 6 L 22 4 L 15 4 C 15 3.449219 14.550781 3 14 3 Z M 13 6 L 19 6 L 19 14.34375 L 21.84375 18 L 10.15625 18 L 13 14.34375 Z M 17 10 C 16.449219 10 16 10.449219 16 11 C 16 11.550781 16.449219 12 17 12 C 17.550781 12 18 11.550781 18 11 C 18 10.449219 17.550781 10 17 10 Z M 8.59375 20 L 23.40625 20 L 25.59375 22.8125 C 25.863281 23.160156 26 23.59375 26 24.03125 C 26 25.136719 25.136719 26 24.03125 26 L 7.96875 26 C 6.863281 26 6 25.136719 6 24.03125 C 6 23.59375 6.136719 23.160156 6.40625 22.8125 Z' }, child: [] }] })(props);
}

export function IoBugOutline(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 512 512' },
    child: [
      { tag: 'path', attr: { fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '32', d: 'M370 378c28.89 23.52 46 46.07 46 86m-274-86c-28.89 23.52-46 46.06-46 86m288-256c28.89-23.52 32-56.07 32-96m-288 94c-28.89-23.52-32-54.06-32-94m368 176.13h-80m-256 0H48M256 192v256' }, child: [] },
      { tag: 'path', attr: { fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '32', d: 'M256 448h0c-70.4 0-128-57.6-128-128v-96.07c0-65.07 57.6-96 128-96h0c70.4 0 128 25.6 128 96V320c0 70.4-57.6 128-128 128z' }, child: [] },
      { tag: 'path', attr: { fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '32', d: 'M179.43 143.52a49.08 49.08 0 0 1-3.43-15.73A80 80 0 0 1 255.79 48h.42A80 80 0 0 1 336 127.79a41.91 41.91 0 0 1-3.12 14.3' }, child: [] }
    ]
  })(props);
}

export function MdOutlineSignpost(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'path', attr: { d: 'M13 10h5l3-3-3-3h-5V2h-2v2H4v6h7v2H6l-3 3 3 3h5v4h2v-4h7v-6h-7v-2zM6 6h11.17l1 1-1 1H6V6zm12 10H6.83l-1-1 1-1H18v2z' }, child: [] }
    ]
  })(props);
}

export function AiOutlineComment(props) {
  return GenIcon({
    tag: 'svg',
    attr: { t: '1569682881658', viewBox: '0 0 1024 1024', version: '1.1' },
    child: [
      { tag: 'path', attr: { d: 'M573 421c-23.1 0-41 17.9-41 40s17.9 40 41 40c21.1 0 39-17.9 39-40s-17.9-40-39-40zM293 421c-23.1 0-41 17.9-41 40s17.9 40 41 40c21.1 0 39-17.9 39-40s-17.9-40-39-40z' }, child: [] },
      { tag: 'path', attr: { d: 'M894 345c-48.1-66-115.3-110.1-189-130v0.1c-17.1-19-36.4-36.5-58-52.1-163.7-119-393.5-82.7-513 81-96.3 133-92.2 311.9 6 439l0.8 132.6c0 3.2 0.5 6.4 1.5 9.4 5.3 16.9 23.3 26.2 40.1 20.9L309 806c33.5 11.9 68.1 18.7 102.5 20.6l-0.5 0.4c89.1 64.9 205.9 84.4 313 49l127.1 41.4c3.2 1 6.5 1.6 9.9 1.6 17.7 0 32-14.3 32-32V753c88.1-119.6 90.4-284.9 1-408zM323 735l-12-5-99 31-1-104-8-9c-84.6-103.2-90.2-251.9-11-361 96.4-132.2 281.2-161.4 413-66 132.2 96.1 161.5 280.6 66 412-80.1 109.9-223.5 150.5-348 102z m505-17l-8 10 1 104-98-33-12 5c-56 20.8-115.7 22.5-171 7l-0.2-0.1C613.7 788.2 680.7 742.2 729 676c76.4-105.3 88.8-237.6 44.4-350.4l0.6 0.4c23 16.5 44.1 37.1 62 62 72.6 99.6 68.5 235.2-8 330z' }, child: [] },
      { tag: 'path', attr: { d: 'M433 421c-23.1 0-41 17.9-41 40s17.9 40 41 40c21.1 0 39-17.9 39-40s-17.9-40-39-40z' }, child: [] }
    ]
  })(props);
}

export function FiInfo(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'circle', attr: { cx: '12', cy: '12', r: '10' }, child: [] },
      { tag: 'line', attr: { x1: '12', y1: '16', x2: '12', y2: '12' }, child: [] },
      { tag: 'line', attr: { x1: '12', y1: '8', x2: '12.01', y2: '8' }, child: [] }
    ]
  })(props);
}

export function RxTimer(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 15 15', fill: 'none' }, child: [{ tag: 'path', attr: { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M7.49998 0.849976C7.22383 0.849976 6.99998 1.07383 6.99998 1.34998V3.52234C6.99998 3.79848 7.22383 4.02234 7.49998 4.02234C7.77612 4.02234 7.99998 3.79848 7.99998 3.52234V1.8718C10.8862 2.12488 13.15 4.54806 13.15 7.49998C13.15 10.6204 10.6204 13.15 7.49998 13.15C4.37957 13.15 1.84998 10.6204 1.84998 7.49998C1.84998 6.10612 2.35407 4.83128 3.19049 3.8459C3.36919 3.63538 3.34339 3.31985 3.13286 3.14115C2.92234 2.96245 2.60681 2.98825 2.42811 3.19877C1.44405 4.35808 0.849976 5.86029 0.849976 7.49998C0.849976 11.1727 3.82728 14.15 7.49998 14.15C11.1727 14.15 14.15 11.1727 14.15 7.49998C14.15 3.82728 11.1727 0.849976 7.49998 0.849976ZM6.74049 8.08072L4.22363 4.57237C4.15231 4.47295 4.16346 4.33652 4.24998 4.25C4.33649 4.16348 4.47293 4.15233 4.57234 4.22365L8.08069 6.74051C8.56227 7.08599 8.61906 7.78091 8.19998 8.2C7.78089 8.61909 7.08597 8.56229 6.74049 8.08072Z', fill: 'currentColor' }, child: [] }] })(props);
}

export function HiOutlineSwitchVertical(props) {
  return GenIcon({ tag: 'svg', attr: { fill: 'none', viewBox: '0 0 24 24', strokeWidth: '2', stroke: 'currentColor', 'aria-hidden': 'true' }, child: [{ tag: 'path', attr: { strokeLinecap: 'round', strokeLinejoin: 'round', d: 'M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4' }, child: [] }] })(props);
}

export function LuFileCog(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M14 2v4a2 2 0 0 0 2 2h4' }, child: [] },
      { tag: 'path', attr: { d: 'm3.2 12.9-.9-.4' }, child: [] },
      { tag: 'path', attr: { d: 'm3.2 15.1-.9.4' }, child: [] },
      { tag: 'path', attr: { d: 'M4.677 21.5a2 2 0 0 0 1.313.5H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v2.5' }, child: [] },
      { tag: 'path', attr: { d: 'm4.9 11.2-.4-.9' }, child: [] },
      { tag: 'path', attr: { d: 'm4.9 16.8-.4.9' }, child: [] },
      { tag: 'path', attr: { d: 'm7.5 10.3-.4.9' }, child: [] },
      { tag: 'path', attr: { d: 'm7.5 17.7-.4-.9' }, child: [] },
      { tag: 'path', attr: { d: 'm9.7 12.5-.9.4' }, child: [] },
      { tag: 'path', attr: { d: 'm9.7 15.5-.9-.4' }, child: [] },
      { tag: 'circle', attr: { cx: '6', cy: '14', r: '3' }, child: [] }
    ]
  })(props);
}

export function LuFileInput(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4' }, child: [] },
      { tag: 'path', attr: { d: 'M14 2v4a2 2 0 0 0 2 2h4' }, child: [] },
      { tag: 'path', attr: { d: 'M2 15h10' }, child: [] },
      { tag: 'path', attr: { d: 'm9 18 3-3-3-3' }, child: [] }
    ]
  })(props);
}

export function PiCheckBold(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 256 256', fill: 'currentColor' }, child: [{ tag: 'path', attr: { d: 'M232.49,80.49l-128,128a12,12,0,0,1-17,0l-56-56a12,12,0,1,1,17-17L96,183,215.51,63.51a12,12,0,0,1,17,17Z' }, child: [] }] })(props);
}

export function FaChalkboardTeacher(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 640 512' }, child: [{ tag: 'path', attr: { d: 'M208 352c-2.39 0-4.78.35-7.06 1.09C187.98 357.3 174.35 360 160 360c-14.35 0-27.98-2.7-40.95-6.91-2.28-.74-4.66-1.09-7.05-1.09C49.94 352-.33 402.48 0 464.62.14 490.88 21.73 512 48 512h224c26.27 0 47.86-21.12 48-47.38.33-62.14-49.94-112.62-112-112.62zm-48-32c53.02 0 96-42.98 96-96s-42.98-96-96-96-96 42.98-96 96 42.98 96 96 96zM592 0H208c-26.47 0-48 22.25-48 49.59V96c23.42 0 45.1 6.78 64 17.8V64h352v288h-64v-64H384v64h-76.24c19.1 16.69 33.12 38.73 39.69 64H592c26.47 0 48-22.25 48-49.59V49.59C640 22.25 618.47 0 592 0z' }, child: [] }] })(props);
}

export function LuGraduationCap(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z' }, child: [] },
      { tag: 'path', attr: { d: 'M22 10v6' }, child: [] },
      { tag: 'path', attr: { d: 'M6 12.5V16a6 3 0 0 0 12 0v-3.5' }, child: [] }
    ]
  })(props);
}

export function RxCursorArrow(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 15 15', fill: 'none' }, child: [{ tag: 'path', attr: { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M3.29227 0.048984C3.47033 -0.032338 3.67946 -0.00228214 3.8274 0.125891L12.8587 7.95026C13.0134 8.08432 13.0708 8.29916 13.0035 8.49251C12.9362 8.68586 12.7578 8.81866 12.5533 8.82768L9.21887 8.97474L11.1504 13.2187C11.2648 13.47 11.1538 13.7664 10.9026 13.8808L8.75024 14.8613C8.499 14.9758 8.20255 14.8649 8.08802 14.6137L6.15339 10.3703L3.86279 12.7855C3.72196 12.934 3.50487 12.9817 3.31479 12.9059C3.1247 12.8301 3 12.6461 3 12.4414V0.503792C3 0.308048 3.11422 0.130306 3.29227 0.048984ZM4 1.59852V11.1877L5.93799 9.14425C6.05238 9.02363 6.21924 8.96776 6.38319 8.99516C6.54715 9.02256 6.68677 9.12965 6.75573 9.2809L8.79056 13.7441L10.0332 13.178L8.00195 8.71497C7.93313 8.56376 7.94391 8.38824 8.03072 8.24659C8.11753 8.10494 8.26903 8.01566 8.435 8.00834L11.2549 7.88397L4 1.59852Z', fill: 'currentColor' }, child: [] }] })(props);
}

export function FiCheckCircle(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M22 11.08V12a10 10 0 1 1-5.93-9.14' }, child: [] },
      { tag: 'polyline', attr: { points: '22 4 12 14.01 9 11.01' }, child: [] }
    ]
  })(props);
}

export function FiMonitor(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'rect', attr: { x: '2', y: '3', width: '20', height: '14', rx: '2', ry: '2' }, child: [] },
      { tag: 'line', attr: { x1: '8', y1: '21', x2: '16', y2: '21' }, child: [] },
      { tag: 'line', attr: { x1: '12', y1: '17', x2: '12', y2: '21' }, child: [] }
    ]
  })(props);
}

export function TbBell(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6' }, child: [] },
      { tag: 'path', attr: { d: 'M9 17v1a3 3 0 0 0 6 0v-1' }, child: [] }
    ]
  })(props);
}

export function TbPigMoney(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M15 11v.01' }, child: [] },
      { tag: 'path', attr: { d: 'M5.173 8.378a3 3 0 1 1 4.656 -1.377' }, child: [] },
      { tag: 'path', attr: { d: 'M16 4v3.803a6.019 6.019 0 0 1 2.658 3.197h1.341a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-1.342c-.336 .95 -.907 1.8 -1.658 2.473v2.027a1.5 1.5 0 0 1 -3 0v-.583a6.04 6.04 0 0 1 -1 .083h-4a6.04 6.04 0 0 1 -1 -.083v.583a1.5 1.5 0 0 1 -3 0v-2l0 -.027a6 6 0 0 1 4 -10.473h2.5l4.5 -3h0z' }, child: [] }
    ]
  })(props);
}

export function TbStatusChange(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M6 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0' }, child: [] },
      { tag: 'path', attr: { d: 'M18 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0' }, child: [] },
      { tag: 'path', attr: { d: 'M6 12v-2a6 6 0 1 1 12 0v2' }, child: [] },
      { tag: 'path', attr: { d: 'M15 9l3 3l3 -3' }, child: [] }
    ]
  })(props);
}

export function MdOutlinePoll(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0V0z' }, child: [] },
      { tag: 'path', attr: { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 10h2v7H7zm4-3h2v10h-2zm4 6h2v4h-2z' }, child: [] }
    ]
  })(props);
}

export function LuShieldQuestion(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z' }, child: [] },
      { tag: 'path', attr: { d: 'M9.1 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3' }, child: [] },
      { tag: 'path', attr: { d: 'M12 17h.01' }, child: [] }
    ]
  })(props);
}

export function LiaUndoAltSolid(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 32 32' }, child: [{ tag: 'path', attr: { d: 'M 16 3 C 12 3 8.4 4.7992187 6 7.6992188 L 6 4 L 4 4 L 4 12 L 12 12 L 12 10 L 6.8007812 10 C 8.8007812 7 12.1 5 16 5 C 22.1 5 27 9.9 27 16 C 27 22.1 22.1 27 16 27 C 9.9 27 5 22.1 5 16 L 3 16 C 3 23.2 8.8 29 16 29 C 23.2 29 29 23.2 29 16 C 29 8.8 23.2 3 16 3 z' }, child: [] }] })(props);
}

export function TbBuilding(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M3 21l18 0' }, child: [] },
      { tag: 'path', attr: { d: 'M9 8l1 0' }, child: [] },
      { tag: 'path', attr: { d: 'M9 12l1 0' }, child: [] },
      { tag: 'path', attr: { d: 'M9 16l1 0' }, child: [] },
      { tag: 'path', attr: { d: 'M14 8l1 0' }, child: [] },
      { tag: 'path', attr: { d: 'M14 12l1 0' }, child: [] },
      { tag: 'path', attr: { d: 'M14 16l1 0' }, child: [] },
      { tag: 'path', attr: { d: 'M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16' }, child: [] }
    ]
  })(props);
}

export function TbUserCircle(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0' }, child: [] },
      { tag: 'path', attr: { d: 'M12 10m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0' }, child: [] },
      { tag: 'path', attr: { d: 'M6.168 18.849a4 4 0 0 1 3.832 -2.849h4a4 4 0 0 1 3.834 2.855' }, child: [] }
    ]
  })(props);
}

export function FiFilePlus(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z' }, child: [] },
      { tag: 'polyline', attr: { points: '14 2 14 8 20 8' }, child: [] },
      { tag: 'line', attr: { x1: '12', y1: '18', x2: '12', y2: '12' }, child: [] },
      { tag: 'line', attr: { x1: '9', y1: '15', x2: '15', y2: '15' }, child: [] }
    ]
  })(props);
}

export function RxDividerVertical(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 15 15', fill: 'none' }, child: [{ tag: 'path', attr: { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M7.5 2C7.77614 2 8 2.22386 8 2.5L8 12.5C8 12.7761 7.77614 13 7.5 13C7.22386 13 7 12.7761 7 12.5L7 2.5C7 2.22386 7.22386 2 7.5 2Z', fill: 'currentColor' }, child: [] }] })(props);
}

export function TbHandStop(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M8 13v-7.5a1.5 1.5 0 0 1 3 0v6.5' }, child: [] },
      { tag: 'path', attr: { d: 'M11 5.5v-2a1.5 1.5 0 1 1 3 0v8.5' }, child: [] },
      { tag: 'path', attr: { d: 'M14 5.5a1.5 1.5 0 0 1 3 0v6.5' }, child: [] },
      { tag: 'path', attr: { d: 'M17 7.5a1.5 1.5 0 0 1 3 0v8.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47' }, child: [] }
    ]
  })(props);
}

export function TbCheck(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }, child: [{ tag: 'path', attr: { d: 'M5 12l5 5l10 -10' }, child: [] }] })(props);
}

export function TbX(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M18 6l-12 12' }, child: [] },
      { tag: 'path', attr: { d: 'M6 6l12 12' }, child: [] }
    ]
  })(props);
}

export function LuListChecks(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'm3 17 2 2 4-4' }, child: [] },
      { tag: 'path', attr: { d: 'm3 7 2 2 4-4' }, child: [] },
      { tag: 'path', attr: { d: 'M13 6h8' }, child: [] },
      { tag: 'path', attr: { d: 'M13 12h8' }, child: [] },
      { tag: 'path', attr: { d: 'M13 18h8' }, child: [] }
    ]
  })(props);
}

export function LuFileQuestion(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M12 17h.01' }, child: [] },
      { tag: 'path', attr: { d: 'M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z' }, child: [] },
      { tag: 'path', attr: { d: 'M9.1 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3' }, child: [] }
    ]
  })(props);
}

export function LuKeyRound(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z' }, child: [] },
      { tag: 'circle', attr: { cx: '16.5', cy: '7.5', r: '.5', fill: 'currentColor' }, child: [] }
    ]
  })(props);
}

export function FiCopy(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'rect', attr: { x: '9', y: '9', width: '13', height: '13', rx: '2', ry: '2' }, child: [] },
      { tag: 'path', attr: { d: 'M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1' }, child: [] }
    ]
  })(props);
}

export function LiaCubesSolid(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 32 32' }, child: [{ tag: 'path', attr: { d: 'M 16 4 L 15.625 4.15625 L 9.625 6.5625 L 9 6.8125 L 9 13.53125 L 3.59375 15.875 L 3 16.15625 L 3 24.21875 L 3.5 24.53125 L 9.5 27.875 L 9.96875 28.125 L 10.4375 27.90625 L 16 25.125 L 21.5625 27.90625 L 22.03125 28.125 L 22.5 27.875 L 28.5 24.53125 L 29 24.21875 L 29 16.15625 L 28.40625 15.875 L 23 13.53125 L 23 6.8125 L 22.375 6.5625 L 16.375 4.15625 Z M 16 6.1875 L 19.28125 7.46875 L 16 8.75 L 12.71875 7.46875 Z M 11 8.9375 L 15 10.46875 L 15 15.34375 L 11 13.5625 Z M 21 8.9375 L 21 13.5625 L 17 15.34375 L 17 10.46875 Z M 10 15.3125 L 13.625 16.90625 L 10 18.6875 L 6.375 16.875 Z M 22 15.3125 L 25.625 16.875 L 22 18.6875 L 18.375 16.90625 L 19.5 16.40625 Z M 5 18.40625 L 9 20.40625 L 9 25.3125 L 5 23.0625 Z M 27 18.40625 L 27 23.0625 L 23 25.3125 L 23 20.40625 Z M 15 18.46875 L 15 23.375 L 11 25.375 L 11 20.40625 Z M 17 18.46875 L 21 20.40625 L 21 25.375 L 17 23.375 Z' }, child: [] }] })(props);
}

export function FiPlay(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }, child: [{ tag: 'polygon', attr: { points: '5 3 19 12 5 21 5 3' }, child: [] }] })(props);
}

export function MdOutlineCancelPresentation(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0V0z' }, child: [] },
      { tag: 'path', attr: { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM9.41 15.95 12 13.36l2.59 2.59L16 14.54l-2.59-2.59L16 9.36l-1.41-1.41L12 10.54 9.41 7.95 8 9.36l2.59 2.59L8 14.54z' }, child: [] }
    ]
  })(props);
}

export function MdOutlineArrowRight(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0V0z' }, child: [] },
      { tag: 'path', attr: { d: 'm10 17 5-5-5-5v10z' }, child: [] }
    ]
  })(props);
}

export function RxDragHandleDots2(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 15 15', fill: 'none' }, child: [{ tag: 'path', attr: { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M5.5 4.625C6.12132 4.625 6.625 4.12132 6.625 3.5C6.625 2.87868 6.12132 2.375 5.5 2.375C4.87868 2.375 4.375 2.87868 4.375 3.5C4.375 4.12132 4.87868 4.625 5.5 4.625ZM9.5 4.625C10.1213 4.625 10.625 4.12132 10.625 3.5C10.625 2.87868 10.1213 2.375 9.5 2.375C8.87868 2.375 8.375 2.87868 8.375 3.5C8.375 4.12132 8.87868 4.625 9.5 4.625ZM10.625 7.5C10.625 8.12132 10.1213 8.625 9.5 8.625C8.87868 8.625 8.375 8.12132 8.375 7.5C8.375 6.87868 8.87868 6.375 9.5 6.375C10.1213 6.375 10.625 6.87868 10.625 7.5ZM5.5 8.625C6.12132 8.625 6.625 8.12132 6.625 7.5C6.625 6.87868 6.12132 6.375 5.5 6.375C4.87868 6.375 4.375 6.87868 4.375 7.5C4.375 8.12132 4.87868 8.625 5.5 8.625ZM10.625 11.5C10.625 12.1213 10.1213 12.625 9.5 12.625C8.87868 12.625 8.375 12.1213 8.375 11.5C8.375 10.8787 8.87868 10.375 9.5 10.375C10.1213 10.375 10.625 10.8787 10.625 11.5ZM5.5 12.625C6.12132 12.625 6.625 12.1213 6.625 11.5C6.625 10.8787 6.12132 10.375 5.5 10.375C4.87868 10.375 4.375 10.8787 4.375 11.5C4.375 12.1213 4.87868 12.625 5.5 12.625Z', fill: 'currentColor' }, child: [] }] })(props);
}

export function LuImageOff(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'line', attr: { x1: '2', x2: '22', y1: '2', y2: '22' }, child: [] },
      { tag: 'path', attr: { d: 'M10.41 10.41a2 2 0 1 1-2.83-2.83' }, child: [] },
      { tag: 'line', attr: { x1: '13.5', x2: '6', y1: '13.5', y2: '21' }, child: [] },
      { tag: 'line', attr: { x1: '18', x2: '21', y1: '12', y2: '15' }, child: [] },
      { tag: 'path', attr: { d: 'M3.59 3.59A1.99 1.99 0 0 0 3 5v14a2 2 0 0 0 2 2h14c.55 0 1.052-.22 1.41-.59' }, child: [] },
      { tag: 'path', attr: { d: 'M21 15V5a2 2 0 0 0-2-2H9' }, child: [] }
    ]
  })(props);
}

export function LuImagePlus(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M16 5h6' }, child: [] },
      { tag: 'path', attr: { d: 'M19 2v6' }, child: [] },
      { tag: 'path', attr: { d: 'M21 11.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7.5' }, child: [] },
      { tag: 'path', attr: { d: 'm21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21' }, child: [] },
      { tag: 'circle', attr: { cx: '9', cy: '9', r: '2' }, child: [] }
    ]
  })(props);
}

export function MdOutlineNotes(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0V0z' }, child: [] },
      { tag: 'path', attr: { d: 'M21 11.01 3 11v2h18zM3 16h12v2H3zM21 6H3v2.01L21 8z' }, child: [] }
    ]
  })(props);
}

export function AiOutlineAlignLeft(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 1024 1024' }, child: [{ tag: 'path', attr: { d: 'M120 230h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 424h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm784 140H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z' }, child: [] }] })(props);
}

export function LuImage(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'rect', attr: { width: '18', height: '18', x: '3', y: '3', rx: '2', ry: '2' }, child: [] },
      { tag: 'circle', attr: { cx: '9', cy: '9', r: '2' }, child: [] },
      { tag: 'path', attr: { d: 'm21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21' }, child: [] }
    ]
  })(props);
}

export function FiUnlock(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'rect', attr: { x: '3', y: '11', width: '18', height: '11', rx: '2', ry: '2' }, child: [] },
      { tag: 'path', attr: { d: 'M7 11V7a5 5 0 0 1 9.9-1' }, child: [] }
    ]
  })(props);
}

export function FiDownload(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4' }, child: [] },
      { tag: 'polyline', attr: { points: '7 10 12 15 17 10' }, child: [] },
      { tag: 'line', attr: { x1: '12', y1: '15', x2: '12', y2: '3' }, child: [] }
    ]
  })(props);
}

export function FiUpload(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4' }, child: [] },
      { tag: 'polyline', attr: { points: '17 8 12 3 7 8' }, child: [] },
      { tag: 'line', attr: { x1: '12', y1: '3', x2: '12', y2: '15' }, child: [] }
    ]
  })(props);
}

export function LuContainer(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M22 7.7c0-.6-.4-1.2-.8-1.5l-6.3-3.9a1.72 1.72 0 0 0-1.7 0l-10.3 6c-.5.2-.9.8-.9 1.4v6.6c0 .5.4 1.2.8 1.5l6.3 3.9a1.72 1.72 0 0 0 1.7 0l10.3-6c.5-.3.9-1 .9-1.5Z' }, child: [] },
      { tag: 'path', attr: { d: 'M10 21.9V14L2.1 9.1' }, child: [] },
      { tag: 'path', attr: { d: 'm10 14 11.9-6.9' }, child: [] },
      { tag: 'path', attr: { d: 'M14 19.8v-8.1' }, child: [] },
      { tag: 'path', attr: { d: 'M18 17.5V9.4' }, child: [] }
    ]
  })(props);
}

export function FiStar(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }, child: [{ tag: 'polygon', attr: { points: '12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2' }, child: [] }] })(props);
}

export function IoSync(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 512 512' },
    child: [
      { tag: 'path', attr: { fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '32', d: 'M434.67 285.59v-29.8c0-98.73-80.24-178.79-179.2-178.79a179 179 0 0 0-140.14 67.36m-38.53 82v29.8C76.8 355 157 435 256 435a180.45 180.45 0 0 0 140-66.92' }, child: [] },
      { tag: 'path', attr: { fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '32', d: 'm32 256 44-44 46 44m358 0-44 44-46-44' }, child: [] }
    ]
  })(props);
}

export function PiFlagBannerFold(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 256 256', fill: 'currentColor' }, child: [{ tag: 'path', attr: { d: 'M238.73,43.67A8,8,0,0,0,232,40H152a8,8,0,0,0-7.28,4.69L135.94,64H28a8,8,0,0,0-5.92,13.38L57.19,116,22.08,154.62A8,8,0,0,0,28,168h73.09a8,8,0,0,0,7.28-4.69L117.15,144h62.43l-34.86,76.69a8,8,0,1,0,14.56,6.62l80-176A8,8,0,0,0,238.73,43.67ZM95.94,152H46.08l27.84-30.62a8,8,0,0,0,0-10.76L46.08,80h82.59Zm90.91-24H124.42l32.73-72h62.43Z' }, child: [] }] })(props);
}

export function PiCheckCircleFill(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 256 256', fill: 'currentColor' }, child: [{ tag: 'path', attr: { d: 'M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm45.66,85.66-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35a8,8,0,0,1,11.32,11.32Z' }, child: [] }] })(props);
}

export function TbCircleDashedCheck(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M8.56 3.69a9 9 0 0 0 -2.92 1.95' }, child: [] },
      { tag: 'path', attr: { d: 'M3.69 8.56a9 9 0 0 0 -.69 3.44' }, child: [] },
      { tag: 'path', attr: { d: 'M3.69 15.44a9 9 0 0 0 1.95 2.92' }, child: [] },
      { tag: 'path', attr: { d: 'M8.56 20.31a9 9 0 0 0 3.44 .69' }, child: [] },
      { tag: 'path', attr: { d: 'M15.44 20.31a9 9 0 0 0 2.92 -1.95' }, child: [] },
      { tag: 'path', attr: { d: 'M20.31 15.44a9 9 0 0 0 .69 -3.44' }, child: [] },
      { tag: 'path', attr: { d: 'M20.31 8.56a9 9 0 0 0 -1.95 -2.92' }, child: [] },
      { tag: 'path', attr: { d: 'M15.44 3.69a9 9 0 0 0 -3.44 -.69' }, child: [] },
      { tag: 'path', attr: { d: 'M9 12l2 2l4 -4' }, child: [] }
    ]
  })(props);
}

export function MdOutlineRocketLaunch(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'path', attr: { d: 'M6 15c-.83 0-1.58.34-2.12.88C2.7 17.06 2 22 2 22s4.94-.7 6.12-1.88A2.996 2.996 0 0 0 6 15zm.71 3.71c-.28.28-2.17.76-2.17.76s.47-1.88.76-2.17c.17-.19.42-.3.7-.3a1.003 1.003 0 0 1 .71 1.71zm10.71-5.06c6.36-6.36 4.24-11.31 4.24-11.31S16.71.22 10.35 6.58l-2.49-.5a2.03 2.03 0 0 0-1.81.55L2 10.69l5 2.14L11.17 17l2.14 5 4.05-4.05c.47-.47.68-1.15.55-1.81l-.49-2.49zM7.41 10.83l-1.91-.82 1.97-1.97 1.44.29c-.57.83-1.08 1.7-1.5 2.5zm6.58 7.67-.82-1.91c.8-.42 1.67-.93 2.49-1.5l.29 1.44-1.96 1.97zM16 12.24c-1.32 1.32-3.38 2.4-4.04 2.73l-2.93-2.93c.32-.65 1.4-2.71 2.73-4.04 4.68-4.68 8.23-3.99 8.23-3.99s.69 3.55-3.99 8.23zM15 11c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z' }, child: [] }
    ]
  })(props);
}

export function FiLock(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'rect', attr: { x: '3', y: '11', width: '18', height: '11', rx: '2', ry: '2' }, child: [] },
      { tag: 'path', attr: { d: 'M7 11V7a5 5 0 0 1 10 0v4' }, child: [] }
    ]
  })(props);
}

export function FiSlash(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'circle', attr: { cx: '12', cy: '12', r: '10' }, child: [] },
      { tag: 'line', attr: { x1: '4.93', y1: '4.93', x2: '19.07', y2: '19.07' }, child: [] }
    ]
  })(props);
}

export function FiCheck(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }, child: [{ tag: 'polyline', attr: { points: '20 6 9 17 4 12' }, child: [] }] })(props);
}

export function MdWebhook(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'path', attr: { d: 'M10 15h5.88c.27-.31.67-.5 1.12-.5.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5c-.44 0-.84-.19-1.12-.5H11.9A5 5 0 1 1 6 11.1v2.07c-1.16.41-2 1.53-2 2.83 0 1.65 1.35 3 3 3s3-1.35 3-3v-1zm2.5-11c1.65 0 3 1.35 3 3h2c0-2.76-2.24-5-5-5a5.002 5.002 0 0 0-3.45 8.62l-2.35 3.9c-.68.14-1.2.75-1.2 1.48 0 .83.67 1.5 1.5 1.5a1.498 1.498 0 0 0 1.43-1.95l3.38-5.63A3.003 3.003 0 0 1 9.5 7c0-1.65 1.35-3 3-3zm4.5 9c-.64 0-1.23.2-1.72.54l-3.05-5.07C11.53 8.35 11 7.74 11 7c0-.83.67-1.5 1.5-1.5S14 6.17 14 7c0 .15-.02.29-.06.43l2.19 3.65c.28-.05.57-.08.87-.08 2.76 0 5 2.24 5 5s-2.24 5-5 5a5 5 0 0 1-4.33-2.5h2.67c.48.32 1.05.5 1.66.5 1.65 0 3-1.35 3-3s-1.35-3-3-3z' }, child: [] }
    ]
  })(props);
}

export function FiLink(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71' }, child: [] },
      { tag: 'path', attr: { d: 'M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71' }, child: [] }
    ]
  })(props);
}

export function IoChevronBack(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 512 512' }, child: [{ tag: 'path', attr: { fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '48', d: 'M328 112 184 256l144 144' }, child: [] }] })(props);
}

export function IoChevronForward(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 512 512' }, child: [{ tag: 'path', attr: { fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '48', d: 'm184 112 144 144-144 144' }, child: [] }] })(props);
}

export function LuHand(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M18 11V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2' }, child: [] },
      { tag: 'path', attr: { d: 'M14 10V4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v2' }, child: [] },
      { tag: 'path', attr: { d: 'M10 10.5V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2v8' }, child: [] },
      { tag: 'path', attr: { d: 'M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15' }, child: [] }
    ]
  })(props);
}

export function TbNumber123(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M3 10l2 -2v8' }, child: [] },
      { tag: 'path', attr: { d: 'M9 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3' }, child: [] },
      { tag: 'path', attr: { d: 'M17 8h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-2.5' }, child: [] }
    ]
  })(props);
}

export function FiChevronDown(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }, child: [{ tag: 'polyline', attr: { points: '6 9 12 15 18 9' }, child: [] }] })(props);
}

export function FiX(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'line', attr: { x1: '18', y1: '6', x2: '6', y2: '18' }, child: [] },
      { tag: 'line', attr: { x1: '6', y1: '6', x2: '18', y2: '18' }, child: [] }
    ]
  })(props);
}

export function IoPlay(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 512 512' }, child: [{ tag: 'path', attr: { d: 'M133 440a35.37 35.37 0 0 1-17.5-4.67c-12-6.8-19.46-20-19.46-34.33V111c0-14.37 7.46-27.53 19.46-34.33a35.13 35.13 0 0 1 35.77.45l247.85 148.36a36 36 0 0 1 0 61l-247.89 148.4A35.5 35.5 0 0 1 133 440z' }, child: [] }] })(props);
}

export function TbTargetArrow(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0' }, child: [] },
      { tag: 'path', attr: { d: 'M12 7a5 5 0 1 0 5 5' }, child: [] },
      { tag: 'path', attr: { d: 'M13 3.055a9 9 0 1 0 7.941 7.945' }, child: [] },
      { tag: 'path', attr: { d: 'M15 6v3h3l3 -3h-3v-3z' }, child: [] },
      { tag: 'path', attr: { d: 'M15 9l-3 3' }, child: [] }
    ]
  })(props);
}

export function TbPlugConnected(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M7 12l5 5l-1.5 1.5a3.536 3.536 0 1 1 -5 -5l1.5 -1.5z' }, child: [] },
      { tag: 'path', attr: { d: 'M17 12l-5 -5l1.5 -1.5a3.536 3.536 0 1 1 5 5l-1.5 1.5z' }, child: [] },
      { tag: 'path', attr: { d: 'M3 21l2.5 -2.5' }, child: [] },
      { tag: 'path', attr: { d: 'M18.5 5.5l2.5 -2.5' }, child: [] },
      { tag: 'path', attr: { d: 'M10 11l-2 2' }, child: [] },
      { tag: 'path', attr: { d: 'M13 14l-2 2' }, child: [] }
    ]
  })(props);
}

export function LuFlag(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z' }, child: [] },
      { tag: 'line', attr: { x1: '4', x2: '4', y1: '22', y2: '15' }, child: [] }
    ]
  })(props);
}

export function BiRename(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { d: 'M20.005 5.995h-1v2h1v8h-1v2h1c1.103 0 2-.897 2-2v-8c0-1.102-.898-2-2-2zm-14 4H15v4H6.005z' }, child: [] },
      { tag: 'path', attr: { d: 'M17.005 17.995V4H20V2h-8v2h3.005v1.995h-11c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h11V20H12v2h8v-2h-2.995v-2.005zm-13-2v-8h11v8h-11z' }, child: [] }
    ]
  })(props);
}

export function LuPencil(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z' }, child: [] },
      { tag: 'path', attr: { d: 'm15 5 4 4' }, child: [] }
    ]
  })(props);
}

export function MdOutlineDragIndicator(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0V0z' }, child: [] },
      { tag: 'path', attr: { d: 'M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' }, child: [] }
    ]
  })(props);
}

export function MdOutlineChecklist(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'path', attr: { d: 'M22 7h-9v2h9V7zm0 8h-9v2h9v-2zM5.54 11 2 7.46l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41L5.54 11zm0 8L2 15.46l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41L5.54 19z' }, child: [] }
    ]
  })(props);
}

export function PiListPlus(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 256 256', fill: 'currentColor' }, child: [{ tag: 'path', attr: { d: 'M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64Zm8,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Zm104,48H40a8,8,0,0,0,0,16H144a8,8,0,0,0,0-16Zm88,0H216V168a8,8,0,0,0-16,0v16H184a8,8,0,0,0,0,16h16v16a8,8,0,0,0,16,0V200h16a8,8,0,0,0,0-16Z' }, child: [] }] })(props);
}

export function LuListPlus(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M11 12H3' }, child: [] },
      { tag: 'path', attr: { d: 'M16 6H3' }, child: [] },
      { tag: 'path', attr: { d: 'M16 18H3' }, child: [] },
      { tag: 'path', attr: { d: 'M18 9v6' }, child: [] },
      { tag: 'path', attr: { d: 'M21 12h-6' }, child: [] }
    ]
  })(props);
}

export function TbMessage(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M8 9h8' }, child: [] },
      { tag: 'path', attr: { d: 'M8 13h6' }, child: [] },
      { tag: 'path', attr: { d: 'M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-5l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12z' }, child: [] }
    ]
  })(props);
}

export function FiMoreHorizontal(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'circle', attr: { cx: '12', cy: '12', r: '1' }, child: [] },
      { tag: 'circle', attr: { cx: '19', cy: '12', r: '1' }, child: [] },
      { tag: 'circle', attr: { cx: '5', cy: '12', r: '1' }, child: [] }
    ]
  })(props);
}

export function FaSquare(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 448 512' }, child: [{ tag: 'path', attr: { d: 'M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z' }, child: [] }] })(props);
}

export function BiFullscreen(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24' }, child: [{ tag: 'path', attr: { d: 'M5 5h5V3H3v7h2zm5 14H5v-5H3v7h7zm11-5h-2v5h-5v2h7zm-2-4h2V3h-7v2h5z' }, child: [] }] })(props);
}

export function FiZoomIn(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'circle', attr: { cx: '11', cy: '11', r: '8' }, child: [] },
      { tag: 'line', attr: { x1: '21', y1: '21', x2: '16.65', y2: '16.65' }, child: [] },
      { tag: 'line', attr: { x1: '11', y1: '8', x2: '11', y2: '14' }, child: [] },
      { tag: 'line', attr: { x1: '8', y1: '11', x2: '14', y2: '11' }, child: [] }
    ]
  })(props);
}

export function BsInfinity(props) {
  return GenIcon({ tag: 'svg', attr: { fill: 'currentColor', viewBox: '0 0 16 16' }, child: [{ tag: 'path', attr: { d: 'M5.68 5.792 7.345 7.75 5.681 9.708a2.75 2.75 0 1 1 0-3.916ZM8 6.978 6.416 5.113l-.014-.015a3.75 3.75 0 1 0 0 5.304l.014-.015L8 8.522l1.584 1.865.014.015a3.75 3.75 0 1 0 0-5.304l-.014.015zm.656.772 1.663-1.958a2.75 2.75 0 1 1 0 3.916z' }, child: [] }] })(props);
}

export function MdOutlineHttp(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M24 24H0V0h24v24z', opacity: '.87' }, child: [] },
      { tag: 'path', attr: { d: 'M4.5 11h-2V9H1v6h1.5v-2.5h2V15H6V9H4.5v2zm2.5-.5h1.5V15H10v-4.5h1.5V9H7v1.5zm5.5 0H14V15h1.5v-4.5H17V9h-4.5v1.5zm9-1.5H18v6h1.5v-2h2c.8 0 1.5-.7 1.5-1.5v-1c0-.8-.7-1.5-1.5-1.5zm0 2.5h-2v-1h2v1z' }, child: [] }
    ]
  })(props);
}

export function BiSave(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24' }, child: [{ tag: 'path', attr: { d: 'M5 21h14a2 2 0 0 0 2-2V8a1 1 0 0 0-.29-.71l-4-4A1 1 0 0 0 16 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2zm10-2H9v-5h6zM13 7h-2V5h2zM5 5h2v4h8V5h.59L19 8.41V19h-2v-5a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v5H5z' }, child: [] }] })(props);
}

export function MdOutlinePublic(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0V0z' }, child: [] },
      { tag: 'path', attr: { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-.61.08-1.21.21-1.78L8.99 15v1c0 1.1.9 2 2 2v1.93C7.06 19.43 4 16.07 4 12zm13.89 5.4c-.26-.81-1-1.4-1.9-1.4h-1v-3c0-.55-.45-1-1-1h-6v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41C17.92 5.77 20 8.65 20 12c0 2.08-.81 3.98-2.11 5.4z' }, child: [] }
    ]
  })(props);
}

export function MdAutorenew(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'path', attr: { d: 'M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8A5.87 5.87 0 0 1 6 12c0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z' }, child: [] }
    ]
  })(props);
}

export function MdOutlineDashboardCustomize(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0V0z' }, child: [] },
      { tag: 'path', attr: { d: 'M3 11h8V3H3v8zm2-6h4v4H5V5zM13 3v8h8V3h-8zm6 6h-4V5h4v4zM3 21h8v-8H3v8zm2-6h4v4H5v-4zM18 13h-2v3h-3v2h3v3h2v-3h3v-2h-3z' }, child: [] }
    ]
  })(props);
}

export function FiChevronRight(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }, child: [{ tag: 'polyline', attr: { points: '9 18 15 12 9 6' }, child: [] }] })(props);
}

export function FiSearch(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'circle', attr: { cx: '11', cy: '11', r: '8' }, child: [] },
      { tag: 'line', attr: { x1: '21', y1: '21', x2: '16.65', y2: '16.65' }, child: [] }
    ]
  })(props);
}

export function FiBriefcase(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'rect', attr: { x: '2', y: '7', width: '20', height: '14', rx: '2', ry: '2' }, child: [] },
      { tag: 'path', attr: { d: 'M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16' }, child: [] }
    ]
  })(props);
}

export function FiZap(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }, child: [{ tag: 'polygon', attr: { points: '13 2 3 14 12 14 11 22 21 10 12 10 13 2' }, child: [] }] })(props);
}

export function HiOutlineSparkles(props) {
  return GenIcon({ tag: 'svg', attr: { fill: 'none', viewBox: '0 0 24 24', strokeWidth: '2', stroke: 'currentColor', 'aria-hidden': 'true' }, child: [{ tag: 'path', attr: { strokeLinecap: 'round', strokeLinejoin: 'round', d: 'M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z' }, child: [] }] })(props);
}

export function HiOutlineDocument(props) {
  return GenIcon({ tag: 'svg', attr: { fill: 'none', viewBox: '0 0 24 24', strokeWidth: '1.5', stroke: 'currentColor', 'aria-hidden': 'true' }, child: [{ tag: 'path', attr: { strokeLinecap: 'round', strokeLinejoin: 'round', d: 'M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z' }, child: [] }] })(props);
}

export function AiOutlineFileSync(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 1024 1024' }, child: [{ tag: 'path', attr: { d: 'M296 256c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm192 200v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8zm-48 396H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm104.1-115.6c1.8-34.5 16.2-66.8 40.8-91.4 26.2-26.2 62-41 99.1-41 37.4 0 72.6 14.6 99.1 41 3.2 3.2 6.3 6.6 9.2 10.1L769.2 673a8 8 0 0 0 3 14.1l93.3 22.5c5 1.2 9.8-2.6 9.9-7.7l.6-95.4a8 8 0 0 0-12.9-6.4l-20.3 15.8C805.4 569.6 748.1 540 684 540c-109.9 0-199.6 86.9-204 195.7-.2 4.5 3.5 8.3 8 8.3h48.1c4.3 0 7.8-3.3 8-7.6zM880 744h-48.1c-4.3 0-7.8 3.3-8 7.6-1.8 34.5-16.2 66.8-40.8 91.4-26.2 26.2-62 41-99.1 41-37.4 0-72.6-14.6-99.1-41-3.2-3.2-6.3-6.6-9.2-10.1l23.1-17.9a8 8 0 0 0-3-14.1l-93.3-22.5c-5-1.2-9.8 2.6-9.9 7.7l-.6 95.4a8 8 0 0 0 12.9 6.4l20.3-15.8C562.6 918.4 619.9 948 684 948c109.9 0 199.6-86.9 204-195.7.2-4.5-3.5-8.3-8-8.3z' }, child: [] }] })(props);
}

export function TbClipboardCopy(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h3m9 -9v-5a2 2 0 0 0 -2 -2h-2' }, child: [] },
      { tag: 'path', attr: { d: 'M13 17v-1a1 1 0 0 1 1 -1h1m3 0h1a1 1 0 0 1 1 1v1m0 3v1a1 1 0 0 1 -1 1h-1m-3 0h-1a1 1 0 0 1 -1 -1v-1' }, child: [] },
      { tag: 'path', attr: { d: 'M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z' }, child: [] }
    ]
  })(props);
}

export function LuCircleDashed(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M10.1 2.182a10 10 0 0 1 3.8 0' }, child: [] },
      { tag: 'path', attr: { d: 'M13.9 21.818a10 10 0 0 1-3.8 0' }, child: [] },
      { tag: 'path', attr: { d: 'M17.609 3.721a10 10 0 0 1 2.69 2.7' }, child: [] },
      { tag: 'path', attr: { d: 'M2.182 13.9a10 10 0 0 1 0-3.8' }, child: [] },
      { tag: 'path', attr: { d: 'M20.279 17.609a10 10 0 0 1-2.7 2.69' }, child: [] },
      { tag: 'path', attr: { d: 'M21.818 10.1a10 10 0 0 1 0 3.8' }, child: [] },
      { tag: 'path', attr: { d: 'M3.721 6.391a10 10 0 0 1 2.7-2.69' }, child: [] },
      { tag: 'path', attr: { d: 'M6.391 20.279a10 10 0 0 1-2.69-2.7' }, child: [] }
    ]
  })(props);
}

export function BsQuestion(props) {
  return GenIcon({ tag: 'svg', attr: { fill: 'currentColor', viewBox: '0 0 16 16' }, child: [{ tag: 'path', attr: { d: 'M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286m1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94' }, child: [] }] })(props);
}

export function FiTable(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }, child: [{ tag: 'path', attr: { d: 'M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18' }, child: [] }] })(props);
}

export function RiIndeterminateCircleLine(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24', fill: 'currentColor' }, child: [{ tag: 'path', attr: { d: 'M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM7 11H17V13H7V11Z' }, child: [] }] })(props);
}

export function LuShuffle(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'm18 14 4 4-4 4' }, child: [] },
      { tag: 'path', attr: { d: 'm18 2 4 4-4 4' }, child: [] },
      { tag: 'path', attr: { d: 'M2 18h1.973a4 4 0 0 0 3.3-1.7l5.454-8.6a4 4 0 0 1 3.3-1.7H22' }, child: [] },
      { tag: 'path', attr: { d: 'M2 6h1.972a4 4 0 0 1 3.6 2.2' }, child: [] },
      { tag: 'path', attr: { d: 'M22 18h-6.041a4 4 0 0 1-3.3-1.8l-.359-.45' }, child: [] }
    ]
  })(props);
}

export function FiAlertCircle(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'circle', attr: { cx: '12', cy: '12', r: '10' }, child: [] },
      { tag: 'line', attr: { x1: '12', y1: '8', x2: '12', y2: '12' }, child: [] },
      { tag: 'line', attr: { x1: '12', y1: '16', x2: '12.01', y2: '16' }, child: [] }
    ]
  })(props);
}

export function LuListRestart(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M21 6H3' }, child: [] },
      { tag: 'path', attr: { d: 'M7 12H3' }, child: [] },
      { tag: 'path', attr: { d: 'M7 18H3' }, child: [] },
      { tag: 'path', attr: { d: 'M12 18a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5c-1.33 0-2.54.54-3.41 1.41L11 14' }, child: [] },
      { tag: 'path', attr: { d: 'M11 10v4h4' }, child: [] }
    ]
  })(props);
}

export function FiKey(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }, child: [{ tag: 'path', attr: { d: 'M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4' }, child: [] }] })(props);
}

export function HiOutlineSortAscending(props) {
  return GenIcon({ tag: 'svg', attr: { fill: 'none', viewBox: '0 0 24 24', strokeWidth: '2', stroke: 'currentColor', 'aria-hidden': 'true' }, child: [{ tag: 'path', attr: { strokeLinecap: 'round', strokeLinejoin: 'round', d: 'M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12' }, child: [] }] })(props);
}

export function HiOutlineSortDescending(props) {
  return GenIcon({ tag: 'svg', attr: { fill: 'none', viewBox: '0 0 24 24', strokeWidth: '2', stroke: 'currentColor', 'aria-hidden': 'true' }, child: [{ tag: 'path', attr: { strokeLinecap: 'round', strokeLinejoin: 'round', d: 'M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4' }, child: [] }] })(props);
}

export function GrAction(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24' }, child: [{ tag: 'path', attr: { fill: 'none', strokeWidth: '2', d: 'M1,23 L4,20 L1,23 Z M20,4 L23,1 L20,4 Z M9,11 L12,8 L9,11 Z M13,15 L16,12 L13,15 Z M10,5 L19,14 L20,13 C22,11 24.0533047,8.00000006 20,4 C15.9466953,-5.91784286e-08 13,2 11,4 L10,5 Z M4,11 L5,10 L14,19 L13,20 C11.0000005,22 7.9999999,24.0873857 4,20 C9.84858655e-08,15.9126143 2,13 4,11 Z' }, child: [] }] })(props);
}

export function TbLogs(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M4 12h.01' }, child: [] },
      { tag: 'path', attr: { d: 'M4 6h.01' }, child: [] },
      { tag: 'path', attr: { d: 'M4 18h.01' }, child: [] },
      { tag: 'path', attr: { d: 'M8 18h2' }, child: [] },
      { tag: 'path', attr: { d: 'M8 12h2' }, child: [] },
      { tag: 'path', attr: { d: 'M8 6h2' }, child: [] },
      { tag: 'path', attr: { d: 'M14 6h6' }, child: [] },
      { tag: 'path', attr: { d: 'M14 12h6' }, child: [] },
      { tag: 'path', attr: { d: 'M14 18h6' }, child: [] }
    ]
  })(props);
}

export function MdSubdirectoryArrowRight(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0V0z' }, child: [] },
      { tag: 'path', attr: { d: 'm19 15-6 6-1.42-1.42L15.17 16H4V4h2v10h9.17l-3.59-3.58L13 9l6 6z' }, child: [] }
    ]
  })(props);
}

export function BiGitMerge(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24' }, child: [{ tag: 'path', attr: { d: 'M2.5 18.5C2.5 20.43 4.07 22 6 22s3.5-1.57 3.5-3.5c0-1.58-1.06-2.903-2.5-3.337v-3.488c.244.273.509.527.813.744 1.18.844 2.617 1.098 3.918 1.098.966 0 1.853-.14 2.506-.281a3.5 3.5 0 0 0 3.264 2.265c1.93 0 3.5-1.57 3.5-3.5s-1.57-3.5-3.5-3.5a3.5 3.5 0 0 0-3.404 2.718c-1.297.321-3.664.616-5.119-.426-.666-.477-1.09-1.239-1.306-2.236C8.755 7.96 9.5 6.821 9.5 5.5 9.5 3.57 7.93 2 6 2S2.5 3.57 2.5 5.5c0 1.58 1.06 2.903 2.5 3.337v6.326c-1.44.434-2.5 1.757-2.5 3.337zm15-8c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5S16 12.827 16 12s.673-1.5 1.5-1.5zm-10 8c0 .827-.673 1.5-1.5 1.5s-1.5-.673-1.5-1.5S5.173 17 6 17s1.5.673 1.5 1.5zm-3-13C4.5 4.673 5.173 4 6 4s1.5.673 1.5 1.5S6.827 7 6 7s-1.5-.673-1.5-1.5z' }, child: [] }] })(props);
}

export function BiErrorCircle(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { d: 'M11.953 2C6.465 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.493 2 11.953 2zM12 20c-4.411 0-8-3.589-8-8s3.567-8 7.953-8C16.391 4 20 7.589 20 12s-3.589 8-8 8z' }, child: [] },
      { tag: 'path', attr: { d: 'M11 7h2v7h-2zm0 8h2v2h-2z' }, child: [] }
    ]
  })(props);
}

export function BiCog(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { d: 'M12 16c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm0-6c1.084 0 2 .916 2 2s-.916 2-2 2-2-.916-2-2 .916-2 2-2z' }, child: [] },
      { tag: 'path', attr: { d: 'm2.845 16.136 1 1.73c.531.917 1.809 1.261 2.73.73l.529-.306A8.1 8.1 0 0 0 9 19.402V20c0 1.103.897 2 2 2h2c1.103 0 2-.897 2-2v-.598a8.132 8.132 0 0 0 1.896-1.111l.529.306c.923.53 2.198.188 2.731-.731l.999-1.729a2.001 2.001 0 0 0-.731-2.732l-.505-.292a7.718 7.718 0 0 0 0-2.224l.505-.292a2.002 2.002 0 0 0 .731-2.732l-.999-1.729c-.531-.92-1.808-1.265-2.731-.732l-.529.306A8.1 8.1 0 0 0 15 4.598V4c0-1.103-.897-2-2-2h-2c-1.103 0-2 .897-2 2v.598a8.132 8.132 0 0 0-1.896 1.111l-.529-.306c-.924-.531-2.2-.187-2.731.732l-.999 1.729a2.001 2.001 0 0 0 .731 2.732l.505.292a7.683 7.683 0 0 0 0 2.223l-.505.292a2.003 2.003 0 0 0-.731 2.733zm3.326-2.758A5.703 5.703 0 0 1 6 12c0-.462.058-.926.17-1.378a.999.999 0 0 0-.47-1.108l-1.123-.65.998-1.729 1.145.662a.997.997 0 0 0 1.188-.142 6.071 6.071 0 0 1 2.384-1.399A1 1 0 0 0 11 5.3V4h2v1.3a1 1 0 0 0 .708.956 6.083 6.083 0 0 1 2.384 1.399.999.999 0 0 0 1.188.142l1.144-.661 1 1.729-1.124.649a1 1 0 0 0-.47 1.108c.112.452.17.916.17 1.378 0 .461-.058.925-.171 1.378a1 1 0 0 0 .471 1.108l1.123.649-.998 1.729-1.145-.661a.996.996 0 0 0-1.188.142 6.071 6.071 0 0 1-2.384 1.399A1 1 0 0 0 13 18.7l.002 1.3H11v-1.3a1 1 0 0 0-.708-.956 6.083 6.083 0 0 1-2.384-1.399.992.992 0 0 0-1.188-.141l-1.144.662-1-1.729 1.124-.651a1 1 0 0 0 .471-1.108z' }, child: [] }
    ]
  })(props);
}

export function BiBulb(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24' }, child: [{ tag: 'path', attr: { d: 'M9 20h6v2H9zm7.906-6.288C17.936 12.506 19 11.259 19 9c0-3.859-3.141-7-7-7S5 5.141 5 9c0 2.285 1.067 3.528 2.101 4.73.358.418.729.851 1.084 1.349.144.206.38.996.591 1.921H8v2h8v-2h-.774c.213-.927.45-1.719.593-1.925.352-.503.726-.94 1.087-1.363zm-2.724.213c-.434.617-.796 2.075-1.006 3.075h-2.351c-.209-1.002-.572-2.463-1.011-3.08a20.502 20.502 0 0 0-1.196-1.492C7.644 11.294 7 10.544 7 9c0-2.757 2.243-5 5-5s5 2.243 5 5c0 1.521-.643 2.274-1.615 3.413-.373.438-.796.933-1.203 1.512z' }, child: [] }] })(props);
}

export function HiOutlineChatBubbleOvalLeft(props) {
  return GenIcon({ tag: 'svg', attr: { fill: 'none', viewBox: '0 0 24 24', strokeWidth: '1.5', stroke: 'currentColor', 'aria-hidden': 'true' }, child: [{ tag: 'path', attr: { strokeLinecap: 'round', strokeLinejoin: 'round', d: 'M12 20.25c4.97 0 9-3.694 9-8.25s-4.03-8.25-9-8.25S3 7.444 3 12c0 2.104.859 4.023 2.273 5.48.432.447.74 1.04.586 1.641a4.483 4.483 0 0 1-.923 1.785A5.969 5.969 0 0 0 6 21c1.282 0 2.47-.402 3.445-1.087.81.22 1.668.337 2.555.337Z' }, child: [] }] })(props);
}

export function FaRegLightbulb(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 352 512' }, child: [{ tag: 'path', attr: { d: 'M176 80c-52.94 0-96 43.06-96 96 0 8.84 7.16 16 16 16s16-7.16 16-16c0-35.3 28.72-64 64-64 8.84 0 16-7.16 16-16s-7.16-16-16-16zM96.06 459.17c0 3.15.93 6.22 2.68 8.84l24.51 36.84c2.97 4.46 7.97 7.14 13.32 7.14h78.85c5.36 0 10.36-2.68 13.32-7.14l24.51-36.84c1.74-2.62 2.67-5.7 2.68-8.84l.05-43.18H96.02l.04 43.18zM176 0C73.72 0 0 82.97 0 176c0 44.37 16.45 84.85 43.56 115.78 16.64 18.99 42.74 58.8 52.42 92.16v.06h48v-.12c-.01-4.77-.72-9.51-2.15-14.07-5.59-17.81-22.82-64.77-62.17-109.67-20.54-23.43-31.52-53.15-31.61-84.14-.2-73.64 59.67-128 127.95-128 70.58 0 128 57.42 128 128 0 30.97-11.24 60.85-31.65 84.14-39.11 44.61-56.42 91.47-62.1 109.46a47.507 47.507 0 0 0-2.22 14.3v.1h48v-.05c9.68-33.37 35.78-73.18 52.42-92.16C335.55 260.85 352 220.37 352 176 352 78.8 273.2 0 176 0z' }, child: [] }] })(props);
}

export function IoSearch(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 512 512' }, child: [{ tag: 'path', attr: { d: 'M456.69 421.39 362.6 327.3a173.81 173.81 0 0 0 34.84-104.58C397.44 126.38 319.06 48 222.72 48S48 126.38 48 222.72s78.38 174.72 174.72 174.72A173.81 173.81 0 0 0 327.3 362.6l94.09 94.09a25 25 0 0 0 35.3-35.3zM97.92 222.72a124.8 124.8 0 1 1 124.8 124.8 124.95 124.95 0 0 1-124.8-124.8z' }, child: [] }] })(props);
}

export function HiOutlineDocumentDuplicate(props) {
  return GenIcon({ tag: 'svg', attr: { fill: 'none', viewBox: '0 0 24 24', strokeWidth: '2', stroke: 'currentColor', 'aria-hidden': 'true' }, child: [{ tag: 'path', attr: { strokeLinecap: 'round', strokeLinejoin: 'round', d: 'M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2' }, child: [] }] })(props);
}

export function HiOutlineDocumentRemove(props) {
  return GenIcon({ tag: 'svg', attr: { fill: 'none', viewBox: '0 0 24 24', strokeWidth: '2', stroke: 'currentColor', 'aria-hidden': 'true' }, child: [{ tag: 'path', attr: { strokeLinecap: 'round', strokeLinejoin: 'round', d: 'M9 13h6m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z' }, child: [] }] })(props);
}

export function HiOutlineDocumentText(props) {
  return GenIcon({ tag: 'svg', attr: { fill: 'none', viewBox: '0 0 24 24', strokeWidth: '1.5', stroke: 'currentColor', 'aria-hidden': 'true' }, child: [{ tag: 'path', attr: { strokeLinecap: 'round', strokeLinejoin: 'round', d: 'M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z' }, child: [] }] })(props);
}

export function FiBookmark(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }, child: [{ tag: 'path', attr: { d: 'M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z' }, child: [] }] })(props);
}

export function FiDatabase(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'ellipse', attr: { cx: '12', cy: '5', rx: '9', ry: '3' }, child: [] },
      { tag: 'path', attr: { d: 'M21 12c0 1.66-4 3-9 3s-9-1.34-9-3' }, child: [] },
      { tag: 'path', attr: { d: 'M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5' }, child: [] }
    ]
  })(props);
}

export function GoTriangleRight(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24' }, child: [{ tag: 'path', attr: { d: 'm15.146 12.354-5.792 5.792a.5.5 0 0 1-.854-.353V6.207a.5.5 0 0 1 .854-.353l5.792 5.792a.5.5 0 0 1 0 .708Z' }, child: [] }] })(props);
}

export function TiFlowChildren(props) {
  return GenIcon({ tag: 'svg', attr: { version: '1.2', baseProfile: 'tiny', viewBox: '0 0 24 24' }, child: [{ tag: 'path', attr: { d: 'M17 16c-1.305 0-2.403.837-2.816 2h-3.184c-1.654 0-3-1.346-3-3v-3.025c.838.634 1.87 1.025 3 1.025h3.184c.413 1.163 1.512 2 2.816 2 1.657 0 3-1.343 3-3s-1.343-3-3-3c-1.305 0-2.403.837-2.816 2h-3.184c-1.654 0-3-1.346-3-3v-.184c1.163-.413 2-1.512 2-2.816 0-1.657-1.343-3-3-3s-3 1.343-3 3c0 1.304.837 2.403 2 2.816v7.184c0 2.757 2.243 5 5 5h3.184c.413 1.163 1.512 2 2.816 2 1.657 0 3-1.343 3-3s-1.343-3-3-3zm0-5c.552 0 1 .449 1 1s-.448 1-1 1-1-.449-1-1 .448-1 1-1zm-10-7c.552 0 1 .449 1 1s-.448 1-1 1-1-.449-1-1 .448-1 1-1zm10 16c-.552 0-1-.449-1-1s.448-1 1-1 1 .449 1 1-.448 1-1 1z' }, child: [] }] })(props);
}

export function MdCheck(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'path', attr: { d: 'M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' }, child: [] }
    ]
  })(props);
}

export function MdOutlineClose(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0V0z' }, child: [] },
      { tag: 'path', attr: { d: 'M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z' }, child: [] }
    ]
  })(props);
}

export function BsPin(props) {
  return GenIcon({ tag: 'svg', attr: { fill: 'currentColor', viewBox: '0 0 16 16' }, child: [{ tag: 'path', attr: { d: 'M4.146.146A.5.5 0 0 1 4.5 0h7a.5.5 0 0 1 .5.5c0 .68-.342 1.174-.646 1.479-.126.125-.25.224-.354.298v4.431l.078.048c.203.127.476.314.751.555C12.36 7.775 13 8.527 13 9.5a.5.5 0 0 1-.5.5h-4v4.5c0 .276-.224 1.5-.5 1.5s-.5-1.224-.5-1.5V10h-4a.5.5 0 0 1-.5-.5c0-.973.64-1.725 1.17-2.189A6 6 0 0 1 5 6.708V2.277a3 3 0 0 1-.354-.298C4.342 1.674 4 1.179 4 .5a.5.5 0 0 1 .146-.354m1.58 1.408-.002-.001zm-.002-.001.002.001A.5.5 0 0 1 6 2v5a.5.5 0 0 1-.276.447h-.002l-.012.007-.054.03a5 5 0 0 0-.827.58c-.318.278-.585.596-.725.936h7.792c-.14-.34-.407-.658-.725-.936a5 5 0 0 0-.881-.61l-.012-.006h-.002A.5.5 0 0 1 10 7V2a.5.5 0 0 1 .295-.458 1.8 1.8 0 0 0 .351-.271c.08-.08.155-.17.214-.271H5.14q.091.15.214.271a1.8 1.8 0 0 0 .37.282' }, child: [] }] })(props);
}

export function PiLightning(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 256 256', fill: 'currentColor' }, child: [{ tag: 'path', attr: { d: 'M215.79,118.17a8,8,0,0,0-5-5.66L153.18,90.9l14.66-73.33a8,8,0,0,0-13.69-7l-112,120a8,8,0,0,0,3,13l57.63,21.61L88.16,238.43a8,8,0,0,0,13.69,7l112-120A8,8,0,0,0,215.79,118.17ZM109.37,214l10.47-52.38a8,8,0,0,0-5-9.06L62,132.71l84.62-90.66L136.16,94.43a8,8,0,0,0,5,9.06l52.8,19.8Z' }, child: [] }] })(props);
}

export function FaFire(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 384 512' }, child: [{ tag: 'path', attr: { d: 'M216 23.86c0-23.8-30.65-32.77-44.15-13.04C48 191.85 224 200 224 288c0 35.63-29.11 64.46-64.85 63.99-35.17-.45-63.15-29.77-63.15-64.94v-85.51c0-21.7-26.47-32.23-41.43-16.5C27.8 213.16 0 261.33 0 320c0 105.87 86.13 192 192 192s192-86.13 192-192c0-170.29-168-193-168-296.14z' }, child: [] }] })(props);
}

export function TbCategoryPlus(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }, child: [{ tag: 'path', attr: { d: 'M4 4h6v6h-6zm10 0h6v6h-6zm-10 10h6v6h-6zm10 3h6m-3 -3v6' }, child: [] }] })(props);
}

export function FaInbox(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 576 512' }, child: [{ tag: 'path', attr: { d: 'M567.938 243.908L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L8.062 243.908A47.994 47.994 0 0 0 0 270.533V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V270.533a47.994 47.994 0 0 0-8.062-26.625zM162.252 128h251.497l85.333 128H376l-32 64H232l-32-64H76.918l85.334-128z' }, child: [] }] })(props);
}

export function AiOutlineMenuUnfold(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 1024 1024' }, child: [{ tag: 'path', attr: { d: 'M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 0 0 0-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0 0 14.4 7z' }, child: [] }] })(props);
}

export function MdOutlineJoinFull(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'ellipse', attr: { cx: '12', cy: '12', rx: '3', ry: '5.74' }, child: [] },
      { tag: 'path', attr: { d: 'M7.5 12c0-.97.23-4.16 3.03-6.5C9.75 5.19 8.9 5 8 5c-3.86 0-7 3.14-7 7s3.14 7 7 7c.9 0 1.75-.19 2.53-.5-2.8-2.34-3.03-5.53-3.03-6.5zM16 5c-.9 0-1.75.19-2.53.5 2.8 2.34 3.03 5.53 3.03 6.5 0 .97-.23 4.16-3.03 6.5.78.31 1.63.5 2.53.5 3.86 0 7-3.14 7-7s-3.14-7-7-7z' }, child: [] }
    ]
  })(props);
}

export function MdOutlineJoinLeft(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'ellipse', attr: { cx: '12', cy: '12', rx: '3', ry: '5.74' }, child: [] },
      { tag: 'path', attr: { d: 'M7.5 12c0-.97.23-4.16 3.03-6.5C9.75 5.19 8.9 5 8 5c-3.86 0-7 3.14-7 7s3.14 7 7 7c.9 0 1.75-.19 2.53-.5-2.8-2.34-3.03-5.53-3.03-6.5zM16 5c-.9 0-1.75.19-2.53.5.61.51 1.1 1.07 1.49 1.63.33-.08.68-.13 1.04-.13 2.76 0 5 2.24 5 5s-2.24 5-5 5c-.36 0-.71-.05-1.04-.13-.39.56-.88 1.12-1.49 1.63.78.31 1.63.5 2.53.5 3.86 0 7-3.14 7-7s-3.14-7-7-7z' }, child: [] }
    ]
  })(props);
}

export function MdOutlineJoinRight(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'ellipse', attr: { cx: '12', cy: '12', rx: '3', ry: '5.74' }, child: [] },
      { tag: 'path', attr: { d: 'M16.5 12c0 .97-.23 4.16-3.03 6.5.78.31 1.63.5 2.53.5 3.86 0 7-3.14 7-7s-3.14-7-7-7c-.9 0-1.75.19-2.53.5 2.8 2.34 3.03 5.53 3.03 6.5zM8 19c.9 0 1.75-.19 2.53-.5-.61-.51-1.1-1.07-1.49-1.63-.33.08-.68.13-1.04.13-2.76 0-5-2.24-5-5s2.24-5 5-5c.36 0 .71.05 1.04.13.39-.56.88-1.12 1.49-1.63C9.75 5.19 8.9 5 8 5c-3.86 0-7 3.14-7 7s3.14 7 7 7z' }, child: [] }
    ]
  })(props);
}

export function MdLink(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'path', attr: { d: 'M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z' }, child: [] }
    ]
  })(props);
}

export function MdSend(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'path', attr: { d: 'M2.01 21 23 12 2.01 3 2 10l15 2-15 2z' }, child: [] }
    ]
  })(props);
}

export function FiClipboard(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2' }, child: [] },
      { tag: 'rect', attr: { x: '8', y: '2', width: '8', height: '4', rx: '1', ry: '1' }, child: [] }
    ]
  })(props);
}

export function MdEmail(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'path', attr: { d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z' }, child: [] }
    ]
  })(props);
}

export function FiMenu(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'line', attr: { x1: '3', y1: '12', x2: '21', y2: '12' }, child: [] },
      { tag: 'line', attr: { x1: '3', y1: '6', x2: '21', y2: '6' }, child: [] },
      { tag: 'line', attr: { x1: '3', y1: '18', x2: '21', y2: '18' }, child: [] }
    ]
  })(props);
}

export function BiShieldAlt2(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24' }, child: [{ tag: 'path', attr: { d: 'M21.438 5.089a1.002 1.002 0 0 0-.959.015c-.684.389-1.355.577-2.053.577-2.035 0-3.952-1.629-5.722-3.39-.375-.373-1.063-.373-1.438 0C9.592 3.959 7.598 5.663 5.51 5.663c-.69 0-1.351-.184-2.018-.561-.298-.166-.658-.171-.96-.012s-.501.461-.528.801c-.011.129-.944 12.872 9.683 16.041a.99.99 0 0 0 .286.042H12c.097 0 .192-.014.285-.041 10.657-3.17 9.695-15.916 9.684-16.044a1 1 0 0 0-.531-.8zm-9.452 14.842c-6.979-2.255-7.934-9.412-8.014-12.477.505.14 1.019.209 1.537.209 2.492 0 4.65-1.567 6.476-3.283 1.893 1.788 3.983 3.301 6.442 3.301.53 0 1.057-.074 1.575-.22-.074 3.065-1.021 10.217-8.016 12.47z' }, child: [] }] })(props);
}

export function MdOutlineScreenRotationAlt(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'path', attr: { d: 'm4 7.59 5-5c.78-.78 2.05-.78 2.83 0L20.24 11h-2.83L10.4 4 5.41 9H8v2H2V5h2v2.59zM20 19h2v-6h-6v2h2.59l-4.99 5-7.01-7H3.76l8.41 8.41c.78.78 2.05.78 2.83 0l5-5V19z' }, child: [] }
    ]
  })(props);
}

export function RiRobot2Line(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24', fill: 'currentColor' }, child: [{ tag: 'path', attr: { d: 'M13.5 2C13.5 2.44425 13.3069 2.84339 13 3.11805V5H18C19.6569 5 21 6.34315 21 8V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V8C3 6.34315 4.34315 5 6 5H11V3.11805C10.6931 2.84339 10.5 2.44425 10.5 2C10.5 1.17157 11.1716 0.5 12 0.5C12.8284 0.5 13.5 1.17157 13.5 2ZM6 7C5.44772 7 5 7.44772 5 8V18C5 18.5523 5.44772 19 6 19H18C18.5523 19 19 18.5523 19 18V8C19 7.44772 18.5523 7 18 7H13H11H6ZM2 10H0V16H2V10ZM22 10H24V16H22V10ZM9 14.5C9.82843 14.5 10.5 13.8284 10.5 13C10.5 12.1716 9.82843 11.5 9 11.5C8.17157 11.5 7.5 12.1716 7.5 13C7.5 13.8284 8.17157 14.5 9 14.5ZM15 14.5C15.8284 14.5 16.5 13.8284 16.5 13C16.5 12.1716 15.8284 11.5 15 11.5C14.1716 11.5 13.5 12.1716 13.5 13C13.5 13.8284 14.1716 14.5 15 14.5Z' }, child: [] }] })(props);
}

export function BiListCheck(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24' }, child: [{ tag: 'path', attr: { d: 'M4 7h11v2H4zm0 4h11v2H4zm0 4h7v2H4zm15.299-2.708-4.3 4.291-1.292-1.291-1.414 1.415 2.706 2.704 5.712-5.703z' }, child: [] }] })(props);
}

export function MdMoreVert(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'path', attr: { d: 'M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' }, child: [] }
    ]
  })(props);
}

export function BiLink(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { d: 'M8.465 11.293c1.133-1.133 3.109-1.133 4.242 0l.707.707 1.414-1.414-.707-.707c-.943-.944-2.199-1.465-3.535-1.465s-2.592.521-3.535 1.465L4.929 12a5.008 5.008 0 0 0 0 7.071 4.983 4.983 0 0 0 3.535 1.462A4.982 4.982 0 0 0 12 19.071l.707-.707-1.414-1.414-.707.707a3.007 3.007 0 0 1-4.243 0 3.005 3.005 0 0 1 0-4.243l2.122-2.121z' }, child: [] },
      { tag: 'path', attr: { d: 'm12 4.929-.707.707 1.414 1.414.707-.707a3.007 3.007 0 0 1 4.243 0 3.005 3.005 0 0 1 0 4.243l-2.122 2.121c-1.133 1.133-3.109 1.133-4.242 0L10.586 12l-1.414 1.414.707.707c.943.944 2.199 1.465 3.535 1.465s2.592-.521 3.535-1.465L19.071 12a5.008 5.008 0 0 0 0-7.071 5.006 5.006 0 0 0-7.071 0z' }, child: [] }
    ]
  })(props);
}

export function TbCircleDashedPlus(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M8.56 3.69a9 9 0 0 0 -2.92 1.95' }, child: [] },
      { tag: 'path', attr: { d: 'M3.69 8.56a9 9 0 0 0 -.69 3.44' }, child: [] },
      { tag: 'path', attr: { d: 'M3.69 15.44a9 9 0 0 0 1.95 2.92' }, child: [] },
      { tag: 'path', attr: { d: 'M8.56 20.31a9 9 0 0 0 3.44 .69' }, child: [] },
      { tag: 'path', attr: { d: 'M15.44 20.31a9 9 0 0 0 2.92 -1.95' }, child: [] },
      { tag: 'path', attr: { d: 'M20.31 15.44a9 9 0 0 0 .69 -3.44' }, child: [] },
      { tag: 'path', attr: { d: 'M20.31 8.56a9 9 0 0 0 -1.95 -2.92' }, child: [] },
      { tag: 'path', attr: { d: 'M15.44 3.69a9 9 0 0 0 -3.44 -.69' }, child: [] },
      { tag: 'path', attr: { d: 'M9 12h6' }, child: [] },
      { tag: 'path', attr: { d: 'M12 9v6' }, child: [] }
    ]
  })(props);
}

export function VscClearAll(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 16 16', fill: 'currentColor' }, child: [{ tag: 'path', attr: { d: 'M10 12.6l.7.7 1.6-1.6 1.6 1.6.8-.7L13 11l1.7-1.6-.8-.8-1.6 1.7-1.6-1.7-.7.8 1.6 1.6-1.6 1.6zM1 4h14V3H1v1zm0 3h14V6H1v1zm8 2.5V9H1v1h8v-.5zM9 13v-1H1v1h8z' }, child: [] }] })(props);
}

export function MdOutlineJoinInner(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'ellipse', attr: { cx: '12', cy: '12', rx: '3', ry: '5.74' }, child: [] },
      { tag: 'path', attr: { d: 'M9.04 16.87c-.33.08-.68.13-1.04.13-2.76 0-5-2.24-5-5s2.24-5 5-5c.36 0 .71.05 1.04.13.39-.56.88-1.12 1.49-1.63C9.75 5.19 8.9 5 8 5c-3.86 0-7 3.14-7 7s3.14 7 7 7c.9 0 1.75-.19 2.53-.5-.61-.51-1.1-1.07-1.49-1.63zM16 5c-.9 0-1.75.19-2.53.5.61.51 1.1 1.07 1.49 1.63.33-.08.68-.13 1.04-.13 2.76 0 5 2.24 5 5s-2.24 5-5 5c-.36 0-.71-.05-1.04-.13-.39.56-.88 1.12-1.49 1.63.78.31 1.63.5 2.53.5 3.86 0 7-3.14 7-7s-3.14-7-7-7z' }, child: [] }
    ]
  })(props);
}

export function FiArrowUpCircle(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'circle', attr: { cx: '12', cy: '12', r: '10' }, child: [] },
      { tag: 'polyline', attr: { points: '16 12 12 8 8 12' }, child: [] },
      { tag: 'line', attr: { x1: '12', y1: '16', x2: '12', y2: '8' }, child: [] }
    ]
  })(props);
}

export function TbFishHook(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M16 9v6a5 5 0 0 1 -10 0v-4l3 3' }, child: [] },
      { tag: 'path', attr: { d: 'M16 7m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0' }, child: [] },
      { tag: 'path', attr: { d: 'M16 5v-2' }, child: [] }
    ]
  })(props);
}

export function TbFlame(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }, child: [{ tag: 'path', attr: { d: 'M12 10.941c2.333 -3.308 .167 -7.823 -1 -8.941c0 3.395 -2.235 5.299 -3.667 6.706c-1.43 1.408 -2.333 3.621 -2.333 5.588c0 3.704 3.134 6.706 7 6.706s7 -3.002 7 -6.706c0 -1.712 -1.232 -4.403 -2.333 -5.588c-2.084 3.353 -3.257 3.353 -4.667 2.235' }, child: [] }] })(props);
}

export function MdDeveloperMode(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'path', attr: { d: 'M7 5h10v2h2V3c0-1.1-.9-1.99-2-1.99L7 1c-1.1 0-2 .9-2 2v4h2V5zm8.41 11.59L20 12l-4.59-4.59L14 8.83 17.17 12 14 15.17l1.41 1.42zM10 15.17 6.83 12 10 8.83 8.59 7.41 4 12l4.59 4.59L10 15.17zM17 19H7v-2H5v4c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-4h-2v2z' }, child: [] }
    ]
  })(props);
}

export function PiQueueBold(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 256 256', fill: 'currentColor' }, child: [{ tag: 'path', attr: { d: 'M28,64A12,12,0,0,1,40,52H216a12,12,0,0,1,0,24H40A12,12,0,0,1,28,64Zm104,52H40a12,12,0,0,0,0,24h92a12,12,0,0,0,0-24Zm0,64H40a12,12,0,0,0,0,24h92a12,12,0,0,0,0-24Zm120-20a12,12,0,0,1-5.64,10.18l-64,40A12,12,0,0,1,164,200V120a12,12,0,0,1,18.36-10.18l64,40A12,12,0,0,1,252,160Zm-34.64,0L188,141.65v36.7Z' }, child: [] }] })(props);
}

export function FiEye(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z' }, child: [] },
      { tag: 'circle', attr: { cx: '12', cy: '12', r: '3' }, child: [] }
    ]
  })(props);
}

export function FiEyeOff(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24' }, child: [] },
      { tag: 'line', attr: { x1: '1', y1: '1', x2: '23', y2: '23' }, child: [] }
    ]
  })(props);
}

export function GrCircleQuestion(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24' }, child: [{ tag: 'path', attr: { fill: 'none', strokeWidth: '2', d: 'M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M12,15 L12,14 C12,13 12,12.5 13,12 C14,11.5 15,11 15,9.5 C15,8.5 14,7 12,7 C10,7 9,8.26413718 9,10 M12,16 L12,18' }, child: [] }] })(props);
}

export function TbWeight(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M12 6m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0' }, child: [] },
      { tag: 'path', attr: { d: 'M6.835 9h10.33a1 1 0 0 1 .984 .821l1.637 9a1 1 0 0 1 -.984 1.179h-13.604a1 1 0 0 1 -.984 -1.179l1.637 -9a1 1 0 0 1 .984 -.821z' }, child: [] }
    ]
  })(props);
}

export function TbSlash(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }, child: [{ tag: 'path', attr: { d: 'M17 5l-10 14' }, child: [] }] })(props);
}

export function FiFileText(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z' }, child: [] },
      { tag: 'polyline', attr: { points: '14 2 14 8 20 8' }, child: [] },
      { tag: 'line', attr: { x1: '16', y1: '13', x2: '8', y2: '13' }, child: [] },
      { tag: 'line', attr: { x1: '16', y1: '17', x2: '8', y2: '17' }, child: [] },
      { tag: 'polyline', attr: { points: '10 9 9 9 8 9' }, child: [] }
    ]
  })(props);
}

export function MdLock(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'path', attr: { d: 'M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z' }, child: [] }
    ]
  })(props);
}

export function MdLockOpen(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'path', attr: { d: 'M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10z' }, child: [] }
    ]
  })(props);
}

export function MdContentCopy(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'path', attr: { d: 'M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z' }, child: [] }
    ]
  })(props);
}

export function MdBackHand(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'path', attr: { d: 'M13 24c-3.26 0-6.19-1.99-7.4-5.02l-3.03-7.61a1 1 0 0 1 1.24-1.32l.79.26c.56.18 1.02.61 1.24 1.16L7.25 15H8V3.25a1.25 1.25 0 0 1 2.5 0V12h1V1.25a1.25 1.25 0 0 1 2.5 0V12h1V2.75a1.25 1.25 0 0 1 2.5 0V12h1V5.75a1.25 1.25 0 0 1 2.5 0V16c0 4.42-3.58 8-8 8z' }, child: [] }
    ]
  })(props);
}

export function FiGlobe(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'circle', attr: { cx: '12', cy: '12', r: '10' }, child: [] },
      { tag: 'line', attr: { x1: '2', y1: '12', x2: '22', y2: '12' }, child: [] },
      { tag: 'path', attr: { d: 'M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z' }, child: [] }
    ]
  })(props);
}

export function TbArrowRight(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M5 12l14 0' }, child: [] },
      { tag: 'path', attr: { d: 'M13 18l6 -6' }, child: [] },
      { tag: 'path', attr: { d: 'M13 6l6 6' }, child: [] }
    ]
  })(props);
}

export function TbArrowsHorizontal(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M7 8l-4 4l4 4' }, child: [] },
      { tag: 'path', attr: { d: 'M17 8l4 4l-4 4' }, child: [] },
      { tag: 'path', attr: { d: 'M3 12l18 0' }, child: [] }
    ]
  })(props);
}

export function IoSend(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 512 512' }, child: [{ tag: 'path', attr: { d: 'm476.59 227.05-.16-.07L49.35 49.84A23.56 23.56 0 0 0 27.14 52 24.65 24.65 0 0 0 16 72.59v113.29a24 24 0 0 0 19.52 23.57l232.93 43.07a4 4 0 0 1 0 7.86L35.53 303.45A24 24 0 0 0 16 327v113.31A23.57 23.57 0 0 0 26.59 460a23.94 23.94 0 0 0 13.22 4 24.55 24.55 0 0 0 9.52-1.93L476.4 285.94l.19-.09a32 32 0 0 0 0-58.8z' }, child: [] }] })(props);
}

export function FaTrash(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 448 512' }, child: [{ tag: 'path', attr: { d: 'M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z' }, child: [] }] })(props);
}

export function MdOutlineAutoAwesome(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'path', attr: { d: 'm19 9 1.25-2.75L23 5l-2.75-1.25L19 1l-1.25 2.75L15 5l2.75 1.25zM19 15l-1.25 2.75L15 19l2.75 1.25L19 23l1.25-2.75L23 19l-2.75-1.25zM11.5 9.5 9 4 6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12l-5.5-2.5zm-1.51 3.49L9 15.17l-.99-2.18L5.83 12l2.18-.99L9 8.83l.99 2.18 2.18.99-2.18.99z' }, child: [] }
    ]
  })(props);
}

export function TbFileTypeXml(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M14 3v4a1 1 0 0 0 1 1h4' }, child: [] },
      { tag: 'path', attr: { d: 'M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4' }, child: [] },
      { tag: 'path', attr: { d: 'M4 15l4 6' }, child: [] },
      { tag: 'path', attr: { d: 'M4 21l4 -6' }, child: [] },
      { tag: 'path', attr: { d: 'M19 15v6h3' }, child: [] },
      { tag: 'path', attr: { d: 'M11 21v-6l2.5 3l2.5 -3v6' }, child: [] }
    ]
  })(props);
}

export function TbJson(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M20 16v-8l3 8v-8' }, child: [] },
      { tag: 'path', attr: { d: 'M15 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z' }, child: [] },
      { tag: 'path', attr: { d: 'M1 8h3v6.5a1.5 1.5 0 0 1 -3 0v-.5' }, child: [] },
      { tag: 'path', attr: { d: 'M7 15a1 1 0 0 0 1 1h1a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h1a1 1 0 0 1 1 1' }, child: [] }
    ]
  })(props);
}

export function IoTextOutline(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 512 512' },
    child: [
      { tag: 'path', attr: { fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '32', d: 'm32 415.5 120-320 120 320m-42-112H74m252-64c12.19-28.69 41-48 74-48h0c46 0 80 32 80 80v144' }, child: [] },
      { tag: 'path', attr: { fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '32', d: 'M320 358.5c0 36 26.86 58 60 58 54 0 100-27 100-106v-15c-20 0-58 1-92 5-32.77 3.86-68 19-68 58z' }, child: [] }
    ]
  })(props);
}

export function PiBinary(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 256 256', fill: 'currentColor' }, child: [{ tag: 'path', attr: { d: 'M94,24C71.63,24,56,43.74,56,72s15.63,48,38,48,38-19.74,38-48S116.37,24,94,24Zm0,80c-17.37,0-22-20.11-22-32s4.63-32,22-32,22,20.11,22,32S111.37,104,94,104Zm72,32c-22.37,0-38,19.74-38,48s15.63,48,38,48,38-19.74,38-48S188.37,136,166,136Zm0,80c-17.37,0-22-20.11-22-32s4.63-32,22-32,22,20.11,22,32S183.37,216,166,216ZM145,49.22a8,8,0,0,1,3.11-10.88l24-13.33A8,8,0,0,1,184,32v80a8,8,0,0,1-16,0V45.6l-12.12,6.73A8,8,0,0,1,145,49.22ZM104,144v80a8,8,0,0,1-16,0V157.6l-12.12,6.73a8,8,0,0,1-7.76-14l24-13.33A8,8,0,0,1,104,144Z' }, child: [] }] })(props);
}

export function MdOutlineDisplaySettings(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'path', attr: { d: 'M20 3H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h4v2h8v-2h4c1.1 0 2-.9 2-2V5a2 2 0 0 0-2-2zm0 14H4V5h16v12z' }, child: [] },
      { tag: 'path', attr: { d: 'M6 8.25h8v1.5H6zM16.5 9.75H18v-1.5h-1.5V7H15v4h1.5zM10 12.25h8v1.5h-8zM7.5 15H9v-4H7.5v1.25H6v1.5h1.5z' }, child: [] }
    ]
  })(props);
}

export function MdOutlineCategory(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0V0z' }, child: [] },
      { tag: 'path', attr: { d: 'm12 2-5.5 9h11L12 2zm0 3.84L13.93 9h-3.87L12 5.84zM17.5 13c-2.49 0-4.5 2.01-4.5 4.5s2.01 4.5 4.5 4.5 4.5-2.01 4.5-4.5-2.01-4.5-4.5-4.5zm0 7a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5zM3 21.5h8v-8H3v8zm2-6h4v4H5v-4z' }, child: [] }
    ]
  })(props);
}

export function MdOutlineCloudDone(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0V0z' }, child: [] },
      { tag: 'path', attr: { d: 'M19.35 10.04A7.49 7.49 0 0 0 12 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 0 0 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95A5.469 5.469 0 0 1 12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11A2.98 2.98 0 0 1 22 15c0 1.65-1.35 3-3 3zm-9-3.82-2.09-2.09L6.5 13.5 10 17l6.01-6.01-1.41-1.41z' }, child: [] }
    ]
  })(props);
}

export function FiTrendingUp(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'polyline', attr: { points: '23 6 13.5 15.5 8.5 10.5 1 18' }, child: [] },
      { tag: 'polyline', attr: { points: '17 6 23 6 23 12' }, child: [] }
    ]
  })(props);
}

export function FiGrid(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'rect', attr: { x: '3', y: '3', width: '7', height: '7' }, child: [] },
      { tag: 'rect', attr: { x: '14', y: '3', width: '7', height: '7' }, child: [] },
      { tag: 'rect', attr: { x: '14', y: '14', width: '7', height: '7' }, child: [] },
      { tag: 'rect', attr: { x: '3', y: '14', width: '7', height: '7' }, child: [] }
    ]
  })(props);
}

export function FiTag(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z' }, child: [] },
      { tag: 'line', attr: { x1: '7', y1: '7', x2: '7.01', y2: '7' }, child: [] }
    ]
  })(props);
}

export function LuBookMarked(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M10 2v8l3-3 3 3V2' }, child: [] },
      { tag: 'path', attr: { d: 'M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20' }, child: [] }
    ]
  })(props);
}

export function FiRotateCw(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'polyline', attr: { points: '23 4 23 10 17 10' }, child: [] },
      { tag: 'path', attr: { d: 'M20.49 15a9 9 0 1 1-2.12-9.36L23 10' }, child: [] }
    ]
  })(props);
}

export function LuArrowUpDown(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'm21 16-4 4-4-4' }, child: [] },
      { tag: 'path', attr: { d: 'M17 20V4' }, child: [] },
      { tag: 'path', attr: { d: 'm3 8 4-4 4 4' }, child: [] },
      { tag: 'path', attr: { d: 'M7 4v16' }, child: [] }
    ]
  })(props);
}

export function PiSlackLogo(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 256 256', fill: 'currentColor' }, child: [{ tag: 'path', attr: { d: 'M221.13,128A32,32,0,0,0,184,76.31V56a32,32,0,0,0-56-21.13A32,32,0,0,0,76.31,72H56a32,32,0,0,0-21.13,56A32,32,0,0,0,72,179.69V200a32,32,0,0,0,56,21.13A32,32,0,0,0,179.69,184H200a32,32,0,0,0,21.13-56ZM72,152a16,16,0,1,1-16-16H72Zm48,48a16,16,0,0,1-32,0V152a16,16,0,0,1,16-16h16Zm0-80H56a16,16,0,0,1,0-32h48a16,16,0,0,1,16,16Zm0-48H104a16,16,0,1,1,16-16Zm16-16a16,16,0,0,1,32,0v48a16,16,0,0,1-16,16H136Zm16,160a16,16,0,0,1-16-16V184h16a16,16,0,0,1,0,32Zm48-48H152a16,16,0,0,1-16-16V136h64a16,16,0,0,1,0,32Zm0-48H184V104a16,16,0,1,1,16,16Z' }, child: [] }] })(props);
}

export function FiBook(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M4 19.5A2.5 2.5 0 0 1 6.5 17H20' }, child: [] },
      { tag: 'path', attr: { d: 'M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z' }, child: [] }
    ]
  })(props);
}

export function MdOutlineArrowOutward(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'path', attr: { d: 'M6 6v2h8.59L5 17.59 6.41 19 16 9.41V18h2V6z' }, child: [] }
    ]
  })(props);
}

export function AiOutlineSortAscending(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 1024 1024' }, child: [{ tag: 'path', attr: { d: 'M839.6 433.8L749 150.5a9.24 9.24 0 0 0-8.9-6.5h-77.4c-4.1 0-7.6 2.6-8.9 6.5l-91.3 283.3c-.3.9-.5 1.9-.5 2.9 0 5.1 4.2 9.3 9.3 9.3h56.4c4.2 0 7.8-2.8 9-6.8l17.5-61.6h89l17.3 61.5c1.1 4 4.8 6.8 9 6.8h61.2c1 0 1.9-.1 2.8-.4 2.4-.8 4.3-2.4 5.5-4.6 1.1-2.2 1.3-4.7.6-7.1zM663.3 325.5l32.8-116.9h6.3l32.1 116.9h-71.2zm143.5 492.9H677.2v-.4l132.6-188.9c1.1-1.6 1.7-3.4 1.7-5.4v-36.4c0-5.1-4.2-9.3-9.3-9.3h-204c-5.1 0-9.3 4.2-9.3 9.3v43c0 5.1 4.2 9.3 9.3 9.3h122.6v.4L587.7 828.9a9.35 9.35 0 0 0-1.7 5.4v36.4c0 5.1 4.2 9.3 9.3 9.3h211.4c5.1 0 9.3-4.2 9.3-9.3v-43a9.2 9.2 0 0 0-9.2-9.3zM416 702h-76V172c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v530h-76c-6.7 0-10.5 7.8-6.3 13l112 141.9a8 8 0 0 0 12.6 0l112-141.9c4.1-5.2.4-13-6.3-13z' }, child: [] }] })(props);
}

export function PiEmpty(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 256 256', fill: 'currentColor' }, child: [{ tag: 'path', attr: { d: 'M198.24,62.63l15.68-17.25a8,8,0,0,0-11.84-10.76L186.4,51.86A95.95,95.95,0,0,0,57.76,193.37L42.08,210.62a8,8,0,1,0,11.84,10.76L69.6,204.14A95.95,95.95,0,0,0,198.24,62.63ZM48,128A80,80,0,0,1,175.6,63.75l-107,117.73A79.63,79.63,0,0,1,48,128Zm80,80a79.55,79.55,0,0,1-47.6-15.75l107-117.73A79.95,79.95,0,0,1,128,208Z' }, child: [] }] })(props);
}

export function AiOutlineExperiment(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 1024 1024' }, child: [{ tag: 'path', attr: { d: 'M512 472a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm367 352.9L696.3 352V178H768v-68H256v68h71.7v174L145 824.9c-2.8 7.4-4.3 15.2-4.3 23.1 0 35.3 28.7 64 64 64h614.6c7.9 0 15.7-1.5 23.1-4.3 33-12.7 49.4-49.8 36.6-82.8zM395.7 364.7V180h232.6v184.7L719.2 600c-20.7-5.3-42.1-8-63.9-8-61.2 0-119.2 21.5-165.3 60a188.78 188.78 0 0 1-121.3 43.9c-32.7 0-64.1-8.3-91.8-23.7l118.8-307.5zM210.5 844l41.7-107.8c35.7 18.1 75.4 27.8 116.6 27.8 61.2 0 119.2-21.5 165.3-60 33.9-28.2 76.3-43.9 121.3-43.9 35 0 68.4 9.5 97.6 27.1L813.5 844h-603z' }, child: [] }] })(props);
}

export function AiOutlineKey(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 1024 1024' }, child: [{ tag: 'path', attr: { d: 'M608 112c-167.9 0-304 136.1-304 304 0 70.3 23.9 135 63.9 186.5L255.8 713.6l-62.3-62.3c-3.148-3.08-8.252-3.08-11.4 0l-39.8 39.8c-3.08 3.148-3.08 8.252 0 11.4l62.3 62.3-44.9 44.9-62.3-62.3c-3.148-3.08-8.252-3.08-11.4 0l-39.8 39.8c-3.08 3.148-3.08 8.252 0 11.4l110.3 111.2c3.1 3.1 8.2 3.1 11.3 0l253.6-253.6A304.1 304.1 0 0 0 608 720c167.9 0 304-136.1 304-304S775.9 112 608 112m161.2 465.2C726.2 620.3 668.9 644 608 644s-118.2-23.7-161.2-66.8C403.7 534.2 380 476.9 380 416s23.7-118.2 66.8-161.2c43-43.1 100.3-66.8 161.2-66.8s118.2 23.7 161.2 66.8c43.1 43 66.8 100.3 66.8 161.2s-23.7 118.2-66.8 161.2' }, child: [] }] })(props);
}

export function AiOutlineLock(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 1024 1024' }, child: [{ tag: 'path', attr: { d: 'M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM332 240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224H332V240zm460 600H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 1 0-56 0z' }, child: [] }] })(props);
}

export function AiOutlineSync(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 1024 1024' }, child: [{ tag: 'path', attr: { d: 'M168 504.2c1-43.7 10-86.1 26.9-126 17.3-41 42.1-77.7 73.7-109.4S337 212.3 378 195c42.4-17.9 87.4-27 133.9-27s91.5 9.1 133.8 27A341.5 341.5 0 0 1 755 268.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 0 0 3 14.1l175.7 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c0-6.7-7.7-10.5-12.9-6.3l-56.4 44.1C765.8 155.1 646.2 92 511.8 92 282.7 92 96.3 275.6 92 503.8a8 8 0 0 0 8 8.2h60c4.4 0 7.9-3.5 8-7.8zm756 7.8h-60c-4.4 0-7.9 3.5-8 7.8-1 43.7-10 86.1-26.9 126-17.3 41-42.1 77.8-73.7 109.4A342.45 342.45 0 0 1 512.1 856a342.24 342.24 0 0 1-243.2-100.8c-9.9-9.9-19.2-20.4-27.8-31.4l60.2-47a8 8 0 0 0-3-14.1l-175.7-43c-5-1.2-9.9 2.6-9.9 7.7l-.7 181c0 6.7 7.7 10.5 12.9 6.3l56.4-44.1C258.2 868.9 377.8 932 512.2 932c229.2 0 415.5-183.7 419.8-411.8a8 8 0 0 0-8-8.2z' }, child: [] }] })(props);
}

export function MdOutlineDoorFront(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0V0z' }, child: [] },
      { tag: 'path', attr: { d: 'M19 19V5c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v14H3v2h18v-2h-2zm-2 0H7V5h10v14zm-4-8h2v2h-2v-2z' }, child: [] }
    ]
  })(props);
}

export function AiOutlineFileText(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 1024 1024' }, child: [{ tag: 'path', attr: { d: 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM504 618H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM312 490v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8z' }, child: [] }] })(props);
}

export function AiOutlineContainer(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 1024 1024' }, child: [{ tag: 'path', attr: { d: 'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V687h97.9c11.6 32.8 32 62.3 59.1 84.7 34.5 28.5 78.2 44.3 123 44.3s88.5-15.7 123-44.3c27.1-22.4 47.5-51.9 59.1-84.7H792v-63H643.6l-5.2 24.7C626.4 708.5 573.2 752 512 752s-114.4-43.5-126.5-103.3l-5.2-24.7H232V136h560v752zM320 341h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 160h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z' }, child: [] }] })(props);
}

export function AiOutlineProduct(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 1024 1024', fill: 'currentColor', fillRule: 'evenodd' }, child: [{ tag: 'path', attr: { d: 'M320 30.02c8.837 0 16 7.163 16 16v304c0 8.836-7.163 16-16 16H16c-8.837 0-16-7.164-16-16v-304c0-8.837 7.163-16 16-16zm-52 68H68v200h200zm493.333 87.686c6.248 6.248 6.248 16.379 0 22.627l-181.02 181.02c-6.248 6.248-16.378 6.248-22.627 0l-181.019-181.02c-6.248-6.248-6.248-16.379 0-22.627l181.02-181.02c6.248-6.248 16.378-6.248 22.627 0zm-84.853 11.313L569 89.54 461.52 197.02 569 304.5zM320 430.02c8.837 0 16 7.164 16 16v304c0 8.837-7.163 16-16 16H16c-8.837 0-16-7.163-16-16v-304c0-8.836 7.163-16 16-16zm-52 68H68v200h200zm452-68c8.837 0 16 7.164 16 16v304c0 8.837-7.163 16-16 16H416c-8.837 0-16-7.163-16-16v-304c0-8.836 7.163-16 16-16zm-52 68H468v200h200z', transform: 'translate(144 113.98)' }, child: [] }] })(props);
}

export function AiOutlineApi(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 1024 1024' }, child: [{ tag: 'path', attr: { d: 'M917.7 148.8l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 0 0-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 0 0 0 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM769.1 441.7l-59.4 59.4-186.8-186.8 59.4-59.4c24.9-24.9 58.1-38.7 93.4-38.7 35.3 0 68.4 13.7 93.4 38.7 24.9 24.9 38.7 58.1 38.7 93.4 0 35.3-13.8 68.4-38.7 93.4zm-190.2 105a8.03 8.03 0 0 0-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 0 0-11.3 0L363 475.3l-43-43a7.85 7.85 0 0 0-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2c-68.9 69-77 175.7-24.3 253.5l-76.1 76.1a8.03 8.03 0 0 0 0 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2zM441.7 769.1a131.32 131.32 0 0 1-93.4 38.7c-35.3 0-68.4-13.7-93.4-38.7a131.32 131.32 0 0 1-38.7-93.4c0-35.3 13.7-68.4 38.7-93.4l59.4-59.4 186.8 186.8-59.4 59.4z' }, child: [] }] })(props);
}

export function TbZzz(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M4 12h6l-6 8h6' }, child: [] },
      { tag: 'path', attr: { d: 'M14 4h6l-6 8h6' }, child: [] }
    ]
  })(props);
}

export function IoTimerOutline(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 512 512' },
    child: [
      { tag: 'path', attr: { fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '32', d: 'M112.91 128A191.85 191.85 0 0 0 64 254c-1.18 106.35 85.65 193.8 192 194 106.2.2 192-85.83 192-192 0-104.54-83.55-189.61-187.5-192a4.36 4.36 0 0 0-4.5 4.37V152' }, child: [] },
      { tag: 'path', attr: { d: 'm233.38 278.63-79-113a8.13 8.13 0 0 1 11.32-11.32l113 79a32.5 32.5 0 0 1-37.25 53.26 33.21 33.21 0 0 1-8.07-7.94z' }, child: [] }
    ]
  })(props);
}

export function TbHeartbeat(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M19.5 13.572l-7.5 7.428l-2.896 -2.868m-6.117 -8.104a5 5 0 0 1 9.013 -3.022a5 5 0 1 1 7.5 6.572' }, child: [] },
      { tag: 'path', attr: { d: 'M3 13h2l2 3l2 -6l1 3h3' }, child: [] }
    ]
  })(props);
}

export function AiOutlineGroup(props) {
  return GenIcon({
    tag: 'svg',
    attr: { t: '1569683739097', viewBox: '0 0 1024 1024', version: '1.1' },
    child: [
      { tag: 'path', attr: { d: 'M912 820.1V203.9c28-9.9 48-36.6 48-67.9 0-39.8-32.2-72-72-72-31.3 0-58 20-67.9 48H203.9C194 84 167.3 64 136 64c-39.8 0-72 32.2-72 72 0 31.3 20 58 48 67.9v616.2C84 830 64 856.7 64 888c0 39.8 32.2 72 72 72 31.3 0 58-20 67.9-48h616.2c9.9 28 36.6 48 67.9 48 39.8 0 72-32.2 72-72 0-31.3-20-58-48-67.9zM888 112c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zM136 912c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z m0-752c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z m704 680H184V184h656v656z m48 72c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z' }, child: [] },
      { tag: 'path', attr: { d: 'M288 474h448c8.8 0 16-7.2 16-16V282c0-8.8-7.2-16-16-16H288c-8.8 0-16 7.2-16 16v176c0 8.8 7.2 16 16 16z m56-136h336v64H344v-64zM288 758h448c8.8 0 16-7.2 16-16V566c0-8.8-7.2-16-16-16H288c-8.8 0-16 7.2-16 16v176c0 8.8 7.2 16 16 16z m56-136h336v64H344v-64z' }, child: [] }
    ]
  })(props);
}

export function FiMeh(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'circle', attr: { cx: '12', cy: '12', r: '10' }, child: [] },
      { tag: 'line', attr: { x1: '8', y1: '15', x2: '16', y2: '15' }, child: [] },
      { tag: 'line', attr: { x1: '9', y1: '9', x2: '9.01', y2: '9' }, child: [] },
      { tag: 'line', attr: { x1: '15', y1: '9', x2: '15.01', y2: '9' }, child: [] }
    ]
  })(props);
}

export function PiFiles(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 256 256', fill: 'currentColor' }, child: [{ tag: 'path', attr: { d: 'M213.66,66.34l-40-40A8,8,0,0,0,168,24H88A16,16,0,0,0,72,40V56H56A16,16,0,0,0,40,72V216a16,16,0,0,0,16,16H168a16,16,0,0,0,16-16V200h16a16,16,0,0,0,16-16V72A8,8,0,0,0,213.66,66.34ZM168,216H56V72h76.69L168,107.31v84.53c0,.06,0,.11,0,.16s0,.1,0,.16V216Zm32-32H184V104a8,8,0,0,0-2.34-5.66l-40-40A8,8,0,0,0,136,56H88V40h76.69L200,75.31Zm-56-32a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h48A8,8,0,0,1,144,152Zm0,32a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h48A8,8,0,0,1,144,184Z' }, child: [] }] })(props);
}

export function HiOutlineEmojiHappy(props) {
  return GenIcon({ tag: 'svg', attr: { fill: 'none', viewBox: '0 0 24 24', strokeWidth: '2', stroke: 'currentColor', 'aria-hidden': 'true' }, child: [{ tag: 'path', attr: { strokeLinecap: 'round', strokeLinejoin: 'round', d: 'M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z' }, child: [] }] })(props);
}

export function LuPartyPopper(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M5.8 11.3 2 22l10.7-3.79' }, child: [] },
      { tag: 'path', attr: { d: 'M4 3h.01' }, child: [] },
      { tag: 'path', attr: { d: 'M22 8h.01' }, child: [] },
      { tag: 'path', attr: { d: 'M15 2h.01' }, child: [] },
      { tag: 'path', attr: { d: 'M22 20h.01' }, child: [] },
      { tag: 'path', attr: { d: 'm22 2-2.24.75a2.9 2.9 0 0 0-1.96 3.12c.1.86-.57 1.63-1.45 1.63h-.38c-.86 0-1.6.6-1.76 1.44L14 10' }, child: [] },
      { tag: 'path', attr: { d: 'm22 13-.82-.33c-.86-.34-1.82.2-1.98 1.11c-.11.7-.72 1.22-1.43 1.22H17' }, child: [] },
      { tag: 'path', attr: { d: 'm11 2 .33.82c.34.86-.2 1.82-1.11 1.98C9.52 4.9 9 5.52 9 6.23V7' }, child: [] },
      { tag: 'path', attr: { d: 'M11 13c1.93 1.93 2.83 4.17 2 5-.83.83-3.07-.07-5-2-1.93-1.93-2.83-4.17-2-5 .83-.83 3.07.07 5 2Z' }, child: [] }
    ]
  })(props);
}

export function IoHomeOutline(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 512 512' },
    child: [
      { tag: 'path', attr: { fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '32', d: 'M80 212v236a16 16 0 0 0 16 16h96V328a24 24 0 0 1 24-24h80a24 24 0 0 1 24 24v136h96a16 16 0 0 0 16-16V212' }, child: [] },
      { tag: 'path', attr: { fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '32', d: 'M480 256 266.89 52c-5-5.28-16.69-5.34-21.78 0L32 256m368-77V64h-48v69' }, child: [] }
    ]
  })(props);
}

export function IoExtensionPuzzleOutline(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 512 512' }, child: [{ tag: 'path', attr: { fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '32', d: 'M413.66 246.1H386a2 2 0 0 1-2-2v-77.24A38.86 38.86 0 0 0 345.14 128H267.9a2 2 0 0 1-2-2V98.34c0-27.14-21.5-49.86-48.64-50.33a49.53 49.53 0 0 0-50.4 49.51V126a2 2 0 0 1-2 2H87.62A39.74 39.74 0 0 0 48 167.62V238a2 2 0 0 0 2 2h26.91c29.37 0 53.68 25.48 54.09 54.85.42 29.87-23.51 57.15-53.29 57.15H50a2 2 0 0 0-2 2v70.38A39.74 39.74 0 0 0 87.62 464H158a2 2 0 0 0 2-2v-20.93c0-30.28 24.75-56.35 55-57.06 30.1-.7 57 20.31 57 50.28V462a2 2 0 0 0 2 2h71.14A38.86 38.86 0 0 0 384 425.14v-78a2 2 0 0 1 2-2h28.48c27.63 0 49.52-22.67 49.52-50.4s-23.2-48.64-50.34-48.64z' }, child: [] }] })(props);
}

export function FiFile(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z' }, child: [] },
      { tag: 'polyline', attr: { points: '13 2 13 9 20 9' }, child: [] }
    ]
  })(props);
}

export function FiFolder(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }, child: [{ tag: 'path', attr: { d: 'M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z' }, child: [] }] })(props);
}

export function FiList(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'line', attr: { x1: '8', y1: '6', x2: '21', y2: '6' }, child: [] },
      { tag: 'line', attr: { x1: '8', y1: '12', x2: '21', y2: '12' }, child: [] },
      { tag: 'line', attr: { x1: '8', y1: '18', x2: '21', y2: '18' }, child: [] },
      { tag: 'line', attr: { x1: '3', y1: '6', x2: '3.01', y2: '6' }, child: [] },
      { tag: 'line', attr: { x1: '3', y1: '12', x2: '3.01', y2: '12' }, child: [] },
      { tag: 'line', attr: { x1: '3', y1: '18', x2: '3.01', y2: '18' }, child: [] }
    ]
  })(props);
}

export function FiMessageCircle(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }, child: [{ tag: 'path', attr: { d: 'M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z' }, child: [] }] })(props);
}

export function LuText(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M17 6.1H3' }, child: [] },
      { tag: 'path', attr: { d: 'M21 12.1H3' }, child: [] },
      { tag: 'path', attr: { d: 'M15.1 18H3' }, child: [] }
    ]
  })(props);
}

export function IoWarning(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 512 512' }, child: [{ tag: 'path', attr: { d: 'M449.07 399.08 278.64 82.58c-12.08-22.44-44.26-22.44-56.35 0L51.87 399.08A32 32 0 0 0 80 446.25h340.89a32 32 0 0 0 28.18-47.17zm-198.6-1.83a20 20 0 1 1 20-20 20 20 0 0 1-20 20zm21.72-201.15-5.74 122a16 16 0 0 1-32 0l-5.74-121.95a21.73 21.73 0 0 1 21.5-22.69h.21a21.74 21.74 0 0 1 21.73 22.7z' }, child: [] }] })(props);
}

export function FiExternalLink(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6' }, child: [] },
      { tag: 'polyline', attr: { points: '15 3 21 3 21 9' }, child: [] },
      { tag: 'line', attr: { x1: '10', y1: '14', x2: '21', y2: '3' }, child: [] }
    ]
  })(props);
}

export function FiDollarSign(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'line', attr: { x1: '12', y1: '1', x2: '12', y2: '23' }, child: [] },
      { tag: 'path', attr: { d: 'M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6' }, child: [] }
    ]
  })(props);
}

export function FiClock(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'circle', attr: { cx: '12', cy: '12', r: '10' }, child: [] },
      { tag: 'polyline', attr: { points: '12 6 12 12 16 14' }, child: [] }
    ]
  })(props);
}

export function FiUsers(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2' }, child: [] },
      { tag: 'circle', attr: { cx: '9', cy: '7', r: '4' }, child: [] },
      { tag: 'path', attr: { d: 'M23 21v-2a4 4 0 0 0-3-3.87' }, child: [] },
      { tag: 'path', attr: { d: 'M16 3.13a4 4 0 0 1 0 7.75' }, child: [] }
    ]
  })(props);
}

export function FiPackage(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'line', attr: { x1: '16.5', y1: '9.4', x2: '7.5', y2: '4.21' }, child: [] },
      { tag: 'path', attr: { d: 'M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z' }, child: [] },
      { tag: 'polyline', attr: { points: '3.27 6.96 12 12.01 20.73 6.96' }, child: [] },
      { tag: 'line', attr: { x1: '12', y1: '22.08', x2: '12', y2: '12' }, child: [] }
    ]
  })(props);
}

export function FiCreditCard(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'rect', attr: { x: '1', y: '4', width: '22', height: '16', rx: '2', ry: '2' }, child: [] },
      { tag: 'line', attr: { x1: '1', y1: '10', x2: '23', y2: '10' }, child: [] }
    ]
  })(props);
}

export function FiShoppingBag(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z' }, child: [] },
      { tag: 'line', attr: { x1: '3', y1: '6', x2: '21', y2: '6' }, child: [] },
      { tag: 'path', attr: { d: 'M16 10a4 4 0 0 1-8 0' }, child: [] }
    ]
  })(props);
}

export function FiTruck(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'rect', attr: { x: '1', y: '3', width: '15', height: '13' }, child: [] },
      { tag: 'polygon', attr: { points: '16 8 20 8 23 11 23 16 16 16 16 8' }, child: [] },
      { tag: 'circle', attr: { cx: '5.5', cy: '18.5', r: '2.5' }, child: [] },
      { tag: 'circle', attr: { cx: '18.5', cy: '18.5', r: '2.5' }, child: [] }
    ]
  })(props);
}

export function FiCalendar(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'rect', attr: { x: '3', y: '4', width: '18', height: '18', rx: '2', ry: '2' }, child: [] },
      { tag: 'line', attr: { x1: '16', y1: '2', x2: '16', y2: '6' }, child: [] },
      { tag: 'line', attr: { x1: '8', y1: '2', x2: '8', y2: '6' }, child: [] },
      { tag: 'line', attr: { x1: '3', y1: '10', x2: '21', y2: '10' }, child: [] }
    ]
  })(props);
}

export function FiMail(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z' }, child: [] },
      { tag: 'polyline', attr: { points: '22,6 12,13 2,6' }, child: [] }
    ]
  })(props);
}

export function FiAlertTriangle(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z' }, child: [] },
      { tag: 'line', attr: { x1: '12', y1: '9', x2: '12', y2: '13' }, child: [] },
      { tag: 'line', attr: { x1: '12', y1: '17', x2: '12.01', y2: '17' }, child: [] }
    ]
  })(props);
}

export function FiAlertOctagon(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'polygon', attr: { points: '7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2' }, child: [] },
      { tag: 'line', attr: { x1: '12', y1: '8', x2: '12', y2: '12' }, child: [] },
      { tag: 'line', attr: { x1: '12', y1: '16', x2: '12.01', y2: '16' }, child: [] }
    ]
  })(props);
}

export function BiDollarCircle(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { d: 'M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z' }, child: [] },
      { tag: 'path', attr: { d: 'M12 11c-2 0-2-.63-2-1s.7-1 2-1 1.39.64 1.4 1h2A3 3 0 0 0 13 7.12V6h-2v1.09C9 7.42 8 8.71 8 10c0 1.12.52 3 4 3 2 0 2 .68 2 1s-.62 1-2 1c-1.84 0-2-.86-2-1H8c0 .92.66 2.55 3 2.92V18h2v-1.08c2-.34 3-1.63 3-2.92 0-1.12-.52-3-4-3z' }, child: [] }
    ]
  })(props);
}

export function FaUserCircle(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 496 512' }, child: [{ tag: 'path', attr: { d: 'M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z' }, child: [] }] })(props);
}

export function BiTransfer(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24' }, child: [{ tag: 'path', attr: { d: 'm15 12 5-4-5-4v2.999H2v2h13zm7 3H9v-3l-5 4 5 4v-3h13z' }, child: [] }] })(props);
}

export function MdOutlineAdminPanelSettings(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      {
        tag: 'g',
        attr: { fillRule: 'evenodd' },
        child: [
          { tag: 'circle', attr: { cx: '17', cy: '15.5', r: '1.12' }, child: [] },
          { tag: 'path', attr: { d: 'M17 17.5c-.73 0-2.19.36-2.24 1.08.5.71 1.32 1.17 2.24 1.17s1.74-.46 2.24-1.17c-.05-.72-1.51-1.08-2.24-1.08z' }, child: [] },
          { tag: 'path', attr: { d: 'M18 11.09V6.27L10.5 3 3 6.27v4.91c0 4.54 3.2 8.79 7.5 9.82.55-.13 1.08-.32 1.6-.55A5.973 5.973 0 0 0 17 23c3.31 0 6-2.69 6-6 0-2.97-2.16-5.43-5-5.91zM11 17c0 .56.08 1.11.23 1.62-.24.11-.48.22-.73.3-3.17-1-5.5-4.24-5.5-7.74v-3.6l5.5-2.4 5.5 2.4v3.51c-2.84.48-5 2.94-5 5.91zm6 4c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z' }, child: [] }
        ]
      }
    ]
  })(props);
}

export function HiMiniEllipsisHorizontal(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 20 20', fill: 'currentColor', 'aria-hidden': 'true' }, child: [{ tag: 'path', attr: { d: 'M3 10a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM8.5 10a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM15.5 8.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z' }, child: [] }] })(props);
}

export function VscTelescope(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 16 16', fill: 'currentColor' }, child: [{ tag: 'path', attr: { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M11.24 1l.59.24 2.11 4.93-.23.59-3.29 1.41-.59-.24-.17-.41L6.1 9l-.58-.19-.16-.38L2.8 9.49l-.58-.24-.72-1.67.28-.59 2.5-1.06-.18-.41.24-.58L7.9 3.41 7.72 3 8 2.42 11.24 1zM2.5 7.64l.35.85 2.22-.91-.37-.85-2.2.91zm2.74-2.12l1.11 2.45 3-1.28-1.11-2.44-3 1.27zM8.79 3l1.86 4.11 2.29-1.01L11.18 2 8.72 3h.07zM8.5 9.1l3.02 4.9h-1.17l-1.88-3.03v4h-1V9.82L5.58 14h-1.1l1.7-3.9 2.32-1z' }, child: [] }] })(props);
}

export function FiArrowUp(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'line', attr: { x1: '12', y1: '19', x2: '12', y2: '5' }, child: [] },
      { tag: 'polyline', attr: { points: '5 12 12 5 19 12' }, child: [] }
    ]
  })(props);
}

export function FiArrowDown(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'line', attr: { x1: '12', y1: '5', x2: '12', y2: '19' }, child: [] },
      { tag: 'polyline', attr: { points: '19 12 12 19 5 12' }, child: [] }
    ]
  })(props);
}

export function IoEllipsisVertical(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 512 512' },
    child: [
      { tag: 'circle', attr: { cx: '256', cy: '256', r: '48' }, child: [] },
      { tag: 'circle', attr: { cx: '256', cy: '416', r: '48' }, child: [] },
      { tag: 'circle', attr: { cx: '256', cy: '96', r: '48' }, child: [] }
    ]
  })(props);
}

export function FaStar(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 576 512' }, child: [{ tag: 'path', attr: { d: 'M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z' }, child: [] }] })(props);
}

export function FiGift(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'polyline', attr: { points: '20 12 20 22 4 22 4 12' }, child: [] },
      { tag: 'rect', attr: { x: '2', y: '7', width: '20', height: '5' }, child: [] },
      { tag: 'line', attr: { x1: '12', y1: '22', x2: '12', y2: '7' }, child: [] },
      { tag: 'path', attr: { d: 'M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z' }, child: [] },
      { tag: 'path', attr: { d: 'M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z' }, child: [] }
    ]
  })(props);
}

export function FiShield(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }, child: [{ tag: 'path', attr: { d: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z' }, child: [] }] })(props);
}

export function FiMinus(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }, child: [{ tag: 'line', attr: { x1: '5', y1: '12', x2: '19', y2: '12' }, child: [] }] })(props);
}

export function BsFillExclamationSquareFill(props) {
  return GenIcon({ tag: 'svg', attr: { fill: 'currentColor', viewBox: '0 0 16 16' }, child: [{ tag: 'path', attr: { d: 'M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm6 4c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995A.905.905 0 0 1 8 4m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2' }, child: [] }] })(props);
}

export function FaBoxArchive(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 512 512' }, child: [{ tag: 'path', attr: { d: 'M32 32l448 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96L0 64C0 46.3 14.3 32 32 32zm0 128l448 0 0 256c0 35.3-28.7 64-64 64L96 480c-35.3 0-64-28.7-64-64l0-256zm128 80c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16z' }, child: [] }] })(props);
}

export function FaAward(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 384 512' }, child: [{ tag: 'path', attr: { d: 'M97.12 362.63c-8.69-8.69-4.16-6.24-25.12-11.85-9.51-2.55-17.87-7.45-25.43-13.32L1.2 448.7c-4.39 10.77 3.81 22.47 15.43 22.03l52.69-2.01L105.56 507c8 8.44 22.04 5.81 26.43-4.96l52.05-127.62c-10.84 6.04-22.87 9.58-35.31 9.58-19.5 0-37.82-7.59-51.61-21.37zM382.8 448.7l-45.37-111.24c-7.56 5.88-15.92 10.77-25.43 13.32-21.07 5.64-16.45 3.18-25.12 11.85-13.79 13.78-32.12 21.37-51.62 21.37-12.44 0-24.47-3.55-35.31-9.58L252 502.04c4.39 10.77 18.44 13.4 26.43 4.96l36.25-38.28 52.69 2.01c11.62.44 19.82-11.27 15.43-22.03zM263 340c15.28-15.55 17.03-14.21 38.79-20.14 13.89-3.79 24.75-14.84 28.47-28.98 7.48-28.4 5.54-24.97 25.95-45.75 10.17-10.35 14.14-25.44 10.42-39.58-7.47-28.38-7.48-24.42 0-52.83 3.72-14.14-.25-29.23-10.42-39.58-20.41-20.78-18.47-17.36-25.95-45.75-3.72-14.14-14.58-25.19-28.47-28.98-27.88-7.61-24.52-5.62-44.95-26.41-10.17-10.35-25-14.4-38.89-10.61-27.87 7.6-23.98 7.61-51.9 0-13.89-3.79-28.72.25-38.89 10.61-20.41 20.78-17.05 18.8-44.94 26.41-13.89 3.79-24.75 14.84-28.47 28.98-7.47 28.39-5.54 24.97-25.95 45.75-10.17 10.35-14.15 25.44-10.42 39.58 7.47 28.36 7.48 24.4 0 52.82-3.72 14.14.25 29.23 10.42 39.59 20.41 20.78 18.47 17.35 25.95 45.75 3.72 14.14 14.58 25.19 28.47 28.98C104.6 325.96 106.27 325 121 340c13.23 13.47 33.84 15.88 49.74 5.82a39.676 39.676 0 0 1 42.53 0c15.89 10.06 36.5 7.65 49.73-5.82zM97.66 175.96c0-53.03 42.24-96.02 94.34-96.02s94.34 42.99 94.34 96.02-42.24 96.02-94.34 96.02-94.34-42.99-94.34-96.02z' }, child: [] }] })(props);
}

export function FaTachometerAlt(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 576 512' }, child: [{ tag: 'path', attr: { d: 'M288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm0 64c14.71 0 26.58 10.13 30.32 23.65-1.11 2.26-2.64 4.23-3.45 6.67l-9.22 27.67c-5.13 3.49-10.97 6.01-17.64 6.01-17.67 0-32-14.33-32-32S270.33 96 288 96zM96 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm48-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm246.77-72.41l-61.33 184C343.13 347.33 352 364.54 352 384c0 11.72-3.38 22.55-8.88 32H232.88c-5.5-9.45-8.88-20.28-8.88-32 0-33.94 26.5-61.43 59.9-63.59l61.34-184.01c4.17-12.56 17.73-19.45 30.36-15.17 12.57 4.19 19.35 17.79 15.17 30.36zm14.66 57.2l15.52-46.55c3.47-1.29 7.13-2.23 11.05-2.23 17.67 0 32 14.33 32 32s-14.33 32-32 32c-11.38-.01-20.89-6.28-26.57-15.22zM480 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z' }, child: [] }] })(props);
}

export function HiOutlineChartBar(props) {
  return GenIcon({ tag: 'svg', attr: { fill: 'none', viewBox: '0 0 24 24', strokeWidth: '2', stroke: 'currentColor', 'aria-hidden': 'true' }, child: [{ tag: 'path', attr: { strokeLinecap: 'round', strokeLinejoin: 'round', d: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z' }, child: [] }] })(props);
}

export function IoGiftOutline(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 512 512' },
    child: [
      { tag: 'path', attr: { fill: 'none', strokeLinecap: 'round', strokeMiterlimit: '10', strokeWidth: '32', d: 'M256 104v56h56a56 56 0 1 0-56-56zm0 0v56h-56a56 56 0 1 1 56-56z' }, child: [] },
      { tag: 'rect', attr: { width: '384', height: '112', x: '64', y: '160', fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '32', rx: '32', ry: '32' }, child: [] },
      { tag: 'path', attr: { fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '32', d: 'M416 272v144a48 48 0 0 1-48 48H144a48 48 0 0 1-48-48V272m160-112v304' }, child: [] }
    ]
  })(props);
}

export function FiBell(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9' }, child: [] },
      { tag: 'path', attr: { d: 'M13.73 21a2 2 0 0 1-3.46 0' }, child: [] }
    ]
  })(props);
}

export function FaRegFile(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 384 512' }, child: [{ tag: 'path', attr: { d: 'M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48z' }, child: [] }] })(props);
}

export function IoArrowDown(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 512 512' }, child: [{ tag: 'path', attr: { fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '48', d: 'm112 268 144 144 144-144M256 392V100' }, child: [] }] })(props);
}

export function TbPageBreak(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M14 3v4a1 1 0 0 0 1 1h4' }, child: [] },
      { tag: 'path', attr: { d: 'M19 18v1a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-1' }, child: [] },
      { tag: 'path', attr: { d: 'M3 14h3m4.5 0h3m4.5 0h3' }, child: [] },
      { tag: 'path', attr: { d: 'M5 10v-5a2 2 0 0 1 2 -2h7l5 5v2' }, child: [] }
    ]
  })(props);
}

export function FiSettings(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'circle', attr: { cx: '12', cy: '12', r: '3' }, child: [] },
      { tag: 'path', attr: { d: 'M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z' }, child: [] }
    ]
  })(props);
}

export function BsCalendarEvent(props) {
  return GenIcon({
    tag: 'svg',
    attr: { fill: 'currentColor', viewBox: '0 0 16 16' },
    child: [
      { tag: 'path', attr: { d: 'M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5z' }, child: [] },
      { tag: 'path', attr: { d: 'M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z' }, child: [] }
    ]
  })(props);
}

export function FiHome(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z' }, child: [] },
      { tag: 'polyline', attr: { points: '9 22 9 12 15 12 15 22' }, child: [] }
    ]
  })(props);
}

export function FiUserCheck(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2' }, child: [] },
      { tag: 'circle', attr: { cx: '8.5', cy: '7', r: '4' }, child: [] },
      { tag: 'polyline', attr: { points: '17 11 19 13 23 9' }, child: [] }
    ]
  })(props);
}

export function TbApi(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M4 13h5' }, child: [] },
      { tag: 'path', attr: { d: 'M12 16v-8h3a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2h-3' }, child: [] },
      { tag: 'path', attr: { d: 'M20 8v8' }, child: [] },
      { tag: 'path', attr: { d: 'M9 16v-5.5a2.5 2.5 0 0 0 -5 0v5.5' }, child: [] }
    ]
  })(props);
}

export function RxLightningBolt(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 15 15', fill: 'none' }, child: [{ tag: 'path', attr: { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M8.69667 0.0403541C8.90859 0.131038 9.03106 0.354857 8.99316 0.582235L8.0902 6.00001H12.5C12.6893 6.00001 12.8625 6.10701 12.9472 6.27641C13.0319 6.4458 13.0136 6.6485 12.8999 6.80001L6.89997 14.8C6.76167 14.9844 6.51521 15.0503 6.30328 14.9597C6.09135 14.869 5.96888 14.6452 6.00678 14.4178L6.90974 9H2.49999C2.31061 9 2.13748 8.893 2.05278 8.72361C1.96809 8.55422 1.98636 8.35151 2.09999 8.2L8.09997 0.200038C8.23828 0.0156255 8.48474 -0.0503301 8.69667 0.0403541ZM3.49999 8.00001H7.49997C7.64695 8.00001 7.78648 8.06467 7.88148 8.17682C7.97648 8.28896 8.01733 8.43723 7.99317 8.5822L7.33027 12.5596L11.5 7.00001H7.49997C7.353 7.00001 7.21347 6.93534 7.11846 6.8232C7.02346 6.71105 6.98261 6.56279 7.00678 6.41781L7.66968 2.44042L3.49999 8.00001Z', fill: 'currentColor' }, child: [] }] })(props);
}

export function FiTrello(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'rect', attr: { x: '3', y: '3', width: '18', height: '18', rx: '2', ry: '2' }, child: [] },
      { tag: 'rect', attr: { x: '7', y: '7', width: '3', height: '9' }, child: [] },
      { tag: 'rect', attr: { x: '14', y: '7', width: '3', height: '5' }, child: [] }
    ]
  })(props);
}

export function FiGitPullRequest(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'circle', attr: { cx: '18', cy: '18', r: '3' }, child: [] },
      { tag: 'circle', attr: { cx: '6', cy: '6', r: '3' }, child: [] },
      { tag: 'path', attr: { d: 'M13 6h3a2 2 0 0 1 2 2v7' }, child: [] },
      { tag: 'line', attr: { x1: '6', y1: '9', x2: '6', y2: '21' }, child: [] }
    ]
  })(props);
}

export function LuClock(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'circle', attr: { cx: '12', cy: '12', r: '10' }, child: [] },
      { tag: 'polyline', attr: { points: '12 6 12 12 16 14' }, child: [] }
    ]
  })(props);
}

export function TbClockExclamation(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M20.986 12.502a9 9 0 1 0 -5.973 7.98' }, child: [] },
      { tag: 'path', attr: { d: 'M12 7v5l3 3' }, child: [] },
      { tag: 'path', attr: { d: 'M19 16v3' }, child: [] },
      { tag: 'path', attr: { d: 'M19 22v.01' }, child: [] }
    ]
  })(props);
}

export function VscDebugStepOver(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 16 16', fill: 'currentColor' }, child: [{ tag: 'path', attr: { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M14.25 5.75v-4h-1.5v2.542c-1.145-1.359-2.911-2.209-4.84-2.209-3.177 0-5.92 2.307-6.16 5.398l-.02.269h1.501l.022-.226c.212-2.195 2.202-3.94 4.656-3.94 1.736 0 3.244.875 4.05 2.166h-2.83v1.5h4.163l.962-.975V5.75h-.004zM8 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4z' }, child: [] }] })(props);
}

export function FiMessageSquare(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }, child: [{ tag: 'path', attr: { d: 'M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z' }, child: [] }] })(props);
}

export function HiOutlineMail(props) {
  return GenIcon({ tag: 'svg', attr: { fill: 'none', viewBox: '0 0 24 24', strokeWidth: '2', stroke: 'currentColor', 'aria-hidden': 'true' }, child: [{ tag: 'path', attr: { strokeLinecap: 'round', strokeLinejoin: 'round', d: 'M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z' }, child: [] }] })(props);
}

export function BiUser(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24' }, child: [{ tag: 'path', attr: { d: 'M12 2a5 5 0 1 0 5 5 5 5 0 0 0-5-5zm0 8a3 3 0 1 1 3-3 3 3 0 0 1-3 3zm9 11v-1a7 7 0 0 0-7-7h-4a7 7 0 0 0-7 7v1h2v-1a5 5 0 0 1 5-5h4a5 5 0 0 1 5 5v1z' }, child: [] }] })(props);
}

export function MdSubject(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'path', attr: { d: 'M14 17H4v2h10v-2zm6-8H4v2h16V9zM4 15h16v-2H4v2zM4 5v2h16V5H4z' }, child: [] }
    ]
  })(props);
}

export function FiType(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'polyline', attr: { points: '4 7 4 4 20 4 20 7' }, child: [] },
      { tag: 'line', attr: { x1: '9', y1: '20', x2: '15', y2: '20' }, child: [] },
      { tag: 'line', attr: { x1: '12', y1: '4', x2: '12', y2: '20' }, child: [] }
    ]
  })(props);
}

export function HiHashtag(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 20 20', fill: 'currentColor', 'aria-hidden': 'true' }, child: [{ tag: 'path', attr: { fillRule: 'evenodd', d: 'M9.243 3.03a1 1 0 01.727 1.213L9.53 6h2.94l.56-2.243a1 1 0 111.94.486L14.53 6H17a1 1 0 110 2h-2.97l-1 4H15a1 1 0 110 2h-2.47l-.56 2.242a1 1 0 11-1.94-.485L10.47 14H7.53l-.56 2.242a1 1 0 11-1.94-.485L5.47 14H3a1 1 0 110-2h2.97l1-4H5a1 1 0 110-2h2.47l.56-2.243a1 1 0 011.213-.727zM9.03 8l-1 4h2.938l1-4H9.031z', clipRule: 'evenodd' }, child: [] }] })(props);
}

export function TiFlowSwitch(props) {
  return GenIcon({ tag: 'svg', attr: { version: '1.2', baseProfile: 'tiny', viewBox: '0 0 24 24' }, child: [{ tag: 'g', attr: {}, child: [{ tag: 'path', attr: { d: 'M8 16.184v-.684c0-.848.512-1.595 1.287-2.047-.667-.282-1.279-.667-1.822-1.131-.904.814-1.465 1.938-1.465 3.178v.684c-1.161.415-2 1.514-2 2.816 0 1.654 1.346 3 3 3s3-1.346 3-3c0-1.302-.839-2.401-2-2.816zm-1 3.816c-.552 0-1-.449-1-1s.448-1 1-1 1 .449 1 1-.448 1-1 1zM16 7.815v.351c0 .985-.535 1.852-1.345 2.36.665.274 1.279.646 1.823 1.1.936-.878 1.522-2.102 1.522-3.459v-.351c1.161-.415 2-1.514 2-2.816 0-1.654-1.346-3-3-3s-3 1.346-3 3c0 1.302.839 2.401 2 2.815zm1-3.815c.552 0 1 .449 1 1s-.448 1-1 1-1-.449-1-1 .448-1 1-1zM17.935 16.164c-.41-2.913-2.911-5.164-5.935-5.164-1.936 0-3.552-1.381-3.92-3.209 1.12-.436 1.92-1.519 1.92-2.791 0-1.654-1.346-3-3-3s-3 1.346-3 3c0 1.326.87 2.44 2.065 2.836.41 2.913 2.911 5.164 5.935 5.164 1.936 0 3.552 1.381 3.92 3.209-1.12.436-1.92 1.519-1.92 2.791 0 1.654 1.346 3 3 3s3-1.346 3-3c0-1.326-.87-2.44-2.065-2.836zm-10.935-12.164c.552 0 1 .449 1 1s-.448 1-1 1-1-.449-1-1 .448-1 1-1zm10 16c-.552 0-1-.449-1-1s.448-1 1-1 1 .449 1 1-.448 1-1 1z' }, child: [] }] }] })(props);
}

export function PiBracketsCurly(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 256 256', fill: 'currentColor' }, child: [{ tag: 'path', attr: { d: 'M43.18,128a29.78,29.78,0,0,1,8,10.26c4.8,9.9,4.8,22,4.8,33.74,0,24.31,1,36,24,36a8,8,0,0,1,0,16c-17.48,0-29.32-6.14-35.2-18.26-4.8-9.9-4.8-22-4.8-33.74,0-24.31-1-36-24-36a8,8,0,0,1,0-16c23,0,24-11.69,24-36,0-11.72,0-23.84,4.8-33.74C50.68,38.14,62.52,32,80,32a8,8,0,0,1,0,16C57,48,56,59.69,56,84c0,11.72,0,23.84-4.8,33.74A29.78,29.78,0,0,1,43.18,128ZM240,120c-23,0-24-11.69-24-36,0-11.72,0-23.84-4.8-33.74C205.32,38.14,193.48,32,176,32a8,8,0,0,0,0,16c23,0,24,11.69,24,36,0,11.72,0,23.84,4.8,33.74a29.78,29.78,0,0,0,8,10.26,29.78,29.78,0,0,0-8,10.26c-4.8,9.9-4.8,22-4.8,33.74,0,24.31-1,36-24,36a8,8,0,0,0,0,16c17.48,0,29.32-6.14,35.2-18.26,4.8-9.9,4.8-22,4.8-33.74,0-24.31,1-36,24-36a8,8,0,0,0,0-16Z' }, child: [] }] })(props);
}

export function IoMdCloudDownload(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 512 512' }, child: [{ tag: 'path', attr: { d: 'M403.002 217.001C388.998 148.002 328.998 96 256 96c-57.998 0-107.998 32.998-132.998 81.001C63.002 183.002 16 233.998 16 296c0 65.996 53.999 120 120 120h260c55 0 100-45 100-100 0-52.998-40.996-96.001-92.998-98.999zM224 268v-76h64v76h68L256 368 156 268h68z' }, child: [] }] })(props);
}

export function TiArrowRepeat(props) {
  return GenIcon({ tag: 'svg', attr: { version: '1.2', baseProfile: 'tiny', viewBox: '0 0 24 24' }, child: [{ tag: 'path', attr: { d: 'M16.5 7h-2.086l1.293-1.293c.391-.391.391-1.023 0-1.414s-1.023-.391-1.414 0l-3.707 3.707 3.707 3.707c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023 0-1.414l-1.293-1.293h2.086c1.379 0 2.5 1.346 2.5 3s-1.346 3-3 3c-.553 0-1 .448-1 1s.447 1 1 1c2.757 0 5-2.243 5-5s-2.019-5-4.5-5zM8.293 12.293c-.391.391-.391 1.023 0 1.414l1.293 1.293h-2.086c-1.379 0-2.5-1.346-2.5-3s1.346-3 3-3c.553 0 1-.448 1-1s-.447-1-1-1c-2.757 0-5 2.243-5 5s2.019 5 4.5 5h2.086l-1.293 1.293c-.391.391-.391 1.023 0 1.414.195.195.451.293.707.293s.512-.098.707-.293l3.707-3.707-3.707-3.707c-.391-.391-1.023-.391-1.414 0z' }, child: [] }] })(props);
}

export function TbTablePlus(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M12.5 21h-7.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7.5' }, child: [] },
      { tag: 'path', attr: { d: 'M3 10h18' }, child: [] },
      { tag: 'path', attr: { d: 'M10 3v18' }, child: [] },
      { tag: 'path', attr: { d: 'M16 19h6' }, child: [] },
      { tag: 'path', attr: { d: 'M19 16v6' }, child: [] }
    ]
  })(props);
}

export function RxPencil2(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 15 15', fill: 'none' }, child: [{ tag: 'path', attr: { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M12.1464 1.14645C12.3417 0.951184 12.6583 0.951184 12.8535 1.14645L14.8535 3.14645C15.0488 3.34171 15.0488 3.65829 14.8535 3.85355L10.9109 7.79618C10.8349 7.87218 10.7471 7.93543 10.651 7.9835L6.72359 9.94721C6.53109 10.0435 6.29861 10.0057 6.14643 9.85355C5.99425 9.70137 5.95652 9.46889 6.05277 9.27639L8.01648 5.34897C8.06455 5.25283 8.1278 5.16507 8.2038 5.08907L12.1464 1.14645ZM12.5 2.20711L8.91091 5.79618L7.87266 7.87267L8.12731 8.12732L10.2038 7.08907L13.7929 3.5L12.5 2.20711ZM9.99998 2L8.99998 3H4.9C4.47171 3 4.18056 3.00039 3.95552 3.01877C3.73631 3.03668 3.62421 3.06915 3.54601 3.10899C3.35785 3.20487 3.20487 3.35785 3.10899 3.54601C3.06915 3.62421 3.03669 3.73631 3.01878 3.95552C3.00039 4.18056 3 4.47171 3 4.9V11.1C3 11.5283 3.00039 11.8194 3.01878 12.0445C3.03669 12.2637 3.06915 12.3758 3.10899 12.454C3.20487 12.6422 3.35785 12.7951 3.54601 12.891C3.62421 12.9309 3.73631 12.9633 3.95552 12.9812C4.18056 12.9996 4.47171 13 4.9 13H11.1C11.5283 13 11.8194 12.9996 12.0445 12.9812C12.2637 12.9633 12.3758 12.9309 12.454 12.891C12.6422 12.7951 12.7951 12.6422 12.891 12.454C12.9309 12.3758 12.9633 12.2637 12.9812 12.0445C12.9996 11.8194 13 11.5283 13 11.1V6.99998L14 5.99998V11.1V11.1207C14 11.5231 14 11.8553 13.9779 12.1259C13.9549 12.407 13.9057 12.6653 13.782 12.908C13.5903 13.2843 13.2843 13.5903 12.908 13.782C12.6653 13.9057 12.407 13.9549 12.1259 13.9779C11.8553 14 11.5231 14 11.1207 14H11.1H4.9H4.87934C4.47686 14 4.14468 14 3.87409 13.9779C3.59304 13.9549 3.33469 13.9057 3.09202 13.782C2.7157 13.5903 2.40973 13.2843 2.21799 12.908C2.09434 12.6653 2.04506 12.407 2.0221 12.1259C1.99999 11.8553 1.99999 11.5231 2 11.1207V11.1206V11.1V4.9V4.87935V4.87932V4.87931C1.99999 4.47685 1.99999 4.14468 2.0221 3.87409C2.04506 3.59304 2.09434 3.33469 2.21799 3.09202C2.40973 2.71569 2.7157 2.40973 3.09202 2.21799C3.33469 2.09434 3.59304 2.04506 3.87409 2.0221C4.14468 1.99999 4.47685 1.99999 4.87932 2H4.87935H4.9H9.99998Z', fill: 'currentColor' }, child: [] }] })(props);
}

export function BiBold(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24' }, child: [{ tag: 'path', attr: { d: 'M17.061 11.22A4.46 4.46 0 0 0 18 8.5C18 6.019 15.981 4 13.5 4H6v15h8c2.481 0 4.5-2.019 4.5-4.5a4.48 4.48 0 0 0-1.439-3.28zM13.5 7c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5H9V7h4.5zm.5 9H9v-3h5c.827 0 1.5.673 1.5 1.5S14.827 16 14 16z' }, child: [] }] })(props);
}

export function BiItalic(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24' }, child: [{ tag: 'path', attr: { d: 'M19 7V4H9v3h2.868L9.012 17H5v3h10v-3h-2.868l2.856-10z' }, child: [] }] })(props);
}

export function BiStrikethrough(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24' }, child: [{ tag: 'path', attr: { d: 'M20 11h-8c-4 0-4-1.816-4-2.5C8 7.882 8 6 12 6c2.8 0 2.99 1.678 3 2.014L16 8h1c0-1.384-1.045-4-5-4-5.416 0-6 3.147-6 4.5 0 .728.148 1.667.736 2.5H4v2h16v-2zm-8 7c-3.793 0-3.99-1.815-4-2H6c0 .04.069 4 6 4 5.221 0 6-2.819 6-4.5 0-.146-.009-.317-.028-.5h-2.006c.032.2.034.376.034.5 0 .684 0 2.5-4 2.5z' }, child: [] }] })(props);
}

export function IoGitBranchOutline(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 512 512' },
    child: [
      { tag: 'circle', attr: { cx: '160', cy: '96', r: '48', fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '32' }, child: [] },
      { tag: 'circle', attr: { cx: '160', cy: '416', r: '48', fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '32' }, child: [] },
      { tag: 'path', attr: { fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '32', d: 'M160 368V144' }, child: [] },
      { tag: 'circle', attr: { cx: '352', cy: '160', r: '48', fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '32' }, child: [] },
      { tag: 'path', attr: { fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '32', d: 'M352 208c0 128-192 48-192 160' }, child: [] }
    ]
  })(props);
}

export function MdSupport(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'path', attr: { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm7.46 7.12-2.78 1.15a4.982 4.982 0 0 0-2.95-2.94l1.15-2.78c2.1.8 3.77 2.47 4.58 4.57zM12 15c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zM9.13 4.54l1.17 2.78a5 5 0 0 0-2.98 2.97L4.54 9.13a7.984 7.984 0 0 1 4.59-4.59zM4.54 14.87l2.78-1.15a4.968 4.968 0 0 0 2.97 2.96l-1.17 2.78a7.996 7.996 0 0 1-4.58-4.59zm10.34 4.59-1.15-2.78a4.978 4.978 0 0 0 2.95-2.97l2.78 1.17a8.007 8.007 0 0 1-4.58 4.58z' }, child: [] }
    ]
  })(props);
}

export function BsList(props) {
  return GenIcon({ tag: 'svg', attr: { fill: 'currentColor', viewBox: '0 0 16 16' }, child: [{ tag: 'path', attr: { fillRule: 'evenodd', d: 'M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5' }, child: [] }] })(props);
}

export function VscSymbolMethod(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 16 16', fill: 'currentColor' }, child: [{ tag: 'path', attr: { d: 'M13.51 4l-5-3h-1l-5 3-.49.86v6l.49.85 5 3h1l5-3 .49-.85v-6L13.51 4zm-6 9.56l-4.5-2.7V5.7l4.5 2.45v5.41zM3.27 4.7l4.74-2.84 4.74 2.84-4.74 2.59L3.27 4.7zm9.74 6.16l-4.5 2.7V8.15l4.5-2.45v5.16z' }, child: [] }] })(props);
}

export function FaHeading(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 512 512' }, child: [{ tag: 'path', attr: { d: 'M448 96v320h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H320a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V288H160v128h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V96H32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16h-32v128h192V96h-32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16z' }, child: [] }] })(props);
}

export function MdPostAdd(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'path', attr: { d: 'M17 19.22H5V7h7V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-7h-2v7.22z' }, child: [] },
      { tag: 'path', attr: { d: 'M19 2h-2v3h-3c.01.01 0 2 0 2h3v2.99c.01.01 2 0 2 0V7h3V5h-3V2zM7 9h8v2H7zM7 12v2h8v-2h-3zM7 15h8v2H7z' }, child: [] }
    ]
  })(props);
}

export function MdOutlineShoppingCart(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0V0z' }, child: [] },
      { tag: 'path', attr: { d: 'M15.55 13c.75 0 1.41-.41 1.75-1.03l3.58-6.49A.996.996 0 0 0 20.01 4H5.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2h7.45zM6.16 6h12.15l-2.76 5H8.53L6.16 6zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z' }, child: [] }
    ]
  })(props);
}

export function FaRegMessage(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 512 512' }, child: [{ tag: 'path', attr: { d: 'M160 368c26.5 0 48 21.5 48 48l0 16 72.5-54.4c8.3-6.2 18.4-9.6 28.8-9.6L448 368c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16L64 48c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l96 0zm48 124l-.2 .2-5.1 3.8-17.1 12.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-21.3 0-6.4 0-.3 0-4 0-48-48 0-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L208 492z' }, child: [] }] })(props);
}

export function GrMultiple(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24' }, child: [{ tag: 'path', attr: { fill: 'none', strokeWidth: '2', d: 'M19,15 L23,15 L23,1 L9,1 L9,5 M15,19 L19,19 L19,5 L5,5 L5,9 M1,23 L15,23 L15,9 L1,9 L1,23 L1,23 L1,23 Z' }, child: [] }] })(props);
}

export function HiOutlineDuplicate(props) {
  return GenIcon({ tag: 'svg', attr: { fill: 'none', viewBox: '0 0 24 24', strokeWidth: '2', stroke: 'currentColor', 'aria-hidden': 'true' }, child: [{ tag: 'path', attr: { strokeLinecap: 'round', strokeLinejoin: 'round', d: 'M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z' }, child: [] }] })(props);
}

export function PiSteps(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 256 256', fill: 'currentColor' }, child: [{ tag: 'path', attr: { d: 'M248,56a8,8,0,0,1-8,8H192v40a8,8,0,0,1-8,8H136v40a8,8,0,0,1-8,8H80v40a8,8,0,0,1-8,8H16a8,8,0,0,1,0-16H64V152a8,8,0,0,1,8-8h48V104a8,8,0,0,1,8-8h48V56a8,8,0,0,1,8-8h56A8,8,0,0,1,248,56Z' }, child: [] }] })(props);
}

export function MdInput(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'path', attr: { d: 'M21 3.01H3c-1.1 0-2 .9-2 2V9h2V4.99h18v14.03H3V15H1v4.01c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98v-14a2 2 0 0 0-2-2zM11 16l4-4-4-4v3H1v2h10v3z' }, child: [] }
    ]
  })(props);
}

export function LuAlertCircle(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'circle', attr: { cx: '12', cy: '12', r: '10' }, child: [] },
      { tag: 'line', attr: { x1: '12', x2: '12', y1: '8', y2: '12' }, child: [] },
      { tag: 'line', attr: { x1: '12', x2: '12.01', y1: '16', y2: '16' }, child: [] }
    ]
  })(props);
}

export function LuCheckCircle(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M22 11.08V12a10 10 0 1 1-5.93-9.14' }, child: [] },
      { tag: 'polyline', attr: { points: '22 4 12 14.01 9 11.01' }, child: [] }
    ]
  })(props);
}

export function RiFileTransferLine(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24', fill: 'currentColor' }, child: [{ tag: 'path', attr: { d: 'M15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM12 11V8L16 12L12 16V13H8V11H12Z' }, child: [] }] })(props);
}

export function RxValueNone(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 15 15', fill: 'none' }, child: [{ tag: 'path', attr: { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M7.49985 0.877045C3.84216 0.877045 0.877014 3.84219 0.877014 7.49988C0.877014 9.1488 1.47963 10.657 2.47665 11.8162L1.64643 12.6464C1.45117 12.8417 1.45117 13.1583 1.64643 13.3535C1.8417 13.5488 2.15828 13.5488 2.35354 13.3535L3.18377 12.5233C4.34296 13.5202 5.85104 14.1227 7.49985 14.1227C11.1575 14.1227 14.1227 11.1575 14.1227 7.49988C14.1227 5.85107 13.5202 4.34299 12.5233 3.1838L13.3535 2.35354C13.5488 2.15827 13.5488 1.84169 13.3535 1.64643C13.1583 1.45117 12.8417 1.45117 12.6464 1.64643L11.8162 2.47668C10.657 1.47966 9.14877 0.877045 7.49985 0.877045ZM11.1422 3.15066C10.1567 2.32449 8.88639 1.82704 7.49985 1.82704C4.36683 1.82704 1.82701 4.36686 1.82701 7.49988C1.82701 8.88642 2.32446 10.1568 3.15063 11.1422L11.1422 3.15066ZM3.85776 11.8493C4.84317 12.6753 6.11343 13.1727 7.49985 13.1727C10.6328 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 6.11346 12.6753 4.8432 11.8493 3.85779L3.85776 11.8493Z', fill: 'currentColor' }, child: [] }] })(props);
}

export function GrStatusInfo(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24' }, child: [{ tag: 'path', attr: { fill: 'none', strokeWidth: '2', d: 'M2,3.99079514 C2,2.89130934 2.89821238,2 3.99079514,2 L20.0092049,2 C21.1086907,2 22,2.89821238 22,3.99079514 L22,20.0092049 C22,21.1086907 21.1017876,22 20.0092049,22 L3.99079514,22 C2.89130934,22 2,21.1017876 2,20.0092049 L2,3.99079514 Z M12,10 L12,18 M12,6 L12,8' }, child: [] }] })(props);
}

export function HiOutlineDocumentMagnifyingGlass(props) {
  return GenIcon({ tag: 'svg', attr: { fill: 'none', viewBox: '0 0 24 24', strokeWidth: '1.5', stroke: 'currentColor', 'aria-hidden': 'true' }, child: [{ tag: 'path', attr: { strokeLinecap: 'round', strokeLinejoin: 'round', d: 'M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m5.231 13.481L15 17.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v16.5c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Zm3.75 11.625a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z' }, child: [] }] })(props);
}

export function FiPlus(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'line', attr: { x1: '12', y1: '5', x2: '12', y2: '19' }, child: [] },
      { tag: 'line', attr: { x1: '5', y1: '12', x2: '19', y2: '12' }, child: [] }
    ]
  })(props);
}

export function FiShuffle(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'polyline', attr: { points: '16 3 21 3 21 8' }, child: [] },
      { tag: 'line', attr: { x1: '4', y1: '20', x2: '21', y2: '3' }, child: [] },
      { tag: 'polyline', attr: { points: '21 16 21 21 16 21' }, child: [] },
      { tag: 'line', attr: { x1: '15', y1: '15', x2: '21', y2: '21' }, child: [] },
      { tag: 'line', attr: { x1: '4', y1: '4', x2: '9', y2: '9' }, child: [] }
    ]
  })(props);
}

export function FiTrash(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'polyline', attr: { points: '3 6 5 6 21 6' }, child: [] },
      { tag: 'path', attr: { d: 'M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2' }, child: [] }
    ]
  })(props);
}

export function BiCodeCurly(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24' }, child: [{ tag: 'path', attr: { d: 'M9 22h1v-2h-.989C8.703 19.994 6 19.827 6 16c0-1.993-.665-3.246-1.502-4C5.335 11.246 6 9.993 6 8c0-3.827 2.703-3.994 3-4h1V2H8.998C7.269 2.004 4 3.264 4 8c0 2.8-1.678 2.99-2.014 3L2 13c.082 0 2 .034 2 3 0 4.736 3.269 5.996 5 6zm13-11c-.082 0-2-.034-2-3 0-4.736-3.269-5.996-5-6h-1v2h.989c.308.006 3.011.173 3.011 4 0 1.993.665 3.246 1.502 4-.837.754-1.502 2.007-1.502 4 0 3.827-2.703 3.994-3 4h-1v2h1.002C16.731 21.996 20 20.736 20 16c0-2.8 1.678-2.99 2.014-3L22 11z' }, child: [] }] })(props);
}

export function IoShuffle(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 512 512' },
    child: [
      { tag: 'path', attr: { fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '32', d: 'm400 304 48 48-48 48m0-288 48 48-48 48M64 352h85.19a80 80 0 0 0 66.56-35.62L256 256' }, child: [] },
      { tag: 'path', attr: { fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '32', d: 'M64 160h85.19a80 80 0 0 1 66.56 35.62l80.5 120.76A80 80 0 0 0 362.81 352H416m0-192h-53.19a80 80 0 0 0-66.56 35.62L288 208' }, child: [] }
    ]
  })(props);
}

export function GrCubes(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24' }, child: [{ tag: 'path', attr: { fill: 'none', strokeWidth: '2', d: 'M6.5,10.5 L12,13.5 L17.5,10.5 L17.5,4.5 L12,1.5 L6.5,4.5 L6.5,10.5 Z M6.5,4.5 L12,7.5 L17.5,4.5 M12,7.5 L12,13.5 L12,7.5 Z M1,19.5 L6.5,22.5 L12,19.5 L12,13.5 L6.5,10.5 L1,13.5 L1,19.5 Z M1,13.5 L6.5,16.5 L12,13.5 M6.5,16.5 L6.5,22.5 L6.5,16.5 Z M12,19.5 L17.5,22.5 L23,19.5 L23,13.5 L17.5,10.5 L12,13.5 L12,19.5 Z M12,13.5 L17.5,16.5 L23,13.5 M17.5,16.5 L17.5,22.5 L17.5,16.5 Z' }, child: [] }] })(props);
}

export function IoMdList(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 512 512' },
    child: [
      { tag: 'path', attr: { d: 'M80 280h256v48H80zM80 184h320v48H80zM80 88h352v48H80z' }, child: [] },
      { tag: 'g', attr: {}, child: [{ tag: 'path', attr: { d: 'M80 376h288v48H80z' }, child: [] }] }
    ]
  })(props);
}

export function RiFunctionLine(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24', fill: 'currentColor' }, child: [{ tag: 'path', attr: { d: 'M3 4C3 3.44772 3.44772 3 4 3H10C10.5523 3 11 3.44772 11 4V10C11 10.5523 10.5523 11 10 11H4C3.44772 11 3 10.5523 3 10V4ZM3 14C3 13.4477 3.44772 13 4 13H10C10.5523 13 11 13.4477 11 14V20C11 20.5523 10.5523 21 10 21H4C3.44772 21 3 20.5523 3 20V14ZM13 4C13 3.44772 13.4477 3 14 3H20C20.5523 3 21 3.44772 21 4V10C21 10.5523 20.5523 11 20 11H14C13.4477 11 13 10.5523 13 10V4ZM13 14C13 13.4477 13.4477 13 14 13H20C20.5523 13 21 13.4477 21 14V20C21 20.5523 20.5523 21 20 21H14C13.4477 21 13 20.5523 13 20V14ZM15 5V9H19V5H15ZM15 15V19H19V15H15ZM5 5V9H9V5H5ZM5 15V19H9V15H5Z' }, child: [] }] })(props);
}

export function BsActivity(props) {
  return GenIcon({ tag: 'svg', attr: { fill: 'currentColor', viewBox: '0 0 16 16' }, child: [{ tag: 'path', attr: { fillRule: 'evenodd', d: 'M6 2a.5.5 0 0 1 .47.33L10 12.036l1.53-4.208A.5.5 0 0 1 12 7.5h3.5a.5.5 0 0 1 0 1h-3.15l-1.88 5.17a.5.5 0 0 1-.94 0L6 3.964 4.47 8.171A.5.5 0 0 1 4 8.5H.5a.5.5 0 0 1 0-1h3.15l1.88-5.17A.5.5 0 0 1 6 2' }, child: [] }] })(props);
}

export function FiUser(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2' }, child: [] },
      { tag: 'circle', attr: { cx: '12', cy: '7', r: '4' }, child: [] }
    ]
  })(props);
}

export function BsBlockquoteLeft(props) {
  return GenIcon({ tag: 'svg', attr: { fill: 'currentColor', viewBox: '0 0 16 16' }, child: [{ tag: 'path', attr: { d: 'M2.5 3a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1zm5 3a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm-5 3a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1zm.79-5.373q.168-.117.444-.275L3.524 6q-.183.111-.452.287-.27.176-.51.428a2.4 2.4 0 0 0-.398.562Q2 7.587 2 7.969q0 .54.217.873.217.328.72.328.322 0 .504-.211a.7.7 0 0 0 .188-.463q0-.345-.211-.521-.205-.182-.568-.182h-.282q.036-.305.123-.498a1.4 1.4 0 0 1 .252-.37 2 2 0 0 1 .346-.298zm2.167 0q.17-.117.445-.275L5.692 6q-.183.111-.452.287-.27.176-.51.428a2.4 2.4 0 0 0-.398.562q-.165.31-.164.692 0 .54.217.873.217.328.72.328.322 0 .504-.211a.7.7 0 0 0 .188-.463q0-.345-.211-.521-.205-.182-.568-.182h-.282a1.8 1.8 0 0 1 .118-.492q.087-.194.257-.375a2 2 0 0 1 .346-.3z' }, child: [] }] })(props);
}

export function PiMathOperations(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 256 256', fill: 'currentColor' }, child: [{ tag: 'path', attr: { d: 'M112,72a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16h64A8,8,0,0,1,112,72Zm-8,104H80V152a8,8,0,0,0-16,0v24H40a8,8,0,0,0,0,16H64v24a8,8,0,0,0,16,0V192h24a8,8,0,0,0,0-16Zm48,0h64a8,8,0,0,0,0-16H152a8,8,0,0,0,0,16Zm64,16H152a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Zm-61.66-90.34a8,8,0,0,0,11.32,0L184,83.31l18.34,18.35a8,8,0,0,0,11.32-11.32L195.31,72l18.35-18.34a8,8,0,0,0-11.32-11.32L184,60.69,165.66,42.34a8,8,0,0,0-11.32,11.32L172.69,72,154.34,90.34A8,8,0,0,0,154.34,101.66Z' }, child: [] }] })(props);
}

export function RxBoxModel(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 15 15', fill: 'none' }, child: [{ tag: 'path', attr: { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M1.99998 0.999976C1.44769 0.999976 0.999976 1.44769 0.999976 1.99998V13C0.999976 13.5523 1.44769 14 1.99998 14H13C13.5523 14 14 13.5523 14 13V1.99998C14 1.44769 13.5523 0.999976 13 0.999976H1.99998ZM1.99998 1.99998L13 1.99998V13H1.99998V1.99998ZM4.49996 3.99996C4.22382 3.99996 3.99996 4.22382 3.99996 4.49996V10.5C3.99996 10.7761 4.22382 11 4.49996 11H10.5C10.7761 11 11 10.7761 11 10.5V4.49996C11 4.22382 10.7761 3.99996 10.5 3.99996H4.49996ZM4.99996 9.99996V4.99996H9.99996V9.99996H4.99996Z', fill: 'currentColor' }, child: [] }] })(props);
}

export function MdOutlineTypeSpecimen(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'path', attr: { d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z' }, child: [] },
      { tag: 'path', attr: { d: 'M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12z' }, child: [] },
      { tag: 'path', attr: { d: 'M12.19 12.2h3.63l.8 2.3h1.56l-3.38-9h-1.6l-3.38 9h1.56l.81-2.3zm1.77-5.03h.08l1.31 3.72h-2.69l1.3-3.72z' }, child: [] }
    ]
  })(props);
}

export function BsFlag(props) {
  return GenIcon({ tag: 'svg', attr: { fill: 'currentColor', viewBox: '0 0 16 16' }, child: [{ tag: 'path', attr: { d: 'M14.778.085A.5.5 0 0 1 15 .5V8a.5.5 0 0 1-.314.464L14.5 8l.186.464-.003.001-.006.003-.023.009a12 12 0 0 1-.397.15c-.264.095-.631.223-1.047.35-.816.252-1.879.523-2.71.523-.847 0-1.548-.28-2.158-.525l-.028-.01C7.68 8.71 7.14 8.5 6.5 8.5c-.7 0-1.638.23-2.437.477A20 20 0 0 0 3 9.342V15.5a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 1 0v.282c.226-.079.496-.17.79-.26C4.606.272 5.67 0 6.5 0c.84 0 1.524.277 2.121.519l.043.018C9.286.788 9.828 1 10.5 1c.7 0 1.638-.23 2.437-.477a20 20 0 0 0 1.349-.476l.019-.007.004-.002h.001M14 1.221c-.22.078-.48.167-.766.255-.81.252-1.872.523-2.734.523-.886 0-1.592-.286-2.203-.534l-.008-.003C7.662 1.21 7.139 1 6.5 1c-.669 0-1.606.229-2.415.478A21 21 0 0 0 3 1.845v6.433c.22-.078.48-.167.766-.255C4.576 7.77 5.638 7.5 6.5 7.5c.847 0 1.548.28 2.158.525l.028.01C9.32 8.29 9.86 8.5 10.5 8.5c.668 0 1.606-.229 2.415-.478A21 21 0 0 0 14 7.655V1.222z' }, child: [] }] })(props);
}

export function SlRefresh(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 1024 1024' }, child: [{ tag: 'path', attr: { d: 'M497.408 898.56c-.08-.193-.272-.323-.385-.483l-91.92-143.664c-6.528-10.72-20.688-14.527-31.728-8.512l-8.193 5.04c-11.007 6-10.767 21.537-4.255 32.256l58.927 91.409c-5.024-1.104-10.096-2-15.056-3.296-103.184-26.993-190.495-96.832-239.535-191.6-46.336-89.52-55.04-191.695-24.512-287.743 30.512-96.048 99.775-174.464 189.295-220.784 15.248-7.888 21.2-26.64 13.312-41.856-7.872-15.264-26.64-21.231-41.855-13.327-104.272 53.952-184.4 145.28-219.969 257.152C45.982 485.008 56.11 604.033 110.078 708.29c57.136 110.336 158.832 191.664 279.024 223.136 1.36.352 2.784.56 4.16.911l-81.311 41.233c-11.008 6.032-14.657 19.631-8.128 30.351l3.152 8.176c6.56 10.72 17.84 14.527 28.815 8.512L484.622 944.4c.193-.128.385-.096.578-.224l9.984-5.456c5.52-3.024 9.168-7.969 10.624-13.505 1.52-5.52.815-11.663-2.448-16.991zm416.496-577.747c-57.056-110.304-155.586-191.63-275.762-223.118-8.56-2.24-17.311-3.984-26.048-5.712l79.824-40.48c11.008-6.033 17.568-19.632 11.04-30.369l-3.153-8.16c-6.56-10.736-20.752-14.528-31.727-8.528L519.262 80.654c-.176.112-.384.08-.577.208l-9.967 5.472c-5.537 3.04-9.168 7.967-10.624 13.503-1.52 5.52-.816 11.648 2.464 16.976l5.92 9.712c.096.192.272.305.384.497l91.92 143.648c6.512 10.736 20.688 14.528 31.712 8.513l7.216-5.025c11.008-6 11.727-21.536 5.231-32.24l-59.2-91.856c13.008 2 25.968 4.416 38.624 7.76 103.232 27.04 187.393 96.864 236.4 191.568 46.32 89.519 55.024 191.695 24.48 287.728-30.511 96.047-96.655 174.448-186.174 220.816-15.233 7.887-21.168 26.607-13.28 41.87 5.519 10.64 16.335 16.768 27.599 16.768 4.8 0 9.664-1.12 14.272-3.488 104.272-53.936 181.248-145.279 216.816-257.119 35.536-111.904 25.393-230.929-28.574-335.152z' }, child: [] }] })(props);
}

export function FiSkipForward(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'polygon', attr: { points: '5 4 15 12 5 20 5 4' }, child: [] },
      { tag: 'line', attr: { x1: '19', y1: '5', x2: '19', y2: '19' }, child: [] }
    ]
  })(props);
}

export function RiLoopRightLine(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24', fill: 'currentColor' }, child: [{ tag: 'path', attr: { d: 'M12 4C14.7486 4 17.1749 5.38626 18.6156 7.5H16V9.5H22V3.5H20V5.99936C18.1762 3.57166 15.2724 2 12 2C6.47715 2 2 6.47715 2 12H4C4 7.58172 7.58172 4 12 4ZM20 12C20 16.4183 16.4183 20 12 20C9.25144 20 6.82508 18.6137 5.38443 16.5H8V14.5H2V20.5H4V18.0006C5.82381 20.4283 8.72764 22 12 22C17.5228 22 22 17.5228 22 12H20Z' }, child: [] }] })(props);
}

export function BiText(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24' }, child: [{ tag: 'path', attr: { d: 'M5 8h2V6h3.252L7.68 18H5v2h8v-2h-2.252L13.32 6H17v2h2V4H5z' }, child: [] }] })(props);
}

export function MdOutlineNumbers(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'path', attr: { d: 'm20.5 10 .5-2h-4l1-4h-2l-1 4h-4l1-4h-2L9 8H5l-.5 2h4l-1 4h-4L3 16h4l-1 4h2l1-4h4l-1 4h2l1-4h4l.5-2h-4l1-4h4zm-7 4h-4l1-4h4l-1 4z' }, child: [] }
    ]
  })(props);
}

export function RxComponentBoolean(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 15 15', fill: 'none' }, child: [{ tag: 'path', attr: { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M7.85367 1.48956C7.65841 1.29429 7.34182 1.29429 7.14656 1.48956L1.48971 7.14641C1.29445 7.34167 1.29445 7.65825 1.48971 7.85352L7.14656 13.5104C7.34182 13.7056 7.65841 13.7056 7.85367 13.5104L13.5105 7.85352C13.7058 7.65825 13.7058 7.34167 13.5105 7.14641L7.85367 1.48956ZM7.5 2.55033L2.55037 7.49996L7.5 12.4496V2.55033Z', fill: 'currentColor' }, child: [] }] })(props);
}

export function FaList(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 512 512' }, child: [{ tag: 'path', attr: { d: 'M80 368H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm0-320H16A16 16 0 0 0 0 64v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16V64a16 16 0 0 0-16-16zm0 160H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm416 176H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z' }, child: [] }] })(props);
}

export function PiBracketsSquareLight(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 256 256', fill: 'currentColor' }, child: [{ tag: 'path', attr: { d: 'M46,46V210H80a6,6,0,0,1,0,12H40a6,6,0,0,1-6-6V40a6,6,0,0,1,6-6H80a6,6,0,0,1,0,12ZM216,34H176a6,6,0,0,0,0,12h34V210H176a6,6,0,0,0,0,12h40a6,6,0,0,0,6-6V40A6,6,0,0,0,216,34Z' }, child: [] }] })(props);
}

export function PiCaretDownBold(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 256 256', fill: 'currentColor' }, child: [{ tag: 'path', attr: { d: 'M216.49,104.49l-80,80a12,12,0,0,1-17,0l-80-80a12,12,0,0,1,17-17L128,159l71.51-71.52a12,12,0,0,1,17,17Z' }, child: [] }] })(props);
}

export function PiCaretRightBold(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 256 256', fill: 'currentColor' }, child: [{ tag: 'path', attr: { d: 'M184.49,136.49l-80,80a12,12,0,0,1-17-17L159,128,87.51,56.49a12,12,0,1,1,17-17l80,80A12,12,0,0,1,184.49,136.49Z' }, child: [] }] })(props);
}

export function IoRefresh(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 512 512' },
    child: [
      { tag: 'path', attr: { fill: 'none', strokeLinecap: 'round', strokeMiterlimit: '10', strokeWidth: '32', d: 'M320 146s24.36-12-64-12a160 160 0 1 0 160 160' }, child: [] },
      { tag: 'path', attr: { fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '32', d: 'm256 58 80 80-80 80' }, child: [] }
    ]
  })(props);
}

export function PiBracketsSquare(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 256 256', fill: 'currentColor' }, child: [{ tag: 'path', attr: { d: 'M48,48V208H80a8,8,0,0,1,0,16H40a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8H80a8,8,0,0,1,0,16ZM216,32H176a8,8,0,0,0,0,16h32V208H176a8,8,0,0,0,0,16h40a8,8,0,0,0,8-8V40A8,8,0,0,0,216,32Z' }, child: [] }] })(props);
}

export function SiStatuspal(props) {
  return GenIcon({ tag: 'svg', attr: { role: 'img', viewBox: '0 0 24 24' }, child: [{ tag: 'path', attr: { d: 'M14.275 9.296c0-1.242-1.02-2.25-2.275-2.25-1.256 0-2.275 1.008-2.275 2.25 0 .936.58 1.737 1.403 2.077L5.934 24c1.896-1.1 3.98-1.651 6.066-1.651 2.085 0 4.17.55 6.066 1.65l-5.194-12.626a2.251 2.251 0 001.403-2.077zm1.187 12.01A13.44 13.44 0 0012 20.849a13.44 13.44 0 00-3.463.457L12 13.389zM16.55 13.5a5.58 5.58 0 00-.723-7.535 5.732 5.732 0 00-7.654 0A5.58 5.58 0 007.45 13.5a6.167 6.167 0 01.143-8.716c2.446-2.379 6.368-2.379 8.813 0a6.167 6.167 0 01.144 8.716zm0 3c3.047-1.988 4.416-5.716 3.366-9.174C18.867 3.867 15.65 1.5 12 1.5c-3.65 0-6.869 2.367-7.917 5.826-1.049 3.458.32 7.186 3.367 9.174-3.481-2.029-5.16-6.111-4.096-9.968C4.417 2.675 7.96 0 12 0c4.042 0 7.583 2.675 8.646 6.532 1.063 3.857-.615 7.94-4.096 9.968z' }, child: [] }] })(props);
}

export function FiChevronUp(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }, child: [{ tag: 'polyline', attr: { points: '18 15 12 9 6 15' }, child: [] }] })(props);
}

export function MdDataArray(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'path', attr: { d: 'M15 4v2h3v12h-3v2h5V4zM4 20h5v-2H6V6h3V4H4z' }, child: [] }
    ]
  })(props);
}

export function MdFormatColorText(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'path', attr: { d: 'M2 20h20v4H2v-4zm3.49-3h2.42l1.27-3.58h5.65L16.09 17h2.42L13.25 3h-2.5L5.49 17zm4.42-5.61 2.03-5.79h.12l2.03 5.79H9.91z' }, child: [] }
    ]
  })(props);
}

export function MdNotificationsNone(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'path', attr: { d: 'M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z' }, child: [] }
    ]
  })(props);
}

export function MdOutlineFormatListBulleted(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0V0z' }, child: [] },
      { tag: 'path', attr: { d: 'M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z' }, child: [] }
    ]
  })(props);
}

export function RiAsterisk(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24', fill: 'currentColor' }, child: [{ tag: 'path', attr: { d: 'M12.9998 3L12.9996 10.267L19.294 6.63397L20.294 8.36602L14.0006 11.999L20.294 15.634L19.294 17.366L12.9996 13.732L12.9998 21H10.9998L10.9996 13.732L4.70557 17.366L3.70557 15.634L9.99857 12L3.70557 8.36602L4.70557 6.63397L10.9996 10.267L10.9998 3H12.9998Z' }, child: [] }] })(props);
}

export function LuSignalLow(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M2 20h.01' }, child: [] },
      { tag: 'path', attr: { d: 'M7 20v-4' }, child: [] }
    ]
  })(props);
}

export function FaRegCircleQuestion(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 512 512' }, child: [{ tag: 'path', attr: { d: 'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z' }, child: [] }] })(props);
}

export function FiArrowLeft(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'line', attr: { x1: '19', y1: '12', x2: '5', y2: '12' }, child: [] },
      { tag: 'polyline', attr: { points: '12 19 5 12 12 5' }, child: [] }
    ]
  })(props);
}

export function IoIosArrowBack(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 512 512' }, child: [{ tag: 'path', attr: { d: 'M217.9 256L345 129c9.4-9.4 9.4-24.6 0-33.9-9.4-9.4-24.6-9.3-34 0L167 239c-9.1 9.1-9.3 23.7-.7 33.1L310.9 417c4.7 4.7 10.9 7 17 7s12.3-2.3 17-7c9.4-9.4 9.4-24.6 0-33.9L217.9 256z' }, child: [] }] })(props);
}

export function FcAcceptDatabase(props) {
  return GenIcon({
    tag: 'svg',
    attr: { version: '1', viewBox: '0 0 48 48', enableBackground: 'new 0 0 48 48' },
    child: [
      {
        tag: 'g',
        attr: { fill: '#D1C4E9' },
        child: [
          { tag: 'path', attr: { d: 'M38,7H10C8.9,7,8,7.9,8,9v6c0,1.1,0.9,2,2,2h28c1.1,0,2-0.9,2-2V9C40,7.9,39.1,7,38,7z' }, child: [] },
          { tag: 'path', attr: { d: 'M38,19H10c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h28c1.1,0,2-0.9,2-2v-6C40,19.9,39.1,19,38,19z' }, child: [] },
          { tag: 'path', attr: { d: 'M38,31H10c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h28c1.1,0,2-0.9,2-2v-6C40,31.9,39.1,31,38,31z' }, child: [] }
        ]
      },
      { tag: 'circle', attr: { fill: '#43A047', cx: '38', cy: '38', r: '10' }, child: [] },
      { tag: 'polygon', attr: { fill: '#DCEDC8', points: '42.5,33.3 36.8,39 34.1,36.3 32,38.5 36.8,43.3 44.6,35.5' }, child: [] }
    ]
  })(props);
}

export function BsArrowsExpandVertical(props) {
  return GenIcon({ tag: 'svg', attr: { fill: 'currentColor', viewBox: '0 0 16 16' }, child: [{ tag: 'path', attr: { d: 'M8 15a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5M.146 8.354a.5.5 0 0 1 0-.708l2-2a.5.5 0 1 1 .708.708L1.707 7.5H5.5a.5.5 0 0 1 0 1H1.707l1.147 1.146a.5.5 0 0 1-.708.708zM10 8a.5.5 0 0 1 .5-.5h3.793l-1.147-1.146a.5.5 0 0 1 .708-.708l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L14.293 8.5H10.5A.5.5 0 0 1 10 8' }, child: [] }] })(props);
}

export function BsArrowsCollapseVertical(props) {
  return GenIcon({ tag: 'svg', attr: { fill: 'currentColor', viewBox: '0 0 16 16' }, child: [{ tag: 'path', attr: { d: 'M8 15a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5M0 8a.5.5 0 0 1 .5-.5h3.793L3.146 6.354a.5.5 0 1 1 .708-.708l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L4.293 8.5H.5A.5.5 0 0 1 0 8m11.707.5 1.147 1.146a.5.5 0 0 1-.708.708l-2-2a.5.5 0 0 1 0-.708l2-2a.5.5 0 0 1 .708.708L11.707 7.5H15.5a.5.5 0 0 1 0 1z' }, child: [] }] })(props);
}

export function GrInherit(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24' }, child: [{ tag: 'path', attr: { fill: 'none', strokeWidth: '2', d: 'M17,18 L12,15 L17,18 Z M7,18 L12,15 L12,11 M17,20 C17,21.657 18.343,23 20,23 C21.657,23 23,21.657 23,20 C23,18.343 21.657,17 20,17 C18.343,17 17,18.343 17,20 L17,20 L17,20 Z M4,17 C2.343,17 1,18.343 1,20 C1,21.657 2.343,23 4,23 C5.657,23 7,21.657 7,20 C7,18.343 5.657,17 4,17 L4,17 L4,17 Z M17,6 C17,8.761 14.761,11 12,11 C9.239,11 7,8.761 7,6 C7,3.239 9.239,1 12,1 C14.761,1 17,3.239 17,6 L17,6 L17,6 Z' }, child: [] }] })(props);
}

export function GrResources(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24' }, child: [{ tag: 'path', attr: { fill: 'none', strokeWidth: '2', d: 'M12,3 L21,7.5 L12,12 L3,7.5 L12,3 Z M16.5,10.25 L21,12.5 L12,17 L3,12.5 L7.5,10.25 L7.5,10.25 M16.5,15.25 L21,17.5 L12,22 L3,17.5 L7.5,15.25 L7.5,15.25' }, child: [] }] })(props);
}

export function MdAddCircleOutline(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'path', attr: { d: 'M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' }, child: [] }
    ]
  })(props);
}

export function GoLinkExternal(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { d: 'M15.5 2.25a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0V4.06l-6.22 6.22a.75.75 0 1 1-1.06-1.06L19.94 3h-3.69a.75.75 0 0 1-.75-.75Z' }, child: [] },
      { tag: 'path', attr: { d: 'M2.5 4.25c0-.966.784-1.75 1.75-1.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.25.25 0 0 0-.25.25v15.5c0 .138.112.25.25.25h15.5a.25.25 0 0 0 .25-.25v-8.5a.75.75 0 0 1 1.5 0v8.5a1.75 1.75 0 0 1-1.75 1.75H4.25a1.75 1.75 0 0 1-1.75-1.75V4.25Z' }, child: [] }
    ]
  })(props);
}

export function PiCaretDownLight(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 256 256', fill: 'currentColor' }, child: [{ tag: 'path', attr: { d: 'M212.24,100.24l-80,80a6,6,0,0,1-8.48,0l-80-80a6,6,0,0,1,8.48-8.48L128,167.51l75.76-75.75a6,6,0,0,1,8.48,8.48Z' }, child: [] }] })(props);
}

export function HiPlus(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 20 20', fill: 'currentColor', 'aria-hidden': 'true' }, child: [{ tag: 'path', attr: { fillRule: 'evenodd', d: 'M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z', clipRule: 'evenodd' }, child: [] }] })(props);
}

export function AiFillApi(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 1024 1024' }, child: [{ tag: 'path', attr: { d: 'M917.7 148.8l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 0 0-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 0 0 0 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM578.9 546.7a8.03 8.03 0 0 0-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 0 0-11.3 0L363 475.3l-43-43a7.85 7.85 0 0 0-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2c-68.9 68.9-77 175.7-24.3 253.5l-76.1 76.1a8.03 8.03 0 0 0 0 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2z' }, child: [] }] })(props);
}

export function GrContactInfo(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24' }, child: [{ tag: 'path', attr: { fill: 'none', strokeWidth: '2', d: 'M5,12 C3.343,12 2,10.657 2,9 C2,7.343 3.343,6 5,6 C6.657,6 8,7.343 8,9 C8,10.657 6.657,12 5,12 Z M9,18 L9,16 C9,13.7504 7.2128,12 4.964,12 L5.0184,12 C2.7688,12 1,13.7504 1,16 L1,18 M12,7 L24,7 M12,17 L22,17 M12,12 L19,12' }, child: [] }] })(props);
}

export function IoSettingsOutline(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 512 512' }, child: [{ tag: 'path', attr: { fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '32', d: 'M262.29 192.31a64 64 0 1 0 57.4 57.4 64.13 64.13 0 0 0-57.4-57.4zM416.39 256a154.34 154.34 0 0 1-1.53 20.79l45.21 35.46a10.81 10.81 0 0 1 2.45 13.75l-42.77 74a10.81 10.81 0 0 1-13.14 4.59l-44.9-18.08a16.11 16.11 0 0 0-15.17 1.75A164.48 164.48 0 0 1 325 400.8a15.94 15.94 0 0 0-8.82 12.14l-6.73 47.89a11.08 11.08 0 0 1-10.68 9.17h-85.54a11.11 11.11 0 0 1-10.69-8.87l-6.72-47.82a16.07 16.07 0 0 0-9-12.22 155.3 155.3 0 0 1-21.46-12.57 16 16 0 0 0-15.11-1.71l-44.89 18.07a10.81 10.81 0 0 1-13.14-4.58l-42.77-74a10.8 10.8 0 0 1 2.45-13.75l38.21-30a16.05 16.05 0 0 0 6-14.08c-.36-4.17-.58-8.33-.58-12.5s.21-8.27.58-12.35a16 16 0 0 0-6.07-13.94l-38.19-30A10.81 10.81 0 0 1 49.48 186l42.77-74a10.81 10.81 0 0 1 13.14-4.59l44.9 18.08a16.11 16.11 0 0 0 15.17-1.75A164.48 164.48 0 0 1 187 111.2a15.94 15.94 0 0 0 8.82-12.14l6.73-47.89A11.08 11.08 0 0 1 213.23 42h85.54a11.11 11.11 0 0 1 10.69 8.87l6.72 47.82a16.07 16.07 0 0 0 9 12.22 155.3 155.3 0 0 1 21.46 12.57 16 16 0 0 0 15.11 1.71l44.89-18.07a10.81 10.81 0 0 1 13.14 4.58l42.77 74a10.8 10.8 0 0 1-2.45 13.75l-38.21 30a16.05 16.05 0 0 0-6.05 14.08c.33 4.14.55 8.3.55 12.47z' }, child: [] }] })(props);
}

export function IoCodeSlashOutline(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 512 512' }, child: [{ tag: 'path', attr: { fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '32', d: 'M160 368 32 256l128-112m192 224 128-112-128-112m-48-48-96 320' }, child: [] }] })(props);
}

export function MdOutlineRawOn(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'path', attr: { d: 'M6.5 9H3v6h1.5v-2h1.1l.9 2H8l-.9-2.1c.5-.3.9-.8.9-1.4v-1C8 9.7 7.3 9 6.5 9zm0 2.5h-2v-1h2v1zM10.25 9l-1.5 6h1.5l.38-1.5h1.75l.37 1.5h1.5l-1.5-6h-2.5zm.75 3 .25-1h.5l.25 1h-1zM19.98 9l-.74 3-.74-3h-1.52l-.74 3-.74-3H14l1.5 6h1.48l.76-3.04.76 3.04h1.48l1.5-6z' }, child: [] }
    ]
  })(props);
}

export function TbLetterCaseToggle(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M6.5 15.5m-3.5 0a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0 -7 0' }, child: [] },
      { tag: 'path', attr: { d: 'M14 19v-10.5a3.5 3.5 0 0 1 7 0v10.5' }, child: [] },
      { tag: 'path', attr: { d: 'M14 13h7' }, child: [] },
      { tag: 'path', attr: { d: 'M10 12v7' }, child: [] }
    ]
  })(props);
}

export function AiOutlineMenu(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 1024 1024' }, child: [{ tag: 'path', attr: { d: 'M904 160H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0 624H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0-312H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z' }, child: [] }] })(props);
}

export function IoDocumentOutline(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 512 512' },
    child: [
      { tag: 'path', attr: { fill: 'none', strokeLinejoin: 'round', strokeWidth: '32', d: 'M416 221.25V416a48 48 0 0 1-48 48H144a48 48 0 0 1-48-48V96a48 48 0 0 1 48-48h98.75a32 32 0 0 1 22.62 9.37l141.26 141.26a32 32 0 0 1 9.37 22.62z' }, child: [] },
      { tag: 'path', attr: { fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '32', d: 'M256 56v120a32 32 0 0 0 32 32h120' }, child: [] }
    ]
  })(props);
}

export function FiFlag(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z' }, child: [] },
      { tag: 'line', attr: { x1: '4', y1: '22', x2: '4', y2: '15' }, child: [] }
    ]
  })(props);
}

export function FiHelpCircle(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'circle', attr: { cx: '12', cy: '12', r: '10' }, child: [] },
      { tag: 'path', attr: { d: 'M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3' }, child: [] },
      { tag: 'line', attr: { x1: '12', y1: '17', x2: '12.01', y2: '17' }, child: [] }
    ]
  })(props);
}

export function LuMilestone(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M12 13v8' }, child: [] },
      { tag: 'path', attr: { d: 'M12 3v3' }, child: [] },
      { tag: 'path', attr: { d: 'M4 6a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h13a2 2 0 0 0 1.152-.365l3.424-2.317a1 1 0 0 0 0-1.635l-3.424-2.318A2 2 0 0 0 17 6z' }, child: [] }
    ]
  })(props);
}

export function BsSliders2(props) {
  return GenIcon({ tag: 'svg', attr: { fill: 'currentColor', viewBox: '0 0 16 16' }, child: [{ tag: 'path', attr: { fillRule: 'evenodd', d: 'M10.5 1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V4H1.5a.5.5 0 0 1 0-1H10V1.5a.5.5 0 0 1 .5-.5M12 3.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5m-6.5 2A.5.5 0 0 1 6 6v1.5h8.5a.5.5 0 0 1 0 1H6V10a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5M1 8a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2A.5.5 0 0 1 1 8m9.5 2a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V13H1.5a.5.5 0 0 1 0-1H10v-1.5a.5.5 0 0 1 .5-.5m1.5 2.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5' }, child: [] }] })(props);
}

export function MdTransform(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'path', attr: { d: 'M22 18v-2H8V4h2L7 1 4 4h2v2H2v2h4v8c0 1.1.9 2 2 2h8v2h-2l3 3 3-3h-2v-2h4zM10 8h6v6h2V8c0-1.1-.9-2-2-2h-6v2z' }, child: [] }
    ]
  })(props);
}

export function ImLoop2(props) {
  return GenIcon({
    tag: 'svg',
    attr: { version: '1.1', viewBox: '0 0 16 16' },
    child: [
      { tag: 'path', attr: { d: 'M13.901 2.599c-1.463-1.597-3.565-2.599-5.901-2.599-4.418 0-8 3.582-8 8h1.5c0-3.59 2.91-6.5 6.5-6.5 1.922 0 3.649 0.835 4.839 2.161l-2.339 2.339h5.5v-5.5l-2.099 2.099z' }, child: [] },
      { tag: 'path', attr: { d: 'M14.5 8c0 3.59-2.91 6.5-6.5 6.5-1.922 0-3.649-0.835-4.839-2.161l2.339-2.339h-5.5v5.5l2.099-2.099c1.463 1.597 3.565 2.599 5.901 2.599 4.418 0 8-3.582 8-8h-1.5z' }, child: [] }
    ]
  })(props);
}

export function RiMindMap(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24', fill: 'currentColor' }, child: [{ tag: 'path', attr: { d: 'M18 3C19.6569 3 21 4.34315 21 6C21 7.65685 19.6569 9 18 9H15C13.6941 9 12.5831 8.16562 12.171 7.0009L11 7C9.9 7 9 7.9 9 9L9.0009 9.17102C10.1656 9.58312 11 10.6941 11 12C11 13.3059 10.1656 14.4169 9.0009 14.829L9 15C9 16.1 9.9 17 11 17L12.1707 17.0001C12.5825 15.8349 13.6937 15 15 15H18C19.6569 15 21 16.3431 21 18C21 19.6569 19.6569 21 18 21H15C13.6941 21 12.5831 20.1656 12.171 19.0009L11 19C8.79 19 7 17.21 7 15H5C3.34315 15 2 13.6569 2 12C2 10.3431 3.34315 9 5 9H7C7 6.79086 8.79086 5 11 5L12.1707 5.00009C12.5825 3.83485 13.6937 3 15 3H18ZM18 17H15C14.4477 17 14 17.4477 14 18C14 18.5523 14.4477 19 15 19H18C18.5523 19 19 18.5523 19 18C19 17.4477 18.5523 17 18 17ZM8 11H5C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13H8C8.55228 13 9 12.5523 9 12C9 11.4477 8.55228 11 8 11ZM18 5H15C14.4477 5 14 5.44772 14 6C14 6.55228 14.4477 7 15 7H18C18.5523 7 19 6.55228 19 6C19 5.44772 18.5523 5 18 5Z' }, child: [] }] })(props);
}

export function BiFilterAlt(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24' }, child: [{ tag: 'path', attr: { d: 'M21 3H5a1 1 0 0 0-1 1v2.59c0 .523.213 1.037.583 1.407L10 13.414V21a1.001 1.001 0 0 0 1.447.895l4-2c.339-.17.553-.516.553-.895v-5.586l5.417-5.417c.37-.37.583-.884.583-1.407V4a1 1 0 0 0-1-1zm-6.707 9.293A.996.996 0 0 0 14 13v5.382l-2 1V13a.996.996 0 0 0-.293-.707L6 6.59V5h14.001l.002 1.583-5.71 5.71z' }, child: [] }] })(props);
}

export function IoAlert(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 512 512' },
    child: [
      { tag: 'path', attr: { fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '32', d: 'M256 80c-8.66 0-16.58 7.36-16 16l8 216a8 8 0 0 0 8 8h0a8 8 0 0 0 8-8l8-216c.58-8.64-7.34-16-16-16z' }, child: [] },
      { tag: 'circle', attr: { cx: '256', cy: '416', r: '16', fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '32' }, child: [] }
    ]
  })(props);
}

export function GoCircle(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24' }, child: [{ tag: 'path', attr: { d: 'M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm11-9.5A9.5 9.5 0 0 0 2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5Z' }, child: [] }] })(props);
}

export function MdOutlineLocationOn(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0V0z' }, child: [] },
      { tag: 'path', attr: { d: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zM7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9z' }, child: [] },
      { tag: 'circle', attr: { cx: '12', cy: '9', r: '2.5' }, child: [] }
    ]
  })(props);
}

export function BsSortNumericDown(props) {
  return GenIcon({
    tag: 'svg',
    attr: { fill: 'currentColor', viewBox: '0 0 16 16' },
    child: [
      { tag: 'path', attr: { d: 'M12.438 1.668V7H11.39V2.684h-.051l-1.211.859v-.969l1.262-.906h1.046z' }, child: [] },
      { tag: 'path', attr: { fillRule: 'evenodd', d: 'M11.36 14.098c-1.137 0-1.708-.657-1.762-1.278h1.004c.058.223.343.45.773.45.824 0 1.164-.829 1.133-1.856h-.059c-.148.39-.57.742-1.261.742-.91 0-1.72-.613-1.72-1.758 0-1.148.848-1.835 1.973-1.835 1.09 0 2.063.636 2.063 2.687 0 1.867-.723 2.848-2.145 2.848zm.062-2.735c.504 0 .933-.336.933-.972 0-.633-.398-1.008-.94-1.008-.52 0-.927.375-.927 1 0 .64.418.98.934.98' }, child: [] },
      { tag: 'path', attr: { d: 'M4.5 2.5a.5.5 0 0 0-1 0v9.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L4.5 12.293z' }, child: [] }
    ]
  })(props);
}

export function TbBrandOauth(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M12 12m-10 0a10 10 0 1 0 20 0a10 10 0 1 0 -20 0' }, child: [] },
      { tag: 'path', attr: { d: 'M12.556 6c.65 0 1.235 .373 1.508 .947l2.839 7.848a1.646 1.646 0 0 1 -1.01 2.108a1.673 1.673 0 0 1 -2.068 -.851l-.46 -1.052h-2.73l-.398 .905a1.67 1.67 0 0 1 -1.977 1.045l-.153 -.047a1.647 1.647 0 0 1 -1.056 -1.956l2.824 -7.852a1.664 1.664 0 0 1 1.409 -1.087l1.272 -.008z' }, child: [] }
    ]
  })(props);
}

export function PiKeyBold(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 256 256', fill: 'currentColor' }, child: [{ tag: 'path', attr: { d: 'M196,76a16,16,0,1,1-16-16A16,16,0,0,1,196,76Zm48,22.74A84.3,84.3,0,0,1,160.11,180H160a83.52,83.52,0,0,1-23.65-3.38l-7.86,7.87A12,12,0,0,1,120,188H108v12a12,12,0,0,1-12,12H84v12a12,12,0,0,1-12,12H40a20,20,0,0,1-20-20V187.31a19.86,19.86,0,0,1,5.86-14.14l53.52-53.52A84,84,0,1,1,244,98.74ZM202.43,53.57A59.48,59.48,0,0,0,158,36c-32,1-58,27.89-58,59.89a59.69,59.69,0,0,0,4.2,22.19,12,12,0,0,1-2.55,13.21L44,189v23H60V200a12,12,0,0,1,12-12H84V176a12,12,0,0,1,12-12h19l9.65-9.65a12,12,0,0,1,13.22-2.55A59.58,59.58,0,0,0,160,156h.08c32,0,58.87-26.07,59.89-58A59.55,59.55,0,0,0,202.43,53.57Z' }, child: [] }] })(props);
}

export function PiKeyDuotone(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 256 256', fill: 'currentColor' },
    child: [
      { tag: 'path', attr: { d: 'M232,98.36C230.73,136.92,198.67,168,160.09,168a71.68,71.68,0,0,1-26.92-5.17h0L120,176H96v24H72v24H40a8,8,0,0,1-8-8V187.31a8,8,0,0,1,2.34-5.65l58.83-58.83h0A71.68,71.68,0,0,1,88,95.91c0-38.58,31.08-70.64,69.64-71.87A72,72,0,0,1,232,98.36Z', opacity: '0.2' }, child: [] },
      { tag: 'path', attr: { d: 'M216.57,39.43A80,80,0,0,0,83.91,120.78L28.69,176A15.86,15.86,0,0,0,24,187.31V216a16,16,0,0,0,16,16H72a8,8,0,0,0,8-8V208H96a8,8,0,0,0,8-8V184h16a8,8,0,0,0,5.66-2.34l9.56-9.57A79.73,79.73,0,0,0,160,176h.1A80,80,0,0,0,216.57,39.43ZM224,98.1c-1.09,34.09-29.75,61.86-63.89,61.9H160a63.7,63.7,0,0,1-23.65-4.51,8,8,0,0,0-8.84,1.68L116.69,168H96a8,8,0,0,0-8,8v16H72a8,8,0,0,0-8,8v16H40V187.31l58.83-58.82a8,8,0,0,0,1.68-8.84A63.72,63.72,0,0,1,96,95.92c0-34.14,27.81-62.8,61.9-63.89A64,64,0,0,1,224,98.1ZM192,76a12,12,0,1,1-12-12A12,12,0,0,1,192,76Z' }, child: [] }
    ]
  })(props);
}

export function BiCode(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24' }, child: [{ tag: 'path', attr: { d: 'M8.293 6.293 2.586 12l5.707 5.707 1.414-1.414L5.414 12l4.293-4.293zm7.414 11.414L21.414 12l-5.707-5.707-1.414 1.414L18.586 12l-4.293 4.293z' }, child: [] }] })(props);
}

export function LuFileJson2(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4' }, child: [] },
      { tag: 'path', attr: { d: 'M14 2v4a2 2 0 0 0 2 2h4' }, child: [] },
      { tag: 'path', attr: { d: 'M4 12a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1 1 1 0 0 1 1 1v1a1 1 0 0 0 1 1' }, child: [] },
      { tag: 'path', attr: { d: 'M8 18a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1 1 1 0 0 1-1-1v-1a1 1 0 0 0-1-1' }, child: [] }
    ]
  })(props);
}

export function FiLogOut(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4' }, child: [] },
      { tag: 'polyline', attr: { points: '16 17 21 12 16 7' }, child: [] },
      { tag: 'line', attr: { x1: '21', y1: '12', x2: '9', y2: '12' }, child: [] }
    ]
  })(props);
}

export function IoMdCheckmark(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 512 512' }, child: [{ tag: 'path', attr: { d: 'M186.301 339.893L96 249.461l-32 30.507L186.301 402 448 140.506 416 110z' }, child: [] }] })(props);
}

export function FiTrash2(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'polyline', attr: { points: '3 6 5 6 21 6' }, child: [] },
      { tag: 'path', attr: { d: 'M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2' }, child: [] },
      { tag: 'line', attr: { x1: '10', y1: '11', x2: '10', y2: '17' }, child: [] },
      { tag: 'line', attr: { x1: '14', y1: '11', x2: '14', y2: '17' }, child: [] }
    ]
  })(props);
}

export function TbKey(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M16.555 3.843l3.602 3.602a2.877 2.877 0 0 1 0 4.069l-2.643 2.643a2.877 2.877 0 0 1 -4.069 0l-.301 -.301l-6.558 6.558a2 2 0 0 1 -1.239 .578l-.175 .008h-1.172a1 1 0 0 1 -.993 -.883l-.007 -.117v-1.172a2 2 0 0 1 .467 -1.284l.119 -.13l.414 -.414h2v-2h2v-2l2.144 -2.144l-.301 -.301a2.877 2.877 0 0 1 0 -4.069l2.643 -2.643a2.877 2.877 0 0 1 4.069 0z' }, child: [] },
      { tag: 'path', attr: { d: 'M15 9h.01' }, child: [] }
    ]
  })(props);
}

export function RxInput(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 15 15', fill: 'none' }, child: [{ tag: 'path', attr: { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M6.5 1C6.22386 1 6 1.22386 6 1.5C6 1.77614 6.22386 2 6.5 2C7.12671 2 7.45718 2.20028 7.65563 2.47812C7.8781 2.78957 8 3.28837 8 4V11C8 11.7116 7.8781 12.2104 7.65563 12.5219C7.45718 12.7997 7.12671 13 6.5 13C6.22386 13 6 13.2239 6 13.5C6 13.7761 6.22386 14 6.5 14C7.37329 14 8.04282 13.7003 8.46937 13.1031C8.47976 13.0886 8.48997 13.0739 8.5 13.0591C8.51003 13.0739 8.52024 13.0886 8.53063 13.1031C8.95718 13.7003 9.62671 14 10.5 14C10.7761 14 11 13.7761 11 13.5C11 13.2239 10.7761 13 10.5 13C9.87329 13 9.54282 12.7997 9.34437 12.5219C9.1219 12.2104 9 11.7116 9 11V4C9 3.28837 9.1219 2.78957 9.34437 2.47812C9.54282 2.20028 9.87329 2 10.5 2C10.7761 2 11 1.77614 11 1.5C11 1.22386 10.7761 1 10.5 1C9.62671 1 8.95718 1.29972 8.53063 1.89688C8.52024 1.91143 8.51003 1.92611 8.5 1.9409C8.48997 1.92611 8.47976 1.91143 8.46937 1.89688C8.04282 1.29972 7.37329 1 6.5 1ZM14 5H11V4H14C14.5523 4 15 4.44772 15 5V10C15 10.5523 14.5523 11 14 11H11V10H14V5ZM6 4V5H1L1 10H6V11H1C0.447715 11 0 10.5523 0 10V5C0 4.44772 0.447715 4 1 4H6Z', fill: 'currentColor' }, child: [] }] })(props);
}

export function HiOutlineChevronRight(props) {
  return GenIcon({ tag: 'svg', attr: { fill: 'none', viewBox: '0 0 24 24', strokeWidth: '2', stroke: 'currentColor', 'aria-hidden': 'true' }, child: [{ tag: 'path', attr: { strokeLinecap: 'round', strokeLinejoin: 'round', d: 'M9 5l7 7-7 7' }, child: [] }] })(props);
}

export function MdMoreHoriz(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'path', attr: { d: 'M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' }, child: [] }
    ]
  })(props);
}

export function FiEdit(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7' }, child: [] },
      { tag: 'path', attr: { d: 'M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z' }, child: [] }
    ]
  })(props);
}

export function AiOutlineSend(props) {
  return GenIcon({ tag: 'svg', attr: { t: '1569683742680', viewBox: '0 0 1024 1024', version: '1.1' }, child: [{ tag: 'path', attr: { d: 'M931.4 498.9L94.9 79.5c-3.4-1.7-7.3-2.1-11-1.2-8.5 2.1-13.8 10.7-11.7 19.3l86.2 352.2c1.3 5.3 5.2 9.6 10.4 11.3l147.7 50.7-147.6 50.7c-5.2 1.8-9.1 6-10.3 11.3L72.2 926.5c-0.9 3.7-0.5 7.6 1.2 10.9 3.9 7.9 13.5 11.1 21.5 7.2l836.5-417c3.1-1.5 5.6-4.1 7.2-7.1 3.9-8 0.7-17.6-7.2-21.6zM170.8 826.3l50.3-205.6 295.2-101.3c2.3-0.8 4.2-2.6 5-5 1.4-4.2-0.8-8.7-5-10.2L221.1 403 171 198.2l628 314.9-628.2 313.2z' }, child: [] }] })(props);
}

export function BsEnvelopeCheck(props) {
  return GenIcon({
    tag: 'svg',
    attr: { fill: 'currentColor', viewBox: '0 0 16 16' },
    child: [
      { tag: 'path', attr: { d: 'M2 2a2 2 0 0 0-2 2v8.01A2 2 0 0 0 2 14h5.5a.5.5 0 0 0 0-1H2a1 1 0 0 1-.966-.741l5.64-3.471L8 9.583l7-4.2V8.5a.5.5 0 0 0 1 0V4a2 2 0 0 0-2-2zm3.708 6.208L1 11.105V5.383zM1 4.217V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.217l-7 4.2z' }, child: [] },
      { tag: 'path', attr: { d: 'M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686' }, child: [] }
    ]
  })(props);
}

export function IoPlayOutline(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 512 512' }, child: [{ tag: 'path', attr: { fill: 'none', strokeMiterlimit: '10', strokeWidth: '32', d: 'M112 111v290c0 17.44 17 28.52 31 20.16l247.9-148.37c12.12-7.25 12.12-26.33 0-33.58L143 90.84c-14-8.36-31 2.72-31 20.16z' }, child: [] }] })(props);
}

export function PiAsteriskBold(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 256 256', fill: 'currentColor' }, child: [{ tag: 'path', attr: { d: 'M218.29,182.17a12,12,0,0,1-16.47,4.12L140,149.19V216a12,12,0,0,1-24,0V149.19l-61.82,37.1a12,12,0,1,1-12.35-20.58L104.68,128,41.83,90.29A12,12,0,1,1,54.18,69.71L116,106.81V40a12,12,0,0,1,24,0v66.81l61.82-37.1a12,12,0,1,1,12.35,20.58L151.32,128l62.85,37.71A12,12,0,0,1,218.29,182.17Z' }, child: [] }] })(props);
}

export function FiEdit3(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M12 20h9' }, child: [] },
      { tag: 'path', attr: { d: 'M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z' }, child: [] }
    ]
  })(props);
}

export function FiEdit2(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }, child: [{ tag: 'path', attr: { d: 'M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z' }, child: [] }] })(props);
}

export function FiSave(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z' }, child: [] },
      { tag: 'polyline', attr: { points: '17 21 17 13 7 13 7 21' }, child: [] },
      { tag: 'polyline', attr: { points: '7 3 7 8 15 8' }, child: [] }
    ]
  })(props);
}

export function VscSymbolOperator(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 16 16', fill: 'currentColor' }, child: [{ tag: 'path', attr: { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M2.873 1.1c.335.136.602.398.745.73.072.17.109.352.107.537a1.34 1.34 0 0 1-.61 1.135 1.359 1.359 0 0 1-.753.223A1.355 1.355 0 0 1 1 2.362a1.355 1.355 0 0 1 .83-1.256A1.37 1.37 0 0 1 2.873 1.1zm-.298 1.765a.551.551 0 0 0 .332-.5.548.548 0 1 0-.332.5zM6.43 1.109L1.11 6.43l.686.687 5.32-5.32-.686-.687zM11.5 9h1v2.5H15v1h-2.5V15h-1v-2.5H9v-1h2.5V9zm-5.732.525l.707.707L4.707 12l1.768 1.768-.707.707L4 12.707l-1.768 1.768-.707-.707L3.293 12l-1.768-1.768.707-.707L4 11.293l1.768-1.768zm1.35-4.195a1.353 1.353 0 0 0-1.256-.83 1.355 1.355 0 0 0-1.256.83 1.362 1.362 0 0 0 1.257 1.895A1.358 1.358 0 0 0 7.118 5.33zm-.753.745a.553.553 0 0 1-.289.29.547.547 0 0 1-.599-.117.529.529 0 0 1-.117-.173.544.544 0 0 1 .716-.715.565.565 0 0 1 .173.116.549.549 0 0 1 .116.599zM14 3h-4v1h4V3z' }, child: [] }] })(props);
}

export function CgToggleOff(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none' },
    child: [
      { tag: 'path', attr: { d: 'M17 15C18.6569 15 20 13.6569 20 12C20 10.3431 18.6569 9 17 9C15.3431 9 14 10.3431 14 12C14 13.6569 15.3431 15 17 15Z', fill: 'currentColor' }, child: [] },
      { tag: 'path', attr: { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M0 12C0 8.13401 3.13401 5 7 5H17C20.866 5 24 8.13401 24 12C24 15.866 20.866 19 17 19H7C3.13401 19 0 15.866 0 12ZM7 7H17C19.7614 7 22 9.23858 22 12C22 14.7614 19.7614 17 17 17H7C4.23858 17 2 14.7614 2 12C2 9.23858 4.23858 7 7 7Z', fill: 'currentColor' }, child: [] }
    ]
  })(props);
}

export function CgToggleOn(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none' },
    child: [
      { tag: 'path', attr: { d: 'M7 15C5.34315 15 4 13.6569 4 12C4 10.3431 5.34315 9 7 9C8.65685 9 10 10.3431 10 12C10 13.6569 8.65685 15 7 15Z', fill: 'currentColor' }, child: [] },
      { tag: 'path', attr: { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M24 12C24 8.13401 20.866 5 17 5H7C3.13401 5 0 8.13401 0 12C0 15.866 3.13401 19 7 19H17C20.866 19 24 15.866 24 12ZM17 7H7C4.23858 7 2 9.23858 2 12C2 14.7614 4.23858 17 7 17H17C19.7614 17 22 14.7614 22 12C22 9.23858 19.7614 7 17 7Z', fill: 'currentColor' }, child: [] }
    ]
  })(props);
}

export function MdOutlineLabel(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0V0z' }, child: [] },
      { tag: 'path', attr: { d: 'M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16zM16 17H5V7h11l3.55 5L16 17z' }, child: [] }
    ]
  })(props);
}

export function MdOutlineNewLabel(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'path', attr: { d: 'm21 12-4.37 6.16c-.37.52-.98.84-1.63.84h-3v-2h3l3.55-5L15 7H5v3H3V7c0-1.1.9-2 2-2h10c.65 0 1.26.31 1.63.84L21 12zm-11 3H7v-3H5v3H2v2h3v3h2v-3h3v-2z' }, child: [] }
    ]
  })(props);
}

export function FiFilter(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }, child: [{ tag: 'polygon', attr: { points: '22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3' }, child: [] }] })(props);
}

export function FiScissors(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'circle', attr: { cx: '6', cy: '6', r: '3' }, child: [] },
      { tag: 'circle', attr: { cx: '6', cy: '18', r: '3' }, child: [] },
      { tag: 'line', attr: { x1: '20', y1: '4', x2: '8.12', y2: '15.88' }, child: [] },
      { tag: 'line', attr: { x1: '14.47', y1: '14.48', x2: '20', y2: '20' }, child: [] },
      { tag: 'line', attr: { x1: '8.12', y1: '8.12', x2: '12', y2: '12' }, child: [] }
    ]
  })(props);
}

export function BiCustomize(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24' }, child: [{ tag: 'path', attr: { d: 'M4 11h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zm1-6h4v4H5V5zm15-2h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm-1 6h-4V5h4v4zm-9 12a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6zm-5-6h4v4H5v-4zm13-1h-2v2h-2v2h2v2h2v-2h2v-2h-2z' }, child: [] }] })(props);
}

export function GoNumber(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24' }, child: [{ tag: 'path', attr: { d: 'M13.003 7.754a.75.75 0 0 1 .75-.75h5.232a.75.75 0 0 1 .53 1.28l-2.776 2.777c.55.097 1.057.253 1.492.483.905.477 1.504 1.284 1.504 2.418 0 .966-.471 1.75-1.172 2.27-.687.511-1.587.77-2.521.77-1.367 0-2.274-.528-2.667-.756a.75.75 0 0 1 .755-1.297c.331.193.953.553 1.912.553.673 0 1.243-.188 1.627-.473.37-.275.566-.635.566-1.067 0-.5-.219-.836-.703-1.091-.538-.284-1.375-.443-2.471-.443a.75.75 0 0 1-.53-1.28l2.643-2.644h-3.421a.75.75 0 0 1-.75-.75ZM7.88 15.215a1.4 1.4 0 0 0-1.446.83.75.75 0 0 1-1.37-.61 2.899 2.899 0 0 1 2.986-1.71c.589.06 1.139.323 1.557.743.434.446.685 1.058.685 1.778 0 1.641-1.254 2.437-2.12 2.986-.538.341-1.18.694-1.495 1.273H9.75a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75c0-1.799 1.337-2.63 2.243-3.21 1.032-.659 1.55-1.031 1.55-1.8 0-.355-.116-.584-.26-.732a1.071 1.071 0 0 0-.652-.298Zm.234-13.121a.75.75 0 0 1 .386.656V9h1.252a.75.75 0 0 1 0 1.5H5.75a.75.75 0 0 1 0-1.5H7V4.103l-.853.533a.749.749 0 1 1-.795-1.272l2-1.25a.749.749 0 0 1 .762-.02Z' }, child: [] }] })(props);
}

export function TbKeyOff(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M10.17 6.159l2.316 -2.316a2.877 2.877 0 0 1 4.069 0l3.602 3.602a2.877 2.877 0 0 1 0 4.069l-2.33 2.33' }, child: [] },
      { tag: 'path', attr: { d: 'M14.931 14.948a2.863 2.863 0 0 1 -1.486 -.79l-.301 -.302l-6.558 6.558a2 2 0 0 1 -1.239 .578l-.175 .008h-1.172a1 1 0 0 1 -.993 -.883l-.007 -.117v-1.172a2 2 0 0 1 .467 -1.284l.119 -.13l.414 -.414h2v-2h2v-2l2.144 -2.144l-.301 -.301a2.863 2.863 0 0 1 -.794 -1.504' }, child: [] },
      { tag: 'path', attr: { d: 'M15 9h.01' }, child: [] },
      { tag: 'path', attr: { d: 'M3 3l18 18' }, child: [] }
    ]
  })(props);
}

export function CgRowFirst(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none' },
    child: [
      {
        tag: 'g',
        attr: { opacity: '0.5' },
        child: [
          { tag: 'path', attr: { d: 'M6 11C5.44772 11 5 11.4477 5 12C5 12.5523 5.44772 13 6 13H14C14.5523 13 15 12.5523 15 12C15 11.4477 14.5523 11 14 11H6Z', fill: 'currentColor' }, child: [] },
          { tag: 'path', attr: { d: 'M6 15C5.44772 15 5 15.4477 5 16C5 16.5523 5.44772 17 6 17H14C14.5523 17 15 16.5523 15 16C15 15.4477 14.5523 15 14 15H6Z', fill: 'currentColor' }, child: [] }
        ]
      },
      { tag: 'path', attr: { d: 'M5 8C5 7.44772 5.44772 7 6 7H18C18.5523 7 19 7.44772 19 8C19 8.55228 18.5523 9 18 9H6C5.44772 9 5 8.55228 5 8Z', fill: 'currentColor' }, child: [] }
    ]
  })(props);
}

export function IoBrowsersOutline(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 512 512' },
    child: [
      { tag: 'rect', attr: { width: '416', height: '384', x: '48', y: '64', fill: 'none', strokeLinejoin: 'round', strokeWidth: '32', rx: '48', ry: '48' }, child: [] },
      { tag: 'path', attr: { d: 'M397.82 64H114.18C77.69 64 48 94.15 48 131.2V176h16c0-16 16-32 32-32h320c16 0 32 16 32 32h16v-44.8c0-37.05-29.69-67.2-66.18-67.2z' }, child: [] }
    ]
  })(props);
}

export function IoServerOutline(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 512 512' },
    child: [
      { tag: 'ellipse', attr: { cx: '256', cy: '128', fill: 'none', strokeLinecap: 'round', strokeMiterlimit: '10', strokeWidth: '32', rx: '192', ry: '80' }, child: [] },
      { tag: 'path', attr: { fill: 'none', strokeLinecap: 'round', strokeMiterlimit: '10', strokeWidth: '32', d: 'M448 214c0 44.18-86 80-192 80S64 258.18 64 214m384 86c0 44.18-86 80-192 80S64 344.18 64 300' }, child: [] },
      { tag: 'path', attr: { fill: 'none', strokeLinecap: 'round', strokeMiterlimit: '10', strokeWidth: '32', d: 'M64 127.24v257.52C64 428.52 150 464 256 464s192-35.48 192-79.24V127.24' }, child: [] }
    ]
  })(props);
}

export function BsBodyText(props) {
  return GenIcon({ tag: 'svg', attr: { fill: 'currentColor', viewBox: '0 0 16 16' }, child: [{ tag: 'path', attr: { fillRule: 'evenodd', d: 'M0 .5A.5.5 0 0 1 .5 0h4a.5.5 0 0 1 0 1h-4A.5.5 0 0 1 0 .5m0 2A.5.5 0 0 1 .5 2h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m9 0a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m-9 2A.5.5 0 0 1 .5 4h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m5 0a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m7 0a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-12 2A.5.5 0 0 1 .5 6h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5m8 0a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m-8 2A.5.5 0 0 1 .5 8h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m7 0a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-7 2a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5' }, child: [] }] })(props);
}

export function LuTextCursorInput(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M5 4h1a3 3 0 0 1 3 3 3 3 0 0 1 3-3h1' }, child: [] },
      { tag: 'path', attr: { d: 'M13 20h-1a3 3 0 0 1-3-3 3 3 0 0 1-3 3H5' }, child: [] },
      { tag: 'path', attr: { d: 'M5 16H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1' }, child: [] },
      { tag: 'path', attr: { d: 'M13 8h7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-7' }, child: [] },
      { tag: 'path', attr: { d: 'M9 7v10' }, child: [] }
    ]
  })(props);
}

export function LiaGreaterThanEqualSolid(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 32 32' }, child: [{ tag: 'path', attr: { d: 'M 6 5 L 6 7.15625 L 22.53125 14 L 6 20.84375 L 6 23 L 26 14.78125 L 26 13.21875 Z M 6 25 L 6 27 L 26 27 L 26 25 Z' }, child: [] }] })(props);
}

export function LiaLessThanEqualSolid(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 32 32' }, child: [{ tag: 'path', attr: { d: 'M 26 5 L 6 13.21875 L 6 14.78125 L 26 23 L 26 20.84375 L 9.46875 14 L 26 7.15625 Z M 6 25 L 6 27 L 26 27 L 26 25 Z' }, child: [] }] })(props);
}

export function MdOutlineInsertPageBreak(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'path', attr: { d: 'M18 20H6v-3H4v3c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-3h-2v3zM6 4h7v5h5v2h2V8l-6-6H6c-1.1 0-2 .9-2 2v7h2V4zM9 13h6v2H9zM17 13h6v2h-6zM1 13h6v2H1z' }, child: [] }
    ]
  })(props);
}

export function PiBracketsCurlyLight(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 256 256', fill: 'currentColor' }, child: [{ tag: 'path', attr: { d: 'M39.91,128a27.68,27.68,0,0,1,9.49,11.13C54,148.62,54,160.51,54,172c0,24.27,1.21,38,26,38a6,6,0,0,1,0,12c-16.88,0-27.81-5.6-33.4-17.13C42,195.38,42,183.49,42,172c0-24.27-1.21-38-26-38a6,6,0,0,1,0-12c24.79,0,26-13.73,26-38,0-11.49,0-23.38,4.6-32.87C52.19,39.6,63.12,34,80,34a6,6,0,0,1,0,12C55.21,46,54,59.73,54,84c0,11.49,0,23.38-4.6,32.87A27.68,27.68,0,0,1,39.91,128ZM240,122c-24.79,0-26-13.73-26-38,0-11.49,0-23.38-4.6-32.87C203.81,39.6,192.88,34,176,34a6,6,0,0,0,0,12c24.79,0,26,13.73,26,38,0,11.49,0,23.38,4.6,32.87A27.68,27.68,0,0,0,216.09,128a27.68,27.68,0,0,0-9.49,11.13C202,148.62,202,160.51,202,172c0,24.27-1.21,38-26,38a6,6,0,0,0,0,12c16.88,0,27.81-5.6,33.4-17.13,4.6-9.49,4.6-21.38,4.6-32.87,0-24.27,1.21-38,26-38a6,6,0,0,0,0-12Z' }, child: [] }] })(props);
}

export function ImPagebreak(props) {
  return GenIcon({ tag: 'svg', attr: { version: '1.1', viewBox: '0 0 16 16' }, child: [{ tag: 'path', attr: { d: 'M4 6v-6h12v6h-1v-5h-10v5zM16 9v7h-12v-7h1v6h10v-6zM8 7h2v1h-2zM5 7h2v1h-2zM11 7h2v1h-2zM14 7h2v1h-2zM0 4.5l3 3-3 3z' }, child: [] }] })(props);
}

export function BiCodeAlt(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24' }, child: [{ tag: 'path', attr: { d: 'm7.375 16.781 1.25-1.562L4.601 12l4.024-3.219-1.25-1.562-5 4a1 1 0 0 0 0 1.562l5 4zm9.25-9.562-1.25 1.562L19.399 12l-4.024 3.219 1.25 1.562 5-4a1 1 0 0 0 0-1.562l-5-4zm-1.649-4.003-4 18-1.953-.434 4-18z' }, child: [] }] })(props);
}

export function HiKey(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 20 20', fill: 'currentColor', 'aria-hidden': 'true' }, child: [{ tag: 'path', attr: { fillRule: 'evenodd', d: 'M18 8a6 6 0 01-7.743 5.743L10 14l-1 1-1 1H6v2H2v-4l4.257-4.257A6 6 0 1118 8zm-6-4a1 1 0 100 2 2 2 0 012 2 1 1 0 102 0 4 4 0 00-4-4z', clipRule: 'evenodd' }, child: [] }] })(props);
}

export function HiOutlineKey(props) {
  return GenIcon({ tag: 'svg', attr: { fill: 'none', viewBox: '0 0 24 24', strokeWidth: '2', stroke: 'currentColor', 'aria-hidden': 'true' }, child: [{ tag: 'path', attr: { strokeLinecap: 'round', strokeLinejoin: 'round', d: 'M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z' }, child: [] }] })(props);
}

export function TbCategory(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M4 4h6v6h-6z' }, child: [] },
      { tag: 'path', attr: { d: 'M14 4h6v6h-6z' }, child: [] },
      { tag: 'path', attr: { d: 'M4 14h6v6h-6z' }, child: [] },
      { tag: 'path', attr: { d: 'M17 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0' }, child: [] }
    ]
  })(props);
}

export function FaReact(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 512 512' }, child: [{ tag: 'path', attr: { d: 'M418.2 177.2c-5.4-1.8-10.8-3.5-16.2-5.1.9-3.7 1.7-7.4 2.5-11.1 12.3-59.6 4.2-107.5-23.1-123.3-26.3-15.1-69.2.6-112.6 38.4-4.3 3.7-8.5 7.6-12.5 11.5-2.7-2.6-5.5-5.2-8.3-7.7-45.5-40.4-91.1-57.4-118.4-41.5-26.2 15.2-34 60.3-23 116.7 1.1 5.6 2.3 11.1 3.7 16.7-6.4 1.8-12.7 3.8-18.6 5.9C38.3 196.2 0 225.4 0 255.6c0 31.2 40.8 62.5 96.3 81.5 4.5 1.5 9 3 13.6 4.3-1.5 6-2.8 11.9-4 18-10.5 55.5-2.3 99.5 23.9 114.6 27 15.6 72.4-.4 116.6-39.1 3.5-3.1 7-6.3 10.5-9.7 4.4 4.3 9 8.4 13.6 12.4 42.8 36.8 85.1 51.7 111.2 36.6 27-15.6 35.8-62.9 24.4-120.5-.9-4.4-1.9-8.9-3-13.5 3.2-.9 6.3-1.9 9.4-2.9 57.7-19.1 99.5-50 99.5-81.7 0-30.3-39.4-59.7-93.8-78.4zM282.9 92.3c37.2-32.4 71.9-45.1 87.7-36 16.9 9.7 23.4 48.9 12.8 100.4-.7 3.4-1.4 6.7-2.3 10-22.2-5-44.7-8.6-67.3-10.6-13-18.6-27.2-36.4-42.6-53.1 3.9-3.7 7.7-7.2 11.7-10.7zM167.2 307.5c5.1 8.7 10.3 17.4 15.8 25.9-15.6-1.7-31.1-4.2-46.4-7.5 4.4-14.4 9.9-29.3 16.3-44.5 4.6 8.8 9.3 17.5 14.3 26.1zm-30.3-120.3c14.4-3.2 29.7-5.8 45.6-7.8-5.3 8.3-10.5 16.8-15.4 25.4-4.9 8.5-9.7 17.2-14.2 26-6.3-14.9-11.6-29.5-16-43.6zm27.4 68.9c6.6-13.8 13.8-27.3 21.4-40.6s15.8-26.2 24.4-38.9c15-1.1 30.3-1.7 45.9-1.7s31 .6 45.9 1.7c8.5 12.6 16.6 25.5 24.3 38.7s14.9 26.7 21.7 40.4c-6.7 13.8-13.9 27.4-21.6 40.8-7.6 13.3-15.7 26.2-24.2 39-14.9 1.1-30.4 1.6-46.1 1.6s-30.9-.5-45.6-1.4c-8.7-12.7-16.9-25.7-24.6-39s-14.8-26.8-21.5-40.6zm180.6 51.2c5.1-8.8 9.9-17.7 14.6-26.7 6.4 14.5 12 29.2 16.9 44.3-15.5 3.5-31.2 6.2-47 8 5.4-8.4 10.5-17 15.5-25.6zm14.4-76.5c-4.7-8.8-9.5-17.6-14.5-26.2-4.9-8.5-10-16.9-15.3-25.2 16.1 2 31.5 4.7 45.9 8-4.6 14.8-10 29.2-16.1 43.4zM256.2 118.3c10.5 11.4 20.4 23.4 29.6 35.8-19.8-.9-39.7-.9-59.5 0 9.8-12.9 19.9-24.9 29.9-35.8zM140.2 57c16.8-9.8 54.1 4.2 93.4 39 2.5 2.2 5 4.6 7.6 7-15.5 16.7-29.8 34.5-42.9 53.1-22.6 2-45 5.5-67.2 10.4-1.3-5.1-2.4-10.3-3.5-15.5-9.4-48.4-3.2-84.9 12.6-94zm-24.5 263.6c-4.2-1.2-8.3-2.5-12.4-3.9-21.3-6.7-45.5-17.3-63-31.2-10.1-7-16.9-17.8-18.8-29.9 0-18.3 31.6-41.7 77.2-57.6 5.7-2 11.5-3.8 17.3-5.5 6.8 21.7 15 43 24.5 63.6-9.6 20.9-17.9 42.5-24.8 64.5zm116.6 98c-16.5 15.1-35.6 27.1-56.4 35.3-11.1 5.3-23.9 5.8-35.3 1.3-15.9-9.2-22.5-44.5-13.5-92 1.1-5.6 2.3-11.2 3.7-16.7 22.4 4.8 45 8.1 67.9 9.8 13.2 18.7 27.7 36.6 43.2 53.4-3.2 3.1-6.4 6.1-9.6 8.9zm24.5-24.3c-10.2-11-20.4-23.2-30.3-36.3 9.6.4 19.5.6 29.5.6 10.3 0 20.4-.2 30.4-.7-9.2 12.7-19.1 24.8-29.6 36.4zm130.7 30c-.9 12.2-6.9 23.6-16.5 31.3-15.9 9.2-49.8-2.8-86.4-34.2-4.2-3.6-8.4-7.5-12.7-11.5 15.3-16.9 29.4-34.8 42.2-53.6 22.9-1.9 45.7-5.4 68.2-10.5 1 4.1 1.9 8.2 2.7 12.2 4.9 21.6 5.7 44.1 2.5 66.3zm18.2-107.5c-2.8.9-5.6 1.8-8.5 2.6-7-21.8-15.6-43.1-25.5-63.8 9.6-20.4 17.7-41.4 24.5-62.9 5.2 1.5 10.2 3.1 15 4.7 46.6 16 79.3 39.8 79.3 58 0 19.6-34.9 44.9-84.8 61.4zm-149.7-15c25.3 0 45.8-20.5 45.8-45.8s-20.5-45.8-45.8-45.8c-25.3 0-45.8 20.5-45.8 45.8s20.5 45.8 45.8 45.8z' }, child: [] }] })(props);
}

export function CgWebsite(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none' },
    child: [
      { tag: 'path', attr: { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M14 7C13.4477 7 13 7.44772 13 8V16C13 16.5523 13.4477 17 14 17H18C18.5523 17 19 16.5523 19 16V8C19 7.44772 18.5523 7 18 7H14ZM17 9H15V15H17V9Z', fill: 'currentColor' }, child: [] },
      { tag: 'path', attr: { d: 'M6 7C5.44772 7 5 7.44772 5 8C5 8.55228 5.44772 9 6 9H10C10.5523 9 11 8.55228 11 8C11 7.44772 10.5523 7 10 7H6Z', fill: 'currentColor' }, child: [] },
      { tag: 'path', attr: { d: 'M6 11C5.44772 11 5 11.4477 5 12C5 12.5523 5.44772 13 6 13H10C10.5523 13 11 12.5523 11 12C11 11.4477 10.5523 11 10 11H6Z', fill: 'currentColor' }, child: [] },
      { tag: 'path', attr: { d: 'M5 16C5 15.4477 5.44772 15 6 15H10C10.5523 15 11 15.4477 11 16C11 16.5523 10.5523 17 10 17H6C5.44772 17 5 16.5523 5 16Z', fill: 'currentColor' }, child: [] },
      { tag: 'path', attr: { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M4 3C2.34315 3 1 4.34315 1 6V18C1 19.6569 2.34315 21 4 21H20C21.6569 21 23 19.6569 23 18V6C23 4.34315 21.6569 3 20 3H4ZM20 5H4C3.44772 5 3 5.44772 3 6V18C3 18.5523 3.44772 19 4 19H20C20.5523 19 21 18.5523 21 18V6C21 5.44772 20.5523 5 20 5Z', fill: 'currentColor' }, child: [] }
    ]
  })(props);
}

export function SiConventionalcommits(props) {
  return GenIcon({ tag: 'svg', attr: { role: 'img', viewBox: '0 0 24 24' }, child: [{ tag: 'path', attr: { d: 'M12 0C5.382 0 0 5.382 0 12s5.382 12 12 12 12-5.382 12-12S18.618 0 12 0zm0 1.6c5.753 0 10.4 4.647 10.4 10.4S17.753 22.4 12 22.4 1.6 17.753 1.6 12 6.247 1.6 12 1.6z' }, child: [] }] })(props);
}

export function AiOutlineIdcard(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 1024 1024' }, child: [{ tag: 'path', attr: { d: 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560zM610.3 476h123.4c1.3 0 2.3-3.6 2.3-8v-48c0-4.4-1-8-2.3-8H610.3c-1.3 0-2.3 3.6-2.3 8v48c0 4.4 1 8 2.3 8zm4.8 144h185.7c3.9 0 7.1-3.6 7.1-8v-48c0-4.4-3.2-8-7.1-8H615.1c-3.9 0-7.1 3.6-7.1 8v48c0 4.4 3.2 8 7.1 8zM224 673h43.9c4.2 0 7.6-3.3 7.9-7.5 3.8-50.5 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H522a8 8 0 0 0 8-8.4c-2.8-53.3-32-99.7-74.6-126.1a111.8 111.8 0 0 0 29.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 0 0-74.6 126.1c-.4 4.6 3.2 8.4 7.8 8.4zm149-262c28.5 0 51.7 23.3 51.7 52s-23.2 52-51.7 52-51.7-23.3-51.7-52 23.2-52 51.7-52z' }, child: [] }] })(props);
}

export function IoArrowUndoSharp(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 512 512' }, child: [{ tag: 'path', attr: { d: 'm464 440-28.12-32.11c-22.48-25.65-43.33-45.45-72.08-58.7-26.61-12.26-60-18.65-104.27-19.84V432L48 252 259.53 72v103.21c72.88 3 127.18 27.08 161.56 71.75C449.56 284 464 335.19 464 399.26z' }, child: [] }] })(props);
}

export function TbVersions(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M10 5m0 2a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2z' }, child: [] },
      { tag: 'path', attr: { d: 'M7 7l0 10' }, child: [] },
      { tag: 'path', attr: { d: 'M4 8l0 8' }, child: [] }
    ]
  })(props);
}

export function FiPause(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'rect', attr: { x: '6', y: '4', width: '4', height: '16' }, child: [] },
      { tag: 'rect', attr: { x: '14', y: '4', width: '4', height: '16' }, child: [] }
    ]
  })(props);
}

export function MdMemory(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'path', attr: { d: 'M15 9H9v6h6V9zm-2 4h-2v-2h2v2zm8-2V9h-2V7c0-1.1-.9-2-2-2h-2V3h-2v2h-2V3H9v2H7c-1.1 0-2 .9-2 2v2H3v2h2v2H3v2h2v2c0 1.1.9 2 2 2h2v2h2v-2h2v2h2v-2h2c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2zm-4 6H7V7h10v10z' }, child: [] }
    ]
  })(props);
}

export function MdSchedule(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'path', attr: { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' }, child: [] },
      { tag: 'path', attr: { d: 'M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z' }, child: [] }
    ]
  })(props);
}

export function HiOutlineStatusOnline(props) {
  return GenIcon({ tag: 'svg', attr: { fill: 'none', viewBox: '0 0 24 24', strokeWidth: '2', stroke: 'currentColor', 'aria-hidden': 'true' }, child: [{ tag: 'path', attr: { strokeLinecap: 'round', strokeLinejoin: 'round', d: 'M5.636 18.364a9 9 0 010-12.728m12.728 0a9 9 0 010 12.728m-9.9-2.829a5 5 0 010-7.07m7.072 0a5 5 0 010 7.07M13 12a1 1 0 11-2 0 1 1 0 012 0z' }, child: [] }] })(props);
}

export function GrConfigure(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24' }, child: [{ tag: 'path', attr: { fill: 'none', strokeWidth: '2', d: 'M16,15 C20.0089021,14.9354541 23,11.9673591 23,8 C23,4.98813056 22.0029673,5.9851632 21,7 C20.0089021,7.97922849 18,10 18,10 L14,6 C14,6 16.0207715,3.99109792 17,3 C18.0148368,1.99703264 18.0148368,1 16,1 C12.0326409,0.999999999 9.05307486,3.99109792 9,8 C9.04154304,8.97626113 9,11 9,11 C7.11486635,12.8970031 4.65923194,15.3526375 3,17 C0.0682492584,19.9436202 4.05637975,23.9317507 7,21 C8.65052042,19.3376102 11.1126942,16.8754364 13,15 C13,15 15.0237389,14.958457 16,15 Z' }, child: [] }] })(props);
}

export function FiTool(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }, child: [{ tag: 'path', attr: { d: 'M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z' }, child: [] }] })(props);
}

export function BiBuildingHouse(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { d: 'M19 2H9c-1.103 0-2 .897-2 2v5.586l-4.707 4.707A1 1 0 0 0 3 16v5a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4c0-1.103-.897-2-2-2zm-8 18H5v-5.586l3-3 3 3V20zm8 0h-6v-4a.999.999 0 0 0 .707-1.707L9 9.586V4h10v16z' }, child: [] },
      { tag: 'path', attr: { d: 'M11 6h2v2h-2zm4 0h2v2h-2zm0 4.031h2V12h-2zM15 14h2v2h-2zm-8 1h2v2H7z' }, child: [] }
    ]
  })(props);
}

export function FiBarChart(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'line', attr: { x1: '12', y1: '20', x2: '12', y2: '10' }, child: [] },
      { tag: 'line', attr: { x1: '18', y1: '20', x2: '18', y2: '4' }, child: [] },
      { tag: 'line', attr: { x1: '6', y1: '20', x2: '6', y2: '16' }, child: [] }
    ]
  })(props);
}

export function FiFolderPlus(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z' }, child: [] },
      { tag: 'line', attr: { x1: '12', y1: '11', x2: '12', y2: '17' }, child: [] },
      { tag: 'line', attr: { x1: '9', y1: '14', x2: '15', y2: '14' }, child: [] }
    ]
  })(props);
}

export function FiTriangle(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }, child: [{ tag: 'path', attr: { d: 'M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z' }, child: [] }] })(props);
}

export function FiChevronLeft(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }, child: [{ tag: 'polyline', attr: { points: '15 18 9 12 15 6' }, child: [] }] })(props);
}

export function MdOutlineToggleOff(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0V0z' }, child: [] },
      { tag: 'path', attr: { d: 'M17 6H7c-3.31 0-6 2.69-6 6s2.69 6 6 6h10c3.31 0 6-2.69 6-6s-2.69-6-6-6zm0 10H7c-2.21 0-4-1.79-4-4s1.79-4 4-4h10c2.21 0 4 1.79 4 4s-1.79 4-4 4zM7 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z' }, child: [] }
    ]
  })(props);
}

export function MdOutlineToggleOn(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
      { tag: 'path', attr: { fill: 'none', d: 'M0 0h24v24H0z' }, child: [] },
      { tag: 'path', attr: { d: 'M17 6H7c-3.31 0-6 2.69-6 6s2.69 6 6 6h10c3.31 0 6-2.69 6-6s-2.69-6-6-6zm0 10H7c-2.21 0-4-1.79-4-4s1.79-4 4-4h10c2.21 0 4 1.79 4 4s-1.79 4-4 4zm0-7c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z' }, child: [] }
    ]
  })(props);
}

export function FiRepeat(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'polyline', attr: { points: '17 1 21 5 17 9' }, child: [] },
      { tag: 'path', attr: { d: 'M3 11V9a4 4 0 0 1 4-4h14' }, child: [] },
      { tag: 'polyline', attr: { points: '7 23 3 19 7 15' }, child: [] },
      { tag: 'path', attr: { d: 'M21 13v2a4 4 0 0 1-4 4H3' }, child: [] }
    ]
  })(props);
}

export function FaAsterisk(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 512 512' }, child: [{ tag: 'path', attr: { d: 'M478.21 334.093L336 256l142.21-78.093c11.795-6.477 15.961-21.384 9.232-33.037l-19.48-33.741c-6.728-11.653-21.72-15.499-33.227-8.523L296 186.718l3.475-162.204C299.763 11.061 288.937 0 275.48 0h-38.96c-13.456 0-24.283 11.061-23.994 24.514L216 186.718 77.265 102.607c-11.506-6.976-26.499-3.13-33.227 8.523l-19.48 33.741c-6.728 11.653-2.562 26.56 9.233 33.037L176 256 33.79 334.093c-11.795 6.477-15.961 21.384-9.232 33.037l19.48 33.741c6.728 11.653 21.721 15.499 33.227 8.523L216 325.282l-3.475 162.204C212.237 500.939 223.064 512 236.52 512h38.961c13.456 0 24.283-11.061 23.995-24.514L296 325.282l138.735 84.111c11.506 6.976 26.499 3.13 33.227-8.523l19.48-33.741c6.728-11.653 2.563-26.559-9.232-33.036z' }, child: [] }] })(props);
}

export function FiActivity(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }, child: [{ tag: 'polyline', attr: { points: '22 12 18 12 15 21 9 3 6 12 2 12' }, child: [] }] })(props);
}

export function FiAnchor(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'circle', attr: { cx: '12', cy: '5', r: '3' }, child: [] },
      { tag: 'line', attr: { x1: '12', y1: '22', x2: '12', y2: '8' }, child: [] },
      { tag: 'path', attr: { d: 'M5 12H2a10 10 0 0 0 20 0h-3' }, child: [] }
    ]
  })(props);
}

export function FiArrowRight(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'line', attr: { x1: '5', y1: '12', x2: '19', y2: '12' }, child: [] },
      { tag: 'polyline', attr: { points: '12 5 19 12 12 19' }, child: [] }
    ]
  })(props);
}

export function RxCounterClockwiseClock(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 15 15', fill: 'none' }, child: [{ tag: 'path', attr: { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M13.15 7.49998C13.15 4.66458 10.9402 1.84998 7.50002 1.84998C4.72167 1.84998 3.34849 3.9064 2.76335 5H4.5C4.77614 5 5 5.22386 5 5.5C5 5.77614 4.77614 6 4.5 6H1.5C1.22386 6 1 5.77614 1 5.5V2.5C1 2.22386 1.22386 2 1.5 2C1.77614 2 2 2.22386 2 2.5V4.31318C2.70453 3.07126 4.33406 0.849976 7.50002 0.849976C11.5628 0.849976 14.15 4.18537 14.15 7.49998C14.15 10.8146 11.5628 14.15 7.50002 14.15C5.55618 14.15 3.93778 13.3808 2.78548 12.2084C2.16852 11.5806 1.68668 10.839 1.35816 10.0407C1.25306 9.78536 1.37488 9.49315 1.63024 9.38806C1.8856 9.28296 2.17781 9.40478 2.2829 9.66014C2.56374 10.3425 2.97495 10.9745 3.4987 11.5074C4.47052 12.4963 5.83496 13.15 7.50002 13.15C10.9402 13.15 13.15 10.3354 13.15 7.49998ZM7.5 4.00001C7.77614 4.00001 8 4.22387 8 4.50001V7.29291L9.85355 9.14646C10.0488 9.34172 10.0488 9.65831 9.85355 9.85357C9.65829 10.0488 9.34171 10.0488 9.14645 9.85357L7.14645 7.85357C7.05268 7.7598 7 7.63262 7 7.50001V4.50001C7 4.22387 7.22386 4.00001 7.5 4.00001Z', fill: 'currentColor' }, child: [] }] })(props);
}

export function TbTransform(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M3 6a3 3 0 1 0 6 0a3 3 0 0 0 -6 0' }, child: [] },
      { tag: 'path', attr: { d: 'M21 11v-3a2 2 0 0 0 -2 -2h-6l3 3m0 -6l-3 3' }, child: [] },
      { tag: 'path', attr: { d: 'M3 13v3a2 2 0 0 0 2 2h6l-3 -3m0 6l3 -3' }, child: [] },
      { tag: 'path', attr: { d: 'M15 18a3 3 0 1 0 6 0a3 3 0 0 0 -6 0' }, child: [] }
    ]
  })(props);
}

export function BiCollapse(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24' }, child: [{ tag: 'path', attr: { d: 'M16.121 6.465 14 4.344V10h5.656l-2.121-2.121 3.172-3.172-1.414-1.414zM4.707 3.293 3.293 4.707l3.172 3.172L4.344 10H10V4.344L7.879 6.465zM19.656 14H14v5.656l2.121-2.121 3.172 3.172 1.414-1.414-3.172-3.172zM6.465 16.121l-3.172 3.172 1.414 1.414 3.172-3.172L10 19.656V14H4.344z' }, child: [] }] })(props);
}

export function BiExpand(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 24 24' }, child: [{ tag: 'path', attr: { d: 'm21 15.344-2.121 2.121-3.172-3.172-1.414 1.414 3.172 3.172L15.344 21H21zM3 8.656l2.121-2.121 3.172 3.172 1.414-1.414-3.172-3.172L8.656 3H3zM21 3h-5.656l2.121 2.121-3.172 3.172 1.414 1.414 3.172-3.172L21 8.656zM3 21h5.656l-2.121-2.121 3.172-3.172-1.414-1.414-3.172 3.172L3 15.344z' }, child: [] }] })(props);
}

export function VscJson(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 16 16', fill: 'currentColor' }, child: [{ tag: 'path', attr: { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M6 2.984V2h-.09c-.313 0-.616.062-.909.185a2.33 2.33 0 0 0-.775.53 2.23 2.23 0 0 0-.493.753v.001a3.542 3.542 0 0 0-.198.83v.002a6.08 6.08 0 0 0-.024.863c.012.29.018.58.018.869 0 .203-.04.393-.117.572v.001a1.504 1.504 0 0 1-.765.787 1.376 1.376 0 0 1-.558.115H2v.984h.09c.195 0 .38.04.556.121l.001.001c.178.078.329.184.455.318l.002.002c.13.13.233.285.307.465l.001.002c.078.18.117.368.117.566 0 .29-.006.58-.018.869-.012.296-.004.585.024.87v.001c.033.283.099.558.197.824v.001c.106.273.271.524.494.753.223.23.482.407.775.53.293.123.596.185.91.185H6v-.984h-.09c-.2 0-.387-.038-.563-.115a1.613 1.613 0 0 1-.457-.32 1.659 1.659 0 0 1-.309-.467c-.074-.18-.11-.37-.11-.573 0-.228.003-.453.011-.672.008-.228.008-.45 0-.665a4.639 4.639 0 0 0-.055-.64 2.682 2.682 0 0 0-.168-.609A2.284 2.284 0 0 0 3.522 8a2.284 2.284 0 0 0 .738-.955c.08-.192.135-.393.168-.602.033-.21.051-.423.055-.64.008-.22.008-.442 0-.666-.008-.224-.012-.45-.012-.678a1.47 1.47 0 0 1 .877-1.354 1.33 1.33 0 0 1 .563-.121H6zm4 10.032V14h.09c.313 0 .616-.062.909-.185.293-.123.552-.3.775-.53.223-.23.388-.48.493-.753v-.001c.1-.266.165-.543.198-.83v-.002c.028-.28.036-.567.024-.863-.012-.29-.018-.58-.018-.869 0-.203.04-.393.117-.572v-.001a1.502 1.502 0 0 1 .765-.787 1.38 1.38 0 0 1 .558-.115H14v-.984h-.09c-.196 0-.381-.04-.557-.121l-.001-.001a1.376 1.376 0 0 1-.455-.318l-.002-.002a1.415 1.415 0 0 1-.307-.465v-.002a1.405 1.405 0 0 1-.118-.566c0-.29.006-.58.018-.869a6.174 6.174 0 0 0-.024-.87v-.001a3.537 3.537 0 0 0-.197-.824v-.001a2.23 2.23 0 0 0-.494-.753 2.331 2.331 0 0 0-.775-.53 2.325 2.325 0 0 0-.91-.185H10v.984h.09c.2 0 .387.038.562.115.174.082.326.188.457.32.127.134.23.29.309.467.074.18.11.37.11.573 0 .228-.003.452-.011.672-.008.228-.008.45 0 .665.004.222.022.435.055.64.033.214.089.416.168.609a2.285 2.285 0 0 0 .738.955 2.285 2.285 0 0 0-.738.955 2.689 2.689 0 0 0-.168.602c-.033.21-.051.423-.055.64a9.15 9.15 0 0 0 0 .666c.008.224.012.45.012.678a1.471 1.471 0 0 1-.877 1.354 1.33 1.33 0 0 1-.563.121H10z' }, child: [] }] })(props);
}

export function RxLapTimer(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 15 15', fill: 'none' }, child: [{ tag: 'path', attr: { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M5.49998 0.5C5.49998 0.223858 5.72383 0 5.99998 0H7.49998H8.99998C9.27612 0 9.49998 0.223858 9.49998 0.5C9.49998 0.776142 9.27612 1 8.99998 1H7.99998V2.11922C9.09832 2.20409 10.119 2.56622 10.992 3.13572C11.0116 3.10851 11.0336 3.08252 11.058 3.05806L12.058 2.05806C12.3021 1.81398 12.6978 1.81398 12.9419 2.05806C13.186 2.30214 13.186 2.69786 12.9419 2.94194L11.967 3.91682C13.1595 5.07925 13.9 6.70314 13.9 8.49998C13.9 12.0346 11.0346 14.9 7.49998 14.9C3.96535 14.9 1.09998 12.0346 1.09998 8.49998C1.09998 5.13361 3.69904 2.3743 6.99998 2.11922V1H5.99998C5.72383 1 5.49998 0.776142 5.49998 0.5ZM2.09998 8.49998C2.09998 5.51764 4.51764 3.09998 7.49998 3.09998C10.4823 3.09998 12.9 5.51764 12.9 8.49998C12.9 11.4823 10.4823 13.9 7.49998 13.9C4.51764 13.9 2.09998 11.4823 2.09998 8.49998ZM7.49998 8.49998V4.09998C5.06992 4.09998 3.09998 6.06992 3.09998 8.49998C3.09998 10.93 5.06992 12.9 7.49998 12.9C8.715 12.9 9.815 12.4075 10.6112 11.6112L7.49998 8.49998Z', fill: 'currentColor' }, child: [] }] })(props);
}

export function FaGlobeAmericas(props) {
  return GenIcon({ tag: 'svg', attr: { viewBox: '0 0 496 512' }, child: [{ tag: 'path', attr: { d: 'M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm82.29 357.6c-3.9 3.88-7.99 7.95-11.31 11.28-2.99 3-5.1 6.7-6.17 10.71-1.51 5.66-2.73 11.38-4.77 16.87l-17.39 46.85c-13.76 3-28 4.69-42.65 4.69v-27.38c1.69-12.62-7.64-36.26-22.63-51.25-6-6-9.37-14.14-9.37-22.63v-32.01c0-11.64-6.27-22.34-16.46-27.97-14.37-7.95-34.81-19.06-48.81-26.11-11.48-5.78-22.1-13.14-31.65-21.75l-.8-.72a114.792 114.792 0 0 1-18.06-20.74c-9.38-13.77-24.66-36.42-34.59-51.14 20.47-45.5 57.36-82.04 103.2-101.89l24.01 12.01C203.48 89.74 216 82.01 216 70.11v-11.3c7.99-1.29 16.12-2.11 24.39-2.42l28.3 28.3c6.25 6.25 6.25 16.38 0 22.63L264 112l-10.34 10.34c-3.12 3.12-3.12 8.19 0 11.31l4.69 4.69c3.12 3.12 3.12 8.19 0 11.31l-8 8a8.008 8.008 0 0 1-5.66 2.34h-8.99c-2.08 0-4.08.81-5.58 2.27l-9.92 9.65a8.008 8.008 0 0 0-1.58 9.31l15.59 31.19c2.66 5.32-1.21 11.58-7.15 11.58h-5.64c-1.93 0-3.79-.7-5.24-1.96l-9.28-8.06a16.017 16.017 0 0 0-15.55-3.1l-31.17 10.39a11.95 11.95 0 0 0-8.17 11.34c0 4.53 2.56 8.66 6.61 10.69l11.08 5.54c9.41 4.71 19.79 7.16 30.31 7.16s22.59 27.29 32 32h66.75c8.49 0 16.62 3.37 22.63 9.37l13.69 13.69a30.503 30.503 0 0 1 8.93 21.57 46.536 46.536 0 0 1-13.72 32.98zM417 274.25c-5.79-1.45-10.84-5-14.15-9.97l-17.98-26.97a23.97 23.97 0 0 1 0-26.62l19.59-29.38c2.32-3.47 5.5-6.29 9.24-8.15l12.98-6.49C440.2 193.59 448 223.87 448 256c0 8.67-.74 17.16-1.82 25.54L417 274.25z' }, child: [] }] })(props);
}

export function TbCircles(props) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    child: [
      { tag: 'path', attr: { d: 'M12 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0' }, child: [] },
      { tag: 'path', attr: { d: 'M6.5 17m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0' }, child: [] },
      { tag: 'path', attr: { d: 'M17.5 17m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0' }, child: [] }
    ]
  })(props);
}
